export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Count: any;
  ISO8601DateTime: any;
  JSON: any;
  Json: any;
  Step: any;
  Upload: any;
};

export enum AccountAutoCollectGroupEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  None = 'none'
}

/** Autogenerated return type of AccountPay */
export type AccountPayPayload = {
  __typename?: 'AccountPayPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  intent?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type Address = {
  __typename?: 'Address';
  /** City name */
  city: Scalars['String'];
  /** Country name */
  country: Scalars['String'];
  /** Flag that indicates that user did not use Google Places API, but a manual address input */
  custom: Scalars['Boolean'];
  /** The formatted address string. */
  display: Array<Scalars['String']>;
  /** Place ID, from Google */
  id: Scalars['ID'];
  location: Location;
  /** [DEPRECATED] The first part of formated address string.Should contains a street name and building number.If the address does not have street here will be value from secondary field. */
  mainText: Scalars['String'];
  /** [DEPRECATED] The second part of formatted address string. Should contains city, zip and country.If the address does not have street this field willbe empty and value will be moved to the main field. */
  secondaryText: Scalars['String'];
  /** Country state name */
  state: Scalars['String'];
  /** Street address */
  streetAddress: Scalars['String'];
  /** ZIP code */
  zip: Scalars['String'];
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  custom?: InputMaybe<Scalars['Boolean']>;
  fixed?: InputMaybe<Scalars['Boolean']>;
  geofenceRadius?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<LocationInput>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AttachOfflinePayment */
export type AttachOfflinePaymentPayload = {
  __typename?: 'AttachOfflinePaymentPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

/** Autogenerated return type of AuthConfirmIdentity */
export type AuthConfirmIdentityPayload = {
  __typename?: 'AuthConfirmIdentityPayload';
  identity?: Maybe<Identity>;
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AuthForgotPassword */
export type AuthForgotPasswordPayload = {
  __typename?: 'AuthForgotPasswordPayload';
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AuthResetPassword */
export type AuthResetPasswordPayload = {
  __typename?: 'AuthResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AuthSignIn */
export type AuthSignInPayload = {
  __typename?: 'AuthSignInPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  driver?: Maybe<Driver>;
  partner?: Maybe<Partner>;
  partnerMember?: Maybe<PartnerMember>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  superAdmin?: Maybe<SuperAdmin>;
  supplier?: Maybe<Supplier>;
  supplierMember?: Maybe<SupplierMember>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<IdentityTypeEnum>;
};

/** Autogenerated return type of AuthSignUp */
export type AuthSignUpPayload = {
  __typename?: 'AuthSignUpPayload';
  partnerId?: Maybe<Scalars['ID']>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AuthValidateResetToken */
export type AuthValidateResetTokenPayload = {
  __typename?: 'AuthValidateResetTokenPayload';
  success: Scalars['Boolean'];
};

export type AvailabilityTimeBlockOff = {
  __typename?: 'AvailabilityTimeBlockOff';
  city?: Maybe<City>;
  date: Scalars['String'];
  from: Scalars['Int'];
  id: Scalars['ID'];
  partner?: Maybe<Partner>;
  plant?: Maybe<Plant>;
  product?: Maybe<ProductCategory>;
  to: Scalars['Int'];
};

export type AvailabilityTimeBlockOffCreateInput = {
  city?: InputMaybe<IdInput>;
  date: Scalars['String'];
  from: Scalars['Int'];
  plant?: InputMaybe<IdInput>;
  product?: InputMaybe<IdInput>;
  to: Scalars['Int'];
};

/** Autogenerated return type of AvailabilityTimeBlockOffCreate */
export type AvailabilityTimeBlockOffCreatePayload = {
  __typename?: 'AvailabilityTimeBlockOffCreatePayload';
  availabilityTimes?: Maybe<Array<AvailabilityTimeBlockOff>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AvailabilityTimeBlockOffDelete */
export type AvailabilityTimeBlockOffDeletePayload = {
  __typename?: 'AvailabilityTimeBlockOffDeletePayload';
  success: Scalars['Boolean'];
};

export type AvailabilityTimeBlockOffList = {
  __typename?: 'AvailabilityTimeBlockOffList';
  count: Scalars['Int'];
  values: Array<AvailabilityTimeBlockOff>;
};

export type AvailabilityTimeBlockOffUpdateInput = {
  city?: InputMaybe<IdInput>;
  date?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  plant?: InputMaybe<IdInput>;
  product?: InputMaybe<IdInput>;
  to?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of AvailabilityTimeBlockOffUpdate */
export type AvailabilityTimeBlockOffUpdatePayload = {
  __typename?: 'AvailabilityTimeBlockOffUpdatePayload';
  availabilityTimes?: Maybe<Array<AvailabilityTimeBlockOff>>;
  success: Scalars['Boolean'];
};

export type AvailabilityTimes = {
  __typename?: 'AvailabilityTimes';
  deliveryWindow: Scalars['Int'];
  openedRules: Array<Scalars['String']>;
  possibleTimes: Array<Scalars['String']>;
  timeStep: Scalars['Int'];
  times: Array<Scalars['String']>;
  timezone: Scalars['String'];
  workingHoursLimits: Array<Scalars['Int']>;
};

export type BankAccountBillingDetails = {
  __typename?: 'BankAccountBillingDetails';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type CardInfoInput = {
  cardholderName?: InputMaybe<Scalars['String']>;
  cvv: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  number: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

export type CareerCandidate = {
  __typename?: 'CareerCandidate';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type CareerCandidateInput = {
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type CareerCandidateRequest = {
  __typename?: 'CareerCandidateRequest';
  attachment: CareerCandidateResume;
  candidate: CareerCandidate;
  id: Scalars['ID'];
  job: CareerJob;
  message?: Maybe<Scalars['String']>;
};

export type CareerCandidateRequestCreateInput = {
  attachment: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type CareerCandidateResume = {
  __typename?: 'CareerCandidateResume';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  source: Scalars['String'];
};

export type CareerJob = {
  __typename?: 'CareerJob';
  additionalInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  direction: Scalars['String'];
  experience?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  requirements: Array<Scalars['String']>;
  responsibilities: Array<Scalars['String']>;
  salary?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type CareerJobList = {
  __typename?: 'CareerJobList';
  count: Scalars['Int'];
  values: Array<CareerJob>;
};

export type Cart = {
  __typename?: 'Cart';
  address?: Maybe<Address>;
  cartItems?: Maybe<Array<CartItem>>;
  contractor?: Maybe<Contractor>;
  flow?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orders: Array<CartOrder>;
  project?: Maybe<Project>;
  timezone?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CartClear */
export type CartClearPayload = {
  __typename?: 'CartClearPayload';
  cart: Cart;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CartCreateOrders */
export type CartCreateOrdersPayload = {
  __typename?: 'CartCreateOrdersPayload';
  orders: Array<Order>;
  success: Scalars['Boolean'];
};

export enum CartFlowEnum {
  AuDelivery = 'au_delivery',
  AuPickup = 'au_pickup',
  Default = 'default'
}

export type CartGroupUpdate = {
  deliveryDetails?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  deliveryWindow?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CartGroupUpdate */
export type CartGroupUpdatePayload = {
  __typename?: 'CartGroupUpdatePayload';
  cart: Cart;
  success: Scalars['Boolean'];
};

export type CartItem = {
  __typename?: 'CartItem';
  cart: Cart;
  deliveryDetails?: Maybe<Scalars['String']>;
  deliveryTime?: Maybe<Scalars['String']>;
  deliveryWindow?: Maybe<Scalars['Int']>;
  group: Scalars['Int'];
  id: Scalars['ID'];
  pickup: Scalars['Boolean'];
  plant?: Maybe<Plant>;
  productTypePrice: ProductTypePrice;
  quantity: Scalars['Float'];
  units?: Maybe<Scalars['String']>;
  virtualPrice?: Maybe<ProductTypeVirtualPrice>;
};

export type CartItemCreate = {
  pickupPlant?: InputMaybe<IdInput>;
  productTypePrice: IdInput;
  quantity: Scalars['Float'];
};

/** Autogenerated return type of CartItemCreate */
export type CartItemCreatePayload = {
  __typename?: 'CartItemCreatePayload';
  cartItem: CartItem;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CartItemRemove */
export type CartItemRemovePayload = {
  __typename?: 'CartItemRemovePayload';
  success: Scalars['Boolean'];
};

export type CartItemUpdate = {
  cleanPickupPlant?: InputMaybe<Scalars['Boolean']>;
  pickupPlant?: InputMaybe<IdInput>;
  quantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of CartItemUpdate */
export type CartItemUpdatePayload = {
  __typename?: 'CartItemUpdatePayload';
  cartItem: CartItem;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CartMerge */
export type CartMergePayload = {
  __typename?: 'CartMergePayload';
  cart: Cart;
  success: Scalars['Boolean'];
};

export type CartOrder = {
  __typename?: 'CartOrder';
  address?: Maybe<Address>;
  components: Array<OrderPrice>;
  deliveryDetails?: Maybe<Scalars['Int']>;
  deliveryItems: Array<Array<OrderDeliveryItem>>;
  deliveryTime: Scalars['String'];
  deliveryWindow: Scalars['Int'];
  pickup: Scalars['Boolean'];
  plant?: Maybe<Plant>;
  totalPrice: Scalars['Float'];
};

export type CartPreparatoryConfig = {
  __typename?: 'CartPreparatoryConfig';
  availabilityTimes: AvailabilityTimes;
  paymentMethods: Array<PaymentMethod>;
  processingFees: Array<OrderPreparatoryConfigFeePrice>;
  totalPricePerSupplier: Array<CartPreparatoryConfigSupplierPrice>;
};


export type CartPreparatoryConfigAvailabilityTimesArgs = {
  days?: InputMaybe<Array<Scalars['String']>>;
  group: Scalars['Int'];
};


export type CartPreparatoryConfigPaymentMethodsArgs = {
  projectType?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Array<Scalars['String']>>;
};

export type CartPreparatoryConfigSupplierPrice = {
  __typename?: 'CartPreparatoryConfigSupplierPrice';
  availableStatus: Scalars['String'];
  distance: Scalars['Float'];
  supplier: Supplier;
  value: Scalars['Float'];
};

/** Autogenerated return type of CartReplaceSupplier */
export type CartReplaceSupplierPayload = {
  __typename?: 'CartReplaceSupplierPayload';
  cart: Cart;
  success: Scalars['Boolean'];
};

export type CartUpdate = {
  address?: InputMaybe<AddressInput>;
  cleanProject?: InputMaybe<Scalars['Boolean']>;
  flow?: InputMaybe<CartFlowEnum>;
  project?: InputMaybe<IdInput>;
};

/** Autogenerated return type of CartUpdate */
export type CartUpdatePayload = {
  __typename?: 'CartUpdatePayload';
  cart: Cart;
  success: Scalars['Boolean'];
};

export type Channel = {
  __typename?: 'Channel';
  archived: Scalars['Boolean'];
  contractor?: Maybe<Contractor>;
  driver?: Maybe<Driver>;
  driverTask?: Maybe<DriverTask>;
  id: Scalars['ID'];
  /** [DEPRECATED] Timestamp of the last message in channel */
  lastMessage?: Maybe<Scalars['String']>;
  /** The last message in channel */
  lastMessageFull?: Maybe<ChannelMessage>;
  order?: Maybe<Order>;
  orderTruck?: Maybe<OrderTruck>;
  partner: Partner;
  project?: Maybe<Project>;
  timezone?: Maybe<Scalars['String']>;
  totalMessages: Scalars['Int'];
  truck?: Maybe<Truck>;
  unreadMessages: Scalars['Int'];
};

export type ChannelList = {
  __typename?: 'ChannelList';
  count: Scalars['Int'];
  values: Array<Channel>;
};

export type ChannelMessage = {
  __typename?: 'ChannelMessage';
  attachments: Array<Resource>;
  author?: Maybe<User>;
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  readAt?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of ChannelMessageCreate */
export type ChannelMessageCreatePayload = {
  __typename?: 'ChannelMessageCreatePayload';
  message?: Maybe<ChannelMessage>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ChannelMessageDelete */
export type ChannelMessageDeletePayload = {
  __typename?: 'ChannelMessageDeletePayload';
  messages?: Maybe<Array<ChannelMessage>>;
  success: Scalars['Boolean'];
};

export type ChannelMessageList = {
  __typename?: 'ChannelMessageList';
  channel: Channel;
  count: Scalars['Int'];
  values: Array<ChannelMessage>;
};

/** Autogenerated return type of ChannelMessageRead */
export type ChannelMessageReadPayload = {
  __typename?: 'ChannelMessageReadPayload';
  success: Scalars['Boolean'];
};

/** City object, describes logical region where locations/products/orders are. */
export type City = {
  __typename?: 'City';
  /** Address object of the city. It usually used to get latitude/longitude. */
  address: Address;
  country: Country;
  countryState: CountryStateInstance;
  id: Scalars['ID'];
  /** The name of city, same as in Google */
  name: Scalars['String'];
  /** Timezone */
  timezone?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CityCreate */
export type CityCreatePayload = {
  __typename?: 'CityCreatePayload';
  city: City;
  success: Scalars['Boolean'];
};

export enum ClientDataStoreScopeEnum {
  Account = 'account',
  User = 'user'
}

export type ClientFeature = {
  __typename?: 'ClientFeature';
  createdAt: Scalars['String'];
  enabled: Scalars['Boolean'];
  feature: Feature;
  id: Scalars['ID'];
  partner?: Maybe<Partner>;
  updatedAt: Scalars['String'];
};

export type CommonMemberUpdateInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  clearAvatar?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<IdInput>>;
  workingTimezone?: InputMaybe<Scalars['String']>;
};

export type Config = {
  __typename?: 'Config';
  currencies: Array<Scalars['String']>;
  industries: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  units: Array<Unit>;
};

export type Contractor = {
  __typename?: 'Contractor';
  account?: Maybe<ContractorAccount>;
  accounts: Array<ContractorAccount>;
  activeStatus?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  companyInfo: ContractorCompanyInfo;
  customField1?: Maybe<Scalars['String']>;
  customField2?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  earnings?: Maybe<Scalars['Int']>;
  exportCode?: Maybe<Scalars['String']>;
  flags: Scalars['JSON'];
  id: Scalars['ID'];
  identities: Array<Identity>;
  info: ContractorInfo;
  label?: Maybe<Scalars['String']>;
  lockedPartner?: Maybe<Partner>;
  /** [DEPRECATED] */
  members: Array<ContractorMember>;
  /** List of contractor's members */
  membersP: ContractorMemberList;
  note?: Maybe<Note>;
  notes?: Maybe<NoteList>;
  orders: Array<Order>;
  ordersP: OrderListExtended;
  owner: ContractorMember;
  paymentsInfo: ContractorPaymentsInfo;
  prettyId: Scalars['String'];
  priceGroups: ContractorPriceGroupList;
  productTypePrices: ProductTypePriceList;
  projects: Array<Project>;
  referees?: Maybe<Array<Contractor>>;
  referralCode?: Maybe<Scalars['String']>;
  savedPartners: Array<Partner>;
  subscription: SubscriptionInstance;
  testMode: Scalars['Boolean'];
  transactions: TransactionList;
  verified: Scalars['Boolean'];
};


export type ContractorMembersPArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContractorNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContractorOrdersPArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type ContractorPriceGroupsArgs = {
  categories?: InputMaybe<Array<IdInput>>;
  cities?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  suppliers?: InputMaybe<Array<IdInput>>;
};


export type ContractorProductTypePricesArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  productTypes?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  suppliers?: InputMaybe<Array<IdInput>>;
};


export type ContractorTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type ContractorAccount = {
  __typename?: 'ContractorAccount';
  allowCreditCard: Scalars['Boolean'];
  allowOffline: Scalars['Boolean'];
  autoCollect: Scalars['Boolean'];
  autoCollectGroup: Scalars['String'];
  balance: Scalars['Float'];
  credit: Scalars['Float'];
  creditExpiredAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  offlineBanks?: Maybe<Array<PartnerAccountBankRequisites>>;
  overdueDays: Scalars['Int'];
  partner: Partner;
  type: Scalars['String'];
  unlimited: Scalars['Boolean'];
  veryOverdueDays: Scalars['Int'];
};

/** Autogenerated return type of ContractorAccountTopUp */
export type ContractorAccountTopUpPayload = {
  __typename?: 'ContractorAccountTopUpPayload';
  account: ContractorAccount;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorAccountUpdate */
export type ContractorAccountUpdatePayload = {
  __typename?: 'ContractorAccountUpdatePayload';
  account: ContractorAccount;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorAddDocument */
export type ContractorAddDocumentPayload = {
  __typename?: 'ContractorAddDocumentPayload';
  success: Scalars['Boolean'];
};

export type ContractorBankAccount = {
  __typename?: 'ContractorBankAccount';
  bankName?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<BankAccountBillingDetails>;
  id?: Maybe<Scalars['ID']>;
  last4?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorBilldRequest */
export type ContractorBilldRequestPayload = {
  __typename?: 'ContractorBilldRequestPayload';
  success: Scalars['Boolean'];
};

export type ContractorCompanyInfo = {
  __typename?: 'ContractorCompanyInfo';
  address?: Maybe<Scalars['String']>;
  addressDetailed?: Maybe<Address>;
  billingAddress?: Maybe<Scalars['String']>;
  billingAddressDetailed?: Maybe<Address>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorConfirmIdentity */
export type ContractorConfirmIdentityPayload = {
  __typename?: 'ContractorConfirmIdentityPayload';
  identity?: Maybe<Identity>;
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorCreate */
export type ContractorCreatePayload = {
  __typename?: 'ContractorCreatePayload';
  contractor?: Maybe<Contractor>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorDisconnect */
export type ContractorDisconnectPayload = {
  __typename?: 'ContractorDisconnectPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorForgotPassword */
export type ContractorForgotPasswordPayload = {
  __typename?: 'ContractorForgotPasswordPayload';
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ContractorIdentityInputData = {
  email?: InputMaybe<IdentityEmailInput>;
  oauth?: InputMaybe<IdentityOauth2Input>;
  phone?: InputMaybe<IdentityPhoneInput>;
};

export type ContractorInfo = {
  __typename?: 'ContractorInfo';
  accountingEmail?: Maybe<Scalars['String']>;
  accountingEmails: Array<Scalars['String']>;
  additional: Scalars['JSON'];
  avatar?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  name?: Maybe<Scalars['String']>;
  onboarded: Scalars['Boolean'];
  type?: Maybe<Scalars['String']>;
};

export type ContractorList = {
  __typename?: 'ContractorList';
  count: Scalars['Int'];
  values: Array<Contractor>;
};

/** Autogenerated return type of ContractorManagerAdd */
export type ContractorManagerAddPayload = {
  __typename?: 'ContractorManagerAddPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorManagerRemove */
export type ContractorManagerRemovePayload = {
  __typename?: 'ContractorManagerRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorManagerResetPassword */
export type ContractorManagerResetPasswordPayload = {
  __typename?: 'ContractorManagerResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorManagerUpdate */
export type ContractorManagerUpdatePayload = {
  __typename?: 'ContractorManagerUpdatePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export type ContractorMember = {
  __typename?: 'ContractorMember';
  contractor: Contractor;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identities: Array<Identity>;
  info: ContractorMemberInfo;
  other: Array<ContractorMember>;
  phone?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  roles?: Maybe<Array<Role>>;
  status?: Maybe<Scalars['String']>;
  statusChangedAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorMemberAdd */
export type ContractorMemberAddPayload = {
  __typename?: 'ContractorMemberAddPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export type ContractorMemberInfo = {
  __typename?: 'ContractorMemberInfo';
  avatar?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ContractorMemberList = {
  __typename?: 'ContractorMemberList';
  count: Scalars['Int'];
  values: Array<ContractorMember>;
};

/** Autogenerated return type of ContractorMemberMakeOwner */
export type ContractorMemberMakeOwnerPayload = {
  __typename?: 'ContractorMemberMakeOwnerPayload';
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorMemberRemove */
export type ContractorMemberRemovePayload = {
  __typename?: 'ContractorMemberRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorMemberResetPassword */
export type ContractorMemberResetPasswordPayload = {
  __typename?: 'ContractorMemberResetPasswordPayload';
  success: Scalars['Boolean'];
};

export type ContractorMemberUpdateInfo = {
  avatar?: InputMaybe<Scalars['String']>;
  avatarFile?: InputMaybe<Scalars['Upload']>;
  clearAvatar?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorMemberUpdate */
export type ContractorMemberUpdatePayload = {
  __typename?: 'ContractorMemberUpdatePayload';
  addedIdentities?: Maybe<Array<Identity>>;
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
  updatedIdentities?: Maybe<Array<Identity>>;
};

/** Autogenerated return type of ContractorMerge */
export type ContractorMergePayload = {
  __typename?: 'ContractorMergePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorNoteUpdate */
export type ContractorNoteUpdatePayload = {
  __typename?: 'ContractorNoteUpdatePayload';
  note?: Maybe<Note>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorPartnerUpdate */
export type ContractorPartnerUpdatePayload = {
  __typename?: 'ContractorPartnerUpdatePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export type ContractorPaymentMethodInput = {
  account?: InputMaybe<IdInput>;
  paymentMethod?: InputMaybe<IdInput>;
  provider: Scalars['String'];
};

export type ContractorPaymentsInfo = {
  __typename?: 'ContractorPaymentsInfo';
  defaultMethod: PaymentMethod;
  paymentMethods: Array<PaymentMethod>;
  /** [DEPRECATED] */
  savedCards: Array<PaymentMethodCard>;
  /** [DEPRECATED] */
  savedCardsNew: Array<PaymentMethod>;
};


export type ContractorPaymentsInfoPaymentMethodsArgs = {
  partner?: InputMaybe<IdInput>;
  provider?: InputMaybe<Array<Scalars['String']>>;
};


export type ContractorPaymentsInfoSavedCardsArgs = {
  provider?: InputMaybe<Scalars['String']>;
};


export type ContractorPaymentsInfoSavedCardsNewArgs = {
  provider?: InputMaybe<Scalars['String']>;
};

export type ContractorPriceGroup = {
  __typename?: 'ContractorPriceGroup';
  category?: Maybe<ProductCategory>;
  city?: Maybe<City>;
  group: Scalars['String'];
  plant?: Maybe<Plant>;
  priority: Scalars['Int'];
  supplier?: Maybe<Supplier>;
};

export type ContractorPriceGroupCreateInput = {
  category?: InputMaybe<IdInput>;
  city?: InputMaybe<IdInput>;
  group: PriceGroupEnum;
  plant?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};

export type ContractorPriceGroupList = {
  __typename?: 'ContractorPriceGroupList';
  count: Scalars['Int'];
  values: Array<ContractorPriceGroup>;
};

/** Autogenerated return type of ContractorResetPassword */
export type ContractorResetPasswordPayload = {
  __typename?: 'ContractorResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorSendPassword */
export type ContractorSendPasswordPayload = {
  __typename?: 'ContractorSendPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ContractorSignIn */
export type ContractorSignInPayload = {
  __typename?: 'ContractorSignInPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorSignUp */
export type ContractorSignUpPayload = {
  __typename?: 'ContractorSignUpPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type ContractorSkidList = {
  __typename?: 'ContractorSkidList';
  count: Scalars['Int'];
  values: Array<SkidContractorListInstance>;
};

export type ContractorSkidUpdateInput = {
  quantity?: InputMaybe<Scalars['Int']>;
  skid: IdInput;
};

/** Autogenerated return type of ContractorSkidUpdate */
export type ContractorSkidUpdatePayload = {
  __typename?: 'ContractorSkidUpdatePayload';
  success: Scalars['Boolean'];
};

export type ContractorSourceInputData = {
  priceRequest?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
  referralWidget?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorSubscriptionRequestTrial */
export type ContractorSubscriptionRequestTrialPayload = {
  __typename?: 'ContractorSubscriptionRequestTrialPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  subscription?: Maybe<SubscriptionInstance>;
  success: Scalars['Boolean'];
};

export type ContractorUpdateCompanyInfoInput = {
  address?: InputMaybe<AddressInput>;
  billingAddress?: InputMaybe<AddressInput>;
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  logoFile?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ContractorUpdateFlags */
export type ContractorUpdateFlagsPayload = {
  __typename?: 'ContractorUpdateFlagsPayload';
  contractor?: Maybe<Contractor>;
  success: Scalars['Boolean'];
};

export type ContractorUpdateInfoInput = {
  accountingEmail?: InputMaybe<Scalars['String']>;
  additional?: InputMaybe<Scalars['JSON']>;
  avatar?: InputMaybe<Scalars['String']>;
  avatarFile?: InputMaybe<Scalars['Upload']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingAddressNew?: InputMaybe<AddressInput>;
  clearAvatar?: InputMaybe<Scalars['Boolean']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddressNew?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companySize?: InputMaybe<Scalars['String']>;
  contractorType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryInput>;
  customField1?: InputMaybe<Scalars['String']>;
  customField2?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['String']>;
  exportCode?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  onboarded?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ContractorUpdate */
export type ContractorUpdatePayload = {
  __typename?: 'ContractorUpdatePayload';
  addedIdentities?: Maybe<Array<Identity>>;
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
  updatedIdentities?: Maybe<Array<Identity>>;
};

export type ContractorUpdatePaymentsInfoInput = {
  addPaymentCard?: InputMaybe<Array<PaymentMethodCardInput>>;
  defaultPaymentMethod?: InputMaybe<ContractorPaymentMethodInput>;
  removePaymentCard?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of ContractorValidateResetToken */
export type ContractorValidateResetTokenPayload = {
  __typename?: 'ContractorValidateResetTokenPayload';
  success: Scalars['Boolean'];
};

/** Country object */
export type Country = {
  __typename?: 'Country';
  /** The international code of country */
  code: Scalars['String'];
  /** The currency used in the country */
  currency: Scalars['String'];
  id: Scalars['ID'];
  /** The name of country, same as in Google */
  name: Scalars['String'];
};

export type CountryInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CountryStateInstance = {
  __typename?: 'CountryStateInstance';
  /** The international code of country state */
  code: Scalars['String'];
  country: Country;
  id: Scalars['ID'];
  /** The name of country state, same as in Google */
  name: Scalars['String'];
};

export type CountryStateList = {
  __typename?: 'CountryStateList';
  count: Scalars['Int'];
  values: Array<CountryStateInstance>;
};

export enum CreditStatusEnum {
  Normal = 'normal',
  Overdue = 'overdue',
  VeryOverdue = 'very_overdue'
}

export type CsvExport = {
  __typename?: 'CsvExport';
  csv?: Maybe<Scalars['String']>;
  job?: Maybe<JobStatus>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  activeContractors: DashboardActiveContractors;
  contractors: DashboardContractors;
  monthlyRevenue: DashboardMonthlyRevenue;
  orders: DashboardOrdersRanges;
  ordersDaily: Array<DashboardOrdersDaily>;
};


export type DashboardMonthlyRevenueArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type DashboardOrdersDailyArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type DashboardActiveContractors = {
  __typename?: 'DashboardActiveContractors';
  last30Days: Scalars['Int'];
  lastMonth: Scalars['Int'];
};

export type DashboardContractors = {
  __typename?: 'DashboardContractors';
  last30Days: Scalars['Int'];
  lastMonth: Scalars['Int'];
  total: Scalars['Int'];
};

export type DashboardMonthlyRevenue = {
  __typename?: 'DashboardMonthlyRevenue';
  currency: Scalars['String'];
  total: Scalars['Float'];
};

export type DashboardOrders = {
  __typename?: 'DashboardOrders';
  active: Scalars['Int'];
  delivered: Scalars['Int'];
  total: Scalars['Int'];
};

export type DashboardOrdersDaily = {
  __typename?: 'DashboardOrdersDaily';
  count: Scalars['Int'];
  date: Scalars['String'];
};

export type DashboardOrdersRanges = {
  __typename?: 'DashboardOrdersRanges';
  last30Days: DashboardOrders;
  lastMonth: DashboardOrders;
  total: DashboardOrders;
};

export enum DeliveryItemStatusEnum {
  Delivered = 'delivered',
  Pending = 'pending',
  Skipped = 'skipped'
}

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  caption?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DeliveryMethodCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
};

/** Autogenerated return type of DeliveryMethodCreate */
export type DeliveryMethodCreatePayload = {
  __typename?: 'DeliveryMethodCreatePayload';
  deliveryMethod?: Maybe<DeliveryMethod>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeliveryMethodDelete */
export type DeliveryMethodDeletePayload = {
  __typename?: 'DeliveryMethodDeletePayload';
  success: Scalars['Boolean'];
};

export type DeliveryMethodList = {
  __typename?: 'DeliveryMethodList';
  count: Scalars['Int'];
  values: Array<DeliveryMethod>;
};

export type DeliveryMethodUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DeliveryMethodUpdate */
export type DeliveryMethodUpdatePayload = {
  __typename?: 'DeliveryMethodUpdatePayload';
  deliveryMethod?: Maybe<DeliveryMethod>;
  success: Scalars['Boolean'];
};

export enum DeliveryStatusEnum {
  Accepted = 'accepted',
  Active = 'active',
  Arrived = 'arrived',
  Completed = 'completed',
  Delivered = 'delivered',
  New = 'new',
  OnsiteJobCompleted = 'onsite_job_completed',
  OnsiteJobStarted = 'onsite_job_started',
  Returning = 'returning',
  Started = 'started'
}

export type DeliveryTransaction = {
  __typename?: 'DeliveryTransaction';
  /** Deprecated. Use status */
  approveStatus: Scalars['String'];
  availableActions: Array<Scalars['String']>;
  createdAt: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  deliveryTransactionItems: Array<DeliveryTransactionItemInstance>;
  document?: Maybe<DeliveryTransactionDocument>;
  driverTask?: Maybe<DriverTask>;
  id: Scalars['ID'];
  possibleFields?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
  statusChangedAt?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type DeliveryTransactionPossibleFieldsArgs = {
  deliveryTransactionDocument?: InputMaybe<IdInput>;
};

/** Autogenerated return type of DeliveryTransactionApprove */
export type DeliveryTransactionApprovePayload = {
  __typename?: 'DeliveryTransactionApprovePayload';
  deliveryTransaction?: Maybe<DeliveryTransaction>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeliveryTransactionConfirm */
export type DeliveryTransactionConfirmPayload = {
  __typename?: 'DeliveryTransactionConfirmPayload';
  deliveryTransaction: DeliveryTransaction;
  success: Scalars['Boolean'];
};

export type DeliveryTransactionCreateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  deliveryTransactionDocument?: InputMaybe<IdInput>;
  deliveryTransactionItems?: InputMaybe<Array<DeliveryTransactionItemTypeInput>>;
  driverTask: IdInput;
  resource?: InputMaybe<ResourceInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DeliveryTransactionCreate */
export type DeliveryTransactionCreatePayload = {
  __typename?: 'DeliveryTransactionCreatePayload';
  deliveryTransaction: DeliveryTransaction;
  success: Scalars['Boolean'];
};

export type DeliveryTransactionDocument = {
  __typename?: 'DeliveryTransactionDocument';
  createdAt: Scalars['String'];
  deliveryTransaction?: Maybe<DeliveryTransaction>;
  id: Scalars['ID'];
  json?: Maybe<Scalars['JSON']>;
  resource: Resource;
  status: Scalars['String'];
};

/** Autogenerated return type of DeliveryTransactionDocumentCreate */
export type DeliveryTransactionDocumentCreatePayload = {
  __typename?: 'DeliveryTransactionDocumentCreatePayload';
  document: DeliveryTransactionDocument;
  success: Scalars['Boolean'];
};

export type DeliveryTransactionItemInstance = {
  __typename?: 'DeliveryTransactionItemInstance';
  deliveryTransaction: DeliveryTransaction;
  productType: ProductType;
  quantity: Scalars['Float'];
  units: Scalars['String'];
};

export type DeliveryTransactionItemTypeInput = {
  productType: IdInput;
  quantity: Scalars['Float'];
};

export type DeliveryTransactionList = {
  __typename?: 'DeliveryTransactionList';
  count: Scalars['Int'];
  values: Array<DeliveryTransaction>;
};

export type DeliveryTransactionPreparatoryConfig = {
  __typename?: 'DeliveryTransactionPreparatoryConfig';
  document?: Maybe<DeliveryTransactionDocument>;
  questionaryConfig?: Maybe<Scalars['JSON']>;
};


export type DeliveryTransactionPreparatoryConfigQuestionaryConfigArgs = {
  document?: InputMaybe<IdInput>;
};

export type DeliveryTransactionUpdateInput = {
  clearDocument?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Scalars['JSON']>;
  deliveryTransactionDocument?: InputMaybe<IdInput>;
  deliveryTransactionItems?: InputMaybe<Array<DeliveryTransactionItemTypeInput>>;
  finalizeDriverTrip?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryTransactionUpdate */
export type DeliveryTransactionUpdatePayload = {
  __typename?: 'DeliveryTransactionUpdatePayload';
  deliveryTransaction?: Maybe<DeliveryTransaction>;
  success: Scalars['Boolean'];
};

export type Driver = {
  __typename?: 'Driver';
  blockOff?: Maybe<Scalars['Boolean']>;
  city?: Maybe<City>;
  color: Scalars['String'];
  driverBlockOffs?: Maybe<Array<DriverBlockOff>>;
  id: Scalars['ID'];
  identities: Array<Identity>;
  info: DriverInfo;
  location?: Maybe<Location>;
  note?: Maybe<Note>;
  notes?: Maybe<NoteList>;
  orders: Array<OrderTruck>;
  partner?: Maybe<Partner>;
  pending: Scalars['Boolean'];
  plants: Array<Plant>;
  prettyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  trucks: Array<Truck>;
  type?: Maybe<Scalars['String']>;
  workingDay?: Maybe<DriverWorkingDay>;
  workingDays: DriverWorkingDayList;
  workingTimezone?: Maybe<Scalars['String']>;
};


export type DriverBlockOffArgs = {
  date: Scalars['String'];
};


export type DriverNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DriverWorkingDaysArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type DriverBlockOff = {
  __typename?: 'DriverBlockOff';
  active: Scalars['Boolean'];
  category?: Maybe<DriverBlockOffEnum>;
  driver: Driver;
  from: Scalars['Int'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DriverBlockOffCreate */
export type DriverBlockOffCreatePayload = {
  __typename?: 'DriverBlockOffCreatePayload';
  driverBlockOff?: Maybe<DriverBlockOff>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverBlockOffDelete */
export type DriverBlockOffDeletePayload = {
  __typename?: 'DriverBlockOffDeletePayload';
  success: Scalars['Boolean'];
};

export enum DriverBlockOffEnum {
  Pto = 'pto',
  SickLeave = 'sick_leave'
}

/** Autogenerated return type of DriverBlockOffUpdate */
export type DriverBlockOffUpdatePayload = {
  __typename?: 'DriverBlockOffUpdatePayload';
  driverBlockOff: DriverBlockOff;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverCompleteDay */
export type DriverCompleteDayPayload = {
  __typename?: 'DriverCompleteDayPayload';
  success: Scalars['Boolean'];
  workingDay: DriverWorkingDay;
};

/** Autogenerated return type of DriverConfirmIdentity */
export type DriverConfirmIdentityPayload = {
  __typename?: 'DriverConfirmIdentityPayload';
  driver?: Maybe<Driver>;
  identity?: Maybe<Identity>;
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverCreate */
export type DriverCreatePayload = {
  __typename?: 'DriverCreatePayload';
  driver?: Maybe<Driver>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverDisconnect */
export type DriverDisconnectPayload = {
  __typename?: 'DriverDisconnectPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverForgotPassword */
export type DriverForgotPasswordPayload = {
  __typename?: 'DriverForgotPasswordPayload';
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DriverIdentityInputData = {
  email?: InputMaybe<IdentityEmailInput>;
  phone?: InputMaybe<IdentityPhoneInput>;
};

export type DriverInfo = {
  __typename?: 'DriverInfo';
  avatar?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type DriverInfoInput = {
  avatar?: InputMaybe<Scalars['String']>;
  avatarFile?: InputMaybe<Scalars['Upload']>;
  city?: InputMaybe<IdInput>;
  clearAvatar?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DriverTypeEnum>;
  workingTimezone?: InputMaybe<Scalars['String']>;
};

export type DriverList = {
  __typename?: 'DriverList';
  count: Scalars['Int'];
  values: Array<Driver>;
};

/** Autogenerated return type of DriverNoteUpdate */
export type DriverNoteUpdatePayload = {
  __typename?: 'DriverNoteUpdatePayload';
  note?: Maybe<Note>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverRemove */
export type DriverRemovePayload = {
  __typename?: 'DriverRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverResetPassword */
export type DriverResetPasswordPayload = {
  __typename?: 'DriverResetPasswordPayload';
  success: Scalars['Boolean'];
};

export type DriverRoute = {
  __typename?: 'DriverRoute';
  active: Scalars['Boolean'];
  driverTask?: Maybe<DriverTask>;
  id: Scalars['ID'];
  route?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  workingDay: DriverWorkingDay;
};

export type DriverRouteList = {
  __typename?: 'DriverRouteList';
  count: Scalars['Int'];
  values: Array<DriverRoute>;
};

/** Autogenerated return type of DriverSetPassword */
export type DriverSetPasswordPayload = {
  __typename?: 'DriverSetPasswordPayload';
  driver?: Maybe<Driver>;
  partnerDriver?: Maybe<PartnerDriver>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverSignIn */
export type DriverSignInPayload = {
  __typename?: 'DriverSignInPayload';
  driver?: Maybe<Driver>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DriverSignUp */
export type DriverSignUpPayload = {
  __typename?: 'DriverSignUpPayload';
  driver?: Maybe<Driver>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DriverStartDay */
export type DriverStartDayPayload = {
  __typename?: 'DriverStartDayPayload';
  success: Scalars['Boolean'];
  workingDay: DriverWorkingDay;
};

export type DriverTask = {
  __typename?: 'DriverTask';
  actualRoute?: Maybe<Scalars['String']>;
  additional?: Maybe<Scalars['JSON']>;
  arrivedAt?: Maybe<Scalars['String']>;
  availableActions: Array<Scalars['String']>;
  availableForExport: Scalars['Boolean'];
  backgroundColor?: Maybe<Scalars['String']>;
  bolNumber?: Maybe<Scalars['String']>;
  caption: Scalars['String'];
  completedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  /** [DEPRECATED] Use completed_at field */
  deliveredAt?: Maybe<Scalars['String']>;
  deliveryTransaction?: Maybe<DeliveryTransaction>;
  description?: Maybe<Scalars['String']>;
  destination?: Maybe<DriverTaskAddress>;
  document?: Maybe<DriverTaskDocument>;
  driver?: Maybe<Driver>;
  driverRoutes: Array<DriverRoute>;
  driverTrip?: Maybe<DriverTrip>;
  estimatedDuration?: Maybe<Scalars['Int']>;
  eta?: Maybe<Scalars['String']>;
  exported?: Maybe<Scalars['Boolean']>;
  heading?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  location?: Maybe<Location>;
  notes: DriverTaskNoteList;
  onsiteJobCompletedAt?: Maybe<Scalars['String']>;
  onsiteJobMetricOnComplete?: Maybe<Scalars['Float']>;
  onsiteJobMetricOnStart?: Maybe<Scalars['Float']>;
  onsiteJobStartedAt?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderTruck?: Maybe<OrderTruck>;
  partner: Partner;
  permissions: Scalars['JSON'];
  pickupDeliveryTransaction?: Maybe<DeliveryTransaction>;
  plannedRoute?: Maybe<Scalars['String']>;
  plannedRouteDuration?: Maybe<Scalars['Int']>;
  plannedRouteVersion?: Maybe<Scalars['Int']>;
  plant?: Maybe<Plant>;
  prettyId: Scalars['String'];
  project?: Maybe<Project>;
  returningAt?: Maybe<Scalars['String']>;
  reusedBolNumber?: Maybe<Scalars['Boolean']>;
  route?: Maybe<Route>;
  routeDetails?: Maybe<Scalars['JSON']>;
  scheduledTime?: Maybe<Scalars['String']>;
  source?: Maybe<DriverTaskAddress>;
  /** Items in a truck before task started */
  startItems: Array<DriverTaskItem>;
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** Items have to be delivered in a task */
  targetItems: Array<DriverTaskItem>;
  /** The time (in min) it takes for a truck to return back */
  timeGapAfter?: Maybe<Scalars['Int']>;
  /** The time (in min) it takes for a truck to get on site */
  timeGapBefore?: Maybe<Scalars['Int']>;
  /** The time (in min) it takes for a truck to do job on site */
  timeGapOnsite?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  truck?: Maybe<Truck>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};


export type DriverTaskAdditionalArgs = {
  reason?: InputMaybe<QuestionaryReasonEnum>;
};


export type DriverTaskNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of DriverTaskAccept */
export type DriverTaskAcceptPayload = {
  __typename?: 'DriverTaskAcceptPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

export type DriverTaskAddress = {
  __typename?: 'DriverTaskAddress';
  address?: Maybe<Address>;
  driverTask?: Maybe<DriverTask>;
  order?: Maybe<Order>;
  plant?: Maybe<Plant>;
  project?: Maybe<Project>;
};

/** Autogenerated return type of DriverTaskArrive */
export type DriverTaskArrivePayload = {
  __typename?: 'DriverTaskArrivePayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

export type DriverTaskBatchUpdateError = {
  __typename?: 'DriverTaskBatchUpdateError';
  error: Scalars['String'];
  id: Scalars['ID'];
};

export type DriverTaskBatchUpdateInput = {
  driverTask: IdInput;
  input: DriverTaskUpdate;
};

/** Autogenerated return type of DriverTaskBatchUpdate */
export type DriverTaskBatchUpdatePayload = {
  __typename?: 'DriverTaskBatchUpdatePayload';
  driverTasks?: Maybe<Array<DriverTask>>;
  errors?: Maybe<Array<DriverTaskBatchUpdateError>>;
  job?: Maybe<JobStatus>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskCancel */
export type DriverTaskCancelPayload = {
  __typename?: 'DriverTaskCancelPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskComplete */
export type DriverTaskCompletePayload = {
  __typename?: 'DriverTaskCompletePayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

export type DriverTaskCreate = {
  address?: InputMaybe<AddressInput>;
  description?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  insertAfter?: InputMaybe<IdInput>;
  insertBefore?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  scheduledTime: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<IdInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DriverTaskCreate */
export type DriverTaskCreatePayload = {
  __typename?: 'DriverTaskCreatePayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskDeleted */
export type DriverTaskDeletedPayload = {
  __typename?: 'DriverTaskDeletedPayload';
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};

export type DriverTaskDocument = {
  __typename?: 'DriverTaskDocument';
  data?: Maybe<Scalars['Json']>;
  driverTask: DriverTask;
  id: Scalars['ID'];
  ocrData?: Maybe<Scalars['Json']>;
  resource: Resource;
  status?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DriverTaskDocumentCreate */
export type DriverTaskDocumentCreatePayload = {
  __typename?: 'DriverTaskDocumentCreatePayload';
  driverTaskDocument?: Maybe<DriverTaskDocument>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskDocumentUpdate */
export type DriverTaskDocumentUpdatePayload = {
  __typename?: 'DriverTaskDocumentUpdatePayload';
  driverTaskDocument?: Maybe<DriverTaskDocument>;
  success: Scalars['Boolean'];
};

export type DriverTaskItem = {
  __typename?: 'DriverTaskItem';
  productType: ProductType;
  quantity: Scalars['Float'];
  units?: Maybe<Scalars['String']>;
};

export type DriverTaskList = {
  __typename?: 'DriverTaskList';
  count: Scalars['Int'];
  values: Array<DriverTask>;
};

export type DriverTaskNote = {
  __typename?: 'DriverTaskNote';
  attachments: Array<Resource>;
  author?: Maybe<User>;
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  readAt?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of DriverTaskNoteAdd */
export type DriverTaskNoteAddPayload = {
  __typename?: 'DriverTaskNoteAddPayload';
  note?: Maybe<DriverTaskNote>;
  success: Scalars['Boolean'];
};

export type DriverTaskNoteList = {
  __typename?: 'DriverTaskNoteList';
  count: Scalars['Int'];
  values: Array<DriverTaskNote>;
};

/** Autogenerated return type of DriverTaskNoteRemove */
export type DriverTaskNoteRemovePayload = {
  __typename?: 'DriverTaskNoteRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskOnSiteJobComplete */
export type DriverTaskOnSiteJobCompletePayload = {
  __typename?: 'DriverTaskOnSiteJobCompletePayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskOnSiteJobStart */
export type DriverTaskOnSiteJobStartPayload = {
  __typename?: 'DriverTaskOnSiteJobStartPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskRemove */
export type DriverTaskRemovePayload = {
  __typename?: 'DriverTaskRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskReturn */
export type DriverTaskReturnPayload = {
  __typename?: 'DriverTaskReturnPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskRevert */
export type DriverTaskRevertPayload = {
  __typename?: 'DriverTaskRevertPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskSetExported */
export type DriverTaskSetExportedPayload = {
  __typename?: 'DriverTaskSetExportedPayload';
  driverTask?: Maybe<DriverTask>;
  driverTasks?: Maybe<Array<DriverTask>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTaskStart */
export type DriverTaskStartPayload = {
  __typename?: 'DriverTaskStartPayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

export enum DriverTaskTypeEnum {
  Custom = 'custom',
  Delivery = 'delivery',
  DropOff = 'drop_off',
  Pickup = 'pickup',
  PreSiteInspection = 'pre_site_inspection',
  Rescale = 'rescale'
}

export type DriverTaskUpdate = {
  address?: InputMaybe<AddressInput>;
  arrivedAt?: InputMaybe<Scalars['String']>;
  autoUpdateTrip?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use completed_at */
  deliveredAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  note?: InputMaybe<Scalars['String']>;
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobMetricOnComplete?: InputMaybe<Scalars['Float']>;
  onsiteJobMetricOnStart?: InputMaybe<Scalars['Float']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  removeDriver?: InputMaybe<Scalars['Boolean']>;
  removeTruck?: InputMaybe<Scalars['Boolean']>;
  returningAt?: InputMaybe<Scalars['String']>;
  scheduledTime?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  timeGapAfter?: InputMaybe<Scalars['Int']>;
  timeGapBefore?: InputMaybe<Scalars['Int']>;
  timeGapOnsite?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<IdInput>;
};

/** Autogenerated return type of DriverTaskUpdate */
export type DriverTaskUpdatePayload = {
  __typename?: 'DriverTaskUpdatePayload';
  driverTask?: Maybe<DriverTask>;
  success: Scalars['Boolean'];
};

export type DriverTrip = {
  __typename?: 'DriverTrip';
  createdAt: Scalars['String'];
  driverTasks: Array<DriverTask>;
  id: Scalars['ID'];
  prettyId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type DriverTripCreate = {
  driver?: InputMaybe<IdInput>;
  driverTasks: Array<IdInput>;
  scheduledTime?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<IdInput>;
};

/** Autogenerated return type of DriverTripCreate */
export type DriverTripCreatePayload = {
  __typename?: 'DriverTripCreatePayload';
  driverTrip?: Maybe<DriverTrip>;
  success: Scalars['Boolean'];
};

export type DriverTripPrepareDriverTask = {
  __typename?: 'DriverTripPrepareDriverTask';
  driverTask: DriverTask;
  scheduledTime: Scalars['String'];
};

export type DriverTripPrepareInputDriverTask = {
  driverTask: IdInput;
  scheduledTime?: InputMaybe<Scalars['String']>;
  timeGapOnsite?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of DriverTripPrepare */
export type DriverTripPreparePayload = {
  __typename?: 'DriverTripPreparePayload';
  driverTasks?: Maybe<Array<DriverTripPrepareDriverTask>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTripRecalculate */
export type DriverTripRecalculatePayload = {
  __typename?: 'DriverTripRecalculatePayload';
  driverTrip?: Maybe<DriverTrip>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverTripRemove */
export type DriverTripRemovePayload = {
  __typename?: 'DriverTripRemovePayload';
  success: Scalars['Boolean'];
};

export type DriverTripUpdate = {
  driver?: InputMaybe<IdInput>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  removeDriver?: InputMaybe<Scalars['Boolean']>;
  removeTruck?: InputMaybe<Scalars['Boolean']>;
  scheduledTime?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<IdInput>;
};

/** Autogenerated return type of DriverTripUpdate */
export type DriverTripUpdatePayload = {
  __typename?: 'DriverTripUpdatePayload';
  driverTrip?: Maybe<DriverTrip>;
  success: Scalars['Boolean'];
};

export enum DriverTruckStatusEnum {
  Accepted = 'accepted',
  Arrived = 'arrived',
  Delivered = 'delivered',
  New = 'new',
  OnsiteJobCompleted = 'onsite_job_completed',
  OnsiteJobStarted = 'onsite_job_started',
  Returning = 'returning',
  Started = 'started'
}

export enum DriverTypeEnum {
  External = 'external',
  Internal = 'internal',
  Other = 'other'
}

/** Autogenerated return type of DriverUpdate */
export type DriverUpdatePayload = {
  __typename?: 'DriverUpdatePayload';
  addedIdentities?: Maybe<Array<Identity>>;
  driver?: Maybe<Driver>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverUpdatePosition */
export type DriverUpdatePositionPayload = {
  __typename?: 'DriverUpdatePositionPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DriverValidateResetToken */
export type DriverValidateResetTokenPayload = {
  __typename?: 'DriverValidateResetTokenPayload';
  success: Scalars['Boolean'];
};

export type DriverWorkingDay = {
  __typename?: 'DriverWorkingDay';
  completedOrderCount: Scalars['Int'];
  day: Scalars['String'];
  driverRoutes: DriverRouteList;
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  timezone: Scalars['String'];
};


export type DriverWorkingDayDriverRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type DriverWorkingDayInput = {
  day?: InputMaybe<Scalars['String']>;
  finishedAt?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  orderTruck?: InputMaybe<IdInput>;
  startedAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type DriverWorkingDayList = {
  __typename?: 'DriverWorkingDayList';
  count: Scalars['Int'];
  values: Array<DriverWorkingDay>;
};

export type ExportFile = {
  __typename?: 'ExportFile';
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ExportPostAction */
export type ExportPostActionPayload = {
  __typename?: 'ExportPostActionPayload';
  job?: Maybe<JobStatus>;
  success: Scalars['Boolean'];
};

export type ExportResult = {
  __typename?: 'ExportResult';
  file?: Maybe<ExportFile>;
  job?: Maybe<JobStatus>;
};

export type FavoriteProductTypes = {
  __typename?: 'FavoriteProductTypes';
  count: Scalars['Int'];
  values: Array<ProductTypeLike>;
};

export type Feature = {
  __typename?: 'Feature';
  clientFeatures: Array<ClientFeature>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FeatureList = {
  __typename?: 'FeatureList';
  count: Scalars['Int'];
  values: Array<Feature>;
};

export type Fee = {
  __typename?: 'Fee';
  /** Flag to show visible status, for dashboard */
  active: Scalars['Boolean'];
  availablePriceContent: Array<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deliveryMethods: Array<DeliveryMethod>;
  deliveryZone?: Maybe<Scalars['String']>;
  details: FeeDetails;
  exportCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkedFee?: Maybe<Fee>;
  linkedFees?: Maybe<Array<Fee>>;
  mergeName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partner?: Maybe<Partner>;
  pickup: Scalars['String'];
  prices?: Maybe<FeePriceList>;
  product?: Maybe<ProductCategory>;
  productTypes: Array<ProductType>;
  productTypesP: ProductTypeList;
  serviceName: Scalars['String'];
  sortOrder: Scalars['Int'];
  target?: Maybe<Scalars['String']>;
  taxable: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  useAfterSubtotal?: Maybe<Scalars['Boolean']>;
  zeroOut?: Maybe<Scalars['Boolean']>;
};


export type FeePricesArgs = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<PricesModeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FeeProductTypesPArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<IdInput>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type FeeCreateInput = {
  amountFrom?: InputMaybe<Scalars['Float']>;
  amountTo?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<OneTimeCodeEnum>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  deliveryMethods?: InputMaybe<Array<IdInput>>;
  deliveryZone?: InputMaybe<Scalars['String']>;
  distanceFrom?: InputMaybe<Scalars['Float']>;
  distanceTo?: InputMaybe<Scalars['Float']>;
  durationFrom?: InputMaybe<Scalars['Float']>;
  durationTo?: InputMaybe<Scalars['Float']>;
  exportCode?: InputMaybe<Scalars['String']>;
  generateCustomTask?: InputMaybe<Scalars['Boolean']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  loadFrom?: InputMaybe<Scalars['Float']>;
  loadTo?: InputMaybe<Scalars['Float']>;
  mergeName?: InputMaybe<Scalars['String']>;
  multiplier?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  partner?: InputMaybe<IdInput>;
  pickup?: InputMaybe<FeePickupEnum>;
  product?: InputMaybe<IdInput>;
  productTypes?: InputMaybe<Array<IdInput>>;
  quantityFrom?: InputMaybe<Scalars['Float']>;
  quantitySequence?: InputMaybe<Scalars['String']>;
  quantityTo?: InputMaybe<Scalars['Float']>;
  rrule?: InputMaybe<Scalars['String']>;
  serviceName: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
  type: FeeTypeEnum;
  useAfterTax?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of FeeCreate */
export type FeeCreatePayload = {
  __typename?: 'FeeCreatePayload';
  fee?: Maybe<Fee>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FeeDelete */
export type FeeDeletePayload = {
  __typename?: 'FeeDeletePayload';
  success: Scalars['Boolean'];
};

export type FeeDetails = {
  __typename?: 'FeeDetails';
  algorithm?: Maybe<Scalars['String']>;
  amountFrom?: Maybe<Scalars['String']>;
  amountTo?: Maybe<Scalars['String']>;
  distanceFrom?: Maybe<Scalars['Float']>;
  distanceTo?: Maybe<Scalars['Float']>;
  durationFrom?: Maybe<Scalars['Float']>;
  durationTo?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  multiplier?: Maybe<Scalars['Float']>;
  provider?: Maybe<Scalars['String']>;
  quantityFrom?: Maybe<Scalars['String']>;
  quantitySequence?: Maybe<Scalars['String']>;
  quantityTo?: Maybe<Scalars['String']>;
  rrule?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  useAfterTax?: Maybe<Scalars['Boolean']>;
};

export type FeeList = {
  __typename?: 'FeeList';
  count: Scalars['Int'];
  values: Array<Fee>;
};

export enum FeePickupEnum {
  Default = 'default',
  Excluded = 'excluded',
  Included = 'included'
}

export type FeePrice = {
  __typename?: 'FeePrice';
  fee: Fee;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  permissions: FeePricePermissions;
  plant?: Maybe<Plant>;
  price: Price;
};

export type FeePriceCreateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  fee: IdInput;
  group?: InputMaybe<PriceGroupEnum>;
  price: PriceInput;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of FeePriceCreate */
export type FeePriceCreatePayload = {
  __typename?: 'FeePriceCreatePayload';
  feePrice?: Maybe<Price>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FeePriceDelete */
export type FeePriceDeletePayload = {
  __typename?: 'FeePriceDeletePayload';
  success: Scalars['Boolean'];
};

export type FeePriceInput = {
  city?: InputMaybe<IdInput>;
  content?: InputMaybe<Scalars['String']>;
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  currency?: InputMaybe<Scalars['String']>;
  fee: IdInput;
  formula?: InputMaybe<IdInput>;
  formulaArguments?: InputMaybe<Scalars['JSON']>;
  group?: InputMaybe<PriceGroupEnum>;
  plant?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FeePriceList = {
  __typename?: 'FeePriceList';
  count: Scalars['Int'];
  values: Array<FeePrice>;
};

export type FeePricePermissions = {
  __typename?: 'FeePricePermissions';
  canDelete: Scalars['Boolean'];
};

export type FeePriceUpdateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  formula?: InputMaybe<IdInput>;
  formulaArguments?: InputMaybe<Scalars['JSON']>;
  group?: InputMaybe<PriceGroupEnum>;
  id: Scalars['ID'];
  price?: InputMaybe<PriceInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of FeePriceUpdate */
export type FeePriceUpdatePayload = {
  __typename?: 'FeePriceUpdatePayload';
  feePrice?: Maybe<FeePrice>;
  success: Scalars['Boolean'];
};

export enum FeeTypeEnum {
  Common = 'common',
  Delivery = 'delivery',
  Discount = 'discount',
  OneTime = 'one_time',
  Seasonal = 'seasonal',
  Tax = 'tax',
  Timebase = 'timebase',
  Timeframe = 'timeframe',
  Underload = 'underload',
  Washout = 'washout'
}

export type FeeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amountFrom?: InputMaybe<Scalars['Float']>;
  amountTo?: InputMaybe<Scalars['Float']>;
  clearProduct?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<OneTimeCodeEnum>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  deliveryMethods?: InputMaybe<Array<IdInput>>;
  deliveryZone?: InputMaybe<Scalars['String']>;
  distanceFrom?: InputMaybe<Scalars['Float']>;
  distanceTo?: InputMaybe<Scalars['Float']>;
  durationFrom?: InputMaybe<Scalars['Float']>;
  durationTo?: InputMaybe<Scalars['Float']>;
  exportCode?: InputMaybe<Scalars['String']>;
  generateCustomTask?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internal?: InputMaybe<Scalars['Boolean']>;
  loadFrom?: InputMaybe<Scalars['Float']>;
  loadTo?: InputMaybe<Scalars['Float']>;
  mergeName?: InputMaybe<Scalars['String']>;
  multiplier?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Float']>;
  partner?: InputMaybe<IdInput>;
  pickup?: InputMaybe<FeePickupEnum>;
  product?: InputMaybe<IdInput>;
  productTypes?: InputMaybe<Array<IdInput>>;
  quantityFrom?: InputMaybe<Scalars['Float']>;
  quantitySequence?: InputMaybe<Scalars['String']>;
  quantityTo?: InputMaybe<Scalars['Float']>;
  rrule?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
  useAfterTax?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of FeeUpdate */
export type FeeUpdatePayload = {
  __typename?: 'FeeUpdatePayload';
  fee?: Maybe<Fee>;
  success: Scalars['Boolean'];
};

export type FinanceAccount = {
  __typename?: 'FinanceAccount';
  id: Scalars['ID'];
  partner: Partner;
  paymentHandling?: Maybe<Scalars['String']>;
  stripeOnboardingProgress?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

export enum FinanceOfflineActionsEnum {
  AutoCollect = 'auto_collect',
  GetPaid = 'get_paid'
}

export enum FinanceOfflineCollectTypesEnum {
  None = 'none',
  Pending = 'pending',
  Reject = 'reject',
  Success = 'success'
}

export enum FinancePeriodEnum {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum FinanceStatusEnum {
  OrderCanceled = 'order_canceled',
  OrderCompleted = 'order_completed',
  OrderInProgress = 'order_in_progress',
  OrderNotPaid = 'order_not_paid',
  OrderOnHold = 'order_on_hold'
}

export type Formula = {
  __typename?: 'Formula';
  id: Scalars['ID'];
  name: Scalars['String'];
  reason: FormulaReasonEnum;
  requiredArguments?: Maybe<Array<Scalars['String']>>;
  value: Scalars['String'];
};

export type FormulaList = {
  __typename?: 'FormulaList';
  count: Scalars['Int'];
  values: Array<Formula>;
};

export enum FormulaReasonEnum {
  ByDistance = 'by_distance',
  BySubtotal = 'by_subtotal',
  ByTravelTime = 'by_travel_time',
  Custom = 'custom',
  IncludedOverageDistance = 'included_overage_distance',
  IncludedOverageLoad = 'included_overage_load',
  MinimumOverageDistance = 'minimum_overage_distance',
  MinimumOverageLoad = 'minimum_overage_load',
  Tiered = 'tiered',
  TieredPerDistance = 'tiered_per_distance',
  TieredPerLoad = 'tiered_per_load'
}

export type FromToInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type GalleryList = {
  __typename?: 'GalleryList';
  count: Scalars['Int'];
  values: Array<OrderImage>;
};

export type GlobalMapList = {
  __typename?: 'GlobalMapList';
  orders: Array<OrderCluster>;
  plants: Array<PlantCluster>;
  trucks: Array<OrderTruckCluster>;
};

/** Autogenerated return type of GroupedPaymentAttachOfflinePayment */
export type GroupedPaymentAttachOfflinePaymentPayload = {
  __typename?: 'GroupedPaymentAttachOfflinePaymentPayload';
  groupedPayment?: Maybe<PaymentLink>;
  success: Scalars['Boolean'];
};

export type GroupedPaymentCreateInput = {
  amount: Scalars['Float'];
  order: IdInput;
};

/** Autogenerated return type of GroupedPaymentCreate */
export type GroupedPaymentCreatePayload = {
  __typename?: 'GroupedPaymentCreatePayload';
  groupedPayment?: Maybe<PaymentLink>;
  success: Scalars['Boolean'];
};

export enum GroupedPaymentTypeEnum {
  Offline = 'offline',
  Online = 'online'
}

export type IdInput = {
  id: Scalars['ID'];
};

export type Identity = {
  __typename?: 'Identity';
  accounting?: Maybe<Scalars['Boolean']>;
  confirmed: Scalars['Boolean'];
  id: Scalars['ID'];
  notify?: Maybe<Scalars['Boolean']>;
  primary?: Maybe<Scalars['Boolean']>;
  provider: Scalars['String'];
  uid: Scalars['String'];
};

export type IdentityAddInput = {
  accounting?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

export type IdentityChangeInput = {
  accounting?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<FromToInput>;
  phone?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

export type IdentityEmailInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type IdentityOauth2Input = {
  provider: OauthProviderEnum;
  token: Scalars['String'];
};

export type IdentityPhoneInput = {
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type IdentityRemoveInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum IdentityTypeEnum {
  Contractor = 'contractor',
  Driver = 'driver',
  Partner = 'partner',
  SuperAdmin = 'super_admin',
  Supplier = 'supplier'
}

export type IdentityUpdateInput = {
  add?: InputMaybe<Array<IdentityAddInput>>;
  change?: InputMaybe<Array<IdentityChangeInput>>;
  remove?: InputMaybe<Array<IdentityRemoveInput>>;
};

/** Autogenerated return type of InternalCandidateRequestCreate */
export type InternalCandidateRequestCreatePayload = {
  __typename?: 'InternalCandidateRequestCreatePayload';
  candidateRequest?: Maybe<CareerCandidateRequest>;
  success: Scalars['Boolean'];
};

export type Inventory = {
  __typename?: 'Inventory';
  id: Scalars['ID'];
  plant: Plant;
  productIngredient?: Maybe<ProductIngredient>;
  productType?: Maybe<ProductType>;
  quantity?: Maybe<Scalars['Float']>;
  quantityMax?: Maybe<Scalars['Float']>;
  quantityPrediction?: Maybe<Scalars['Float']>;
  unlimited: Scalars['Boolean'];
};


export type InventoryQuantityPredictionArgs = {
  date: Scalars['String'];
};

/** Autogenerated return type of InventoryBatchUpdate */
export type InventoryBatchUpdatePayload = {
  __typename?: 'InventoryBatchUpdatePayload';
  inventories: Array<Inventory>;
  success: Scalars['Boolean'];
};

export type InventoryList = {
  __typename?: 'InventoryList';
  count: Scalars['Int'];
  values: Array<Inventory>;
};

export type InventoryRecipe = {
  __typename?: 'InventoryRecipe';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  productIngredient: ProductIngredient;
  productType: ProductType;
  quantity: Scalars['Float'];
};

/** Autogenerated return type of InventoryRecipeBatchUpdate */
export type InventoryRecipeBatchUpdatePayload = {
  __typename?: 'InventoryRecipeBatchUpdatePayload';
  inventoryRecipes: Array<InventoryRecipe>;
  success: Scalars['Boolean'];
};

export type InventoryRecipeList = {
  __typename?: 'InventoryRecipeList';
  count: Scalars['Int'];
  values: Array<InventoryRecipe>;
};

/** Autogenerated return type of InventoryRecipeRemove */
export type InventoryRecipeRemovePayload = {
  __typename?: 'InventoryRecipeRemovePayload';
  success: Scalars['Boolean'];
};

export type InventoryRecipeUpdateInput = {
  productIngredient: IdInput;
  productType: IdInput;
  quantity: Scalars['Float'];
};

/** Autogenerated return type of InventoryRecipeUpdate */
export type InventoryRecipeUpdatePayload = {
  __typename?: 'InventoryRecipeUpdatePayload';
  inventoryRecipe: InventoryRecipe;
  success: Scalars['Boolean'];
};

export type InventoryTransaction = {
  __typename?: 'InventoryTransaction';
  childInventoryTransactions?: Maybe<Array<InventoryTransaction>>;
  createdAt: Scalars['String'];
  deliveryItem?: Maybe<OrderDeliveryItem>;
  driverTask?: Maybe<DriverTask>;
  id: Scalars['ID'];
  inventory?: Maybe<Inventory>;
  inventoryRecipe?: Maybe<InventoryRecipe>;
  orderTruck?: Maybe<OrderTruck>;
  parentInventoryTransaction?: Maybe<InventoryTransaction>;
  quantity: Scalars['Float'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  virtual: Scalars['Boolean'];
};

/** Autogenerated return type of InventoryTransactionActualize */
export type InventoryTransactionActualizePayload = {
  __typename?: 'InventoryTransactionActualizePayload';
  inventoryTransaction: InventoryTransaction;
  success: Scalars['Boolean'];
};

export type InventoryTransactionCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  inventory?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  productIngredient?: InputMaybe<IdInput>;
  quantity: Scalars['Float'];
};

/** Autogenerated return type of InventoryTransactionCreate */
export type InventoryTransactionCreatePayload = {
  __typename?: 'InventoryTransactionCreatePayload';
  inventoryTransaction: InventoryTransaction;
  success: Scalars['Boolean'];
};

export type InventoryTransactionList = {
  __typename?: 'InventoryTransactionList';
  count: Scalars['Int'];
  values: Array<InventoryTransaction>;
};

/** Autogenerated return type of InventoryTransactionRemove */
export type InventoryTransactionRemovePayload = {
  __typename?: 'InventoryTransactionRemovePayload';
  success: Scalars['Boolean'];
};

export type InventoryTransactionUpdateInput = {
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

/** Autogenerated return type of InventoryTransactionUpdate */
export type InventoryTransactionUpdatePayload = {
  __typename?: 'InventoryTransactionUpdatePayload';
  inventoryTransaction: InventoryTransaction;
  success: Scalars['Boolean'];
};

export type InventoryUpdateInput = {
  inventory?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  productIngredient?: InputMaybe<IdInput>;
  quantityMax: Scalars['Float'];
};

/** Autogenerated return type of InventoryUpdate */
export type InventoryUpdatePayload = {
  __typename?: 'InventoryUpdatePayload';
  inventory: Inventory;
  success: Scalars['Boolean'];
};

export type Invite = {
  __typename?: 'Invite';
  contractor?: Maybe<InviteContractorInfo>;
  id: Scalars['ID'];
  partner?: Maybe<InvitePartnerInfo>;
  pending: Scalars['Boolean'];
  redirectTo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  targetContractor?: Maybe<Contractor>;
  targetDriver?: Maybe<Driver>;
  targetMember?: Maybe<Member>;
  type: Scalars['String'];
};

/** Autogenerated return type of InviteConfirm */
export type InviteConfirmPayload = {
  __typename?: 'InviteConfirmPayload';
  success: Scalars['Boolean'];
};

export type InviteContractorInfo = {
  __typename?: 'InviteContractorInfo';
  companyInfo: ContractorCompanyInfo;
  id: Scalars['ID'];
  info: ContractorInfo;
};

export type InvitePartnerInfo = {
  __typename?: 'InvitePartnerInfo';
  address?: Maybe<Address>;
  appAndroidUrl: Scalars['String'];
  appIosUrl: Scalars['String'];
  banner?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  countryState: CountryStateInstance;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hasApp: Scalars['Boolean'];
  id: Scalars['ID'];
  inviteContractorBanner?: Maybe<Scalars['String']>;
  inviteManagerBanner?: Maybe<Scalars['String']>;
  largeLogo?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  qrAppUrl?: Maybe<Scalars['String']>;
  qrDriverUrl?: Maybe<Scalars['String']>;
  shortCaption?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of InviteReject */
export type InviteRejectPayload = {
  __typename?: 'InviteRejectPayload';
  success: Scalars['Boolean'];
};

export type JobStatus = {
  __typename?: 'JobStatus';
  id: Scalars['String'];
  lastUpdate: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  percent?: Maybe<Scalars['Int']>;
  progress?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
};

export type JobStatusList = {
  __typename?: 'JobStatusList';
  count: Scalars['Int'];
  values: Array<JobStatus>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type LocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type MapTruck = {
  __typename?: 'MapTruck';
  actualRoute?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
  driverTask?: Maybe<DriverTask>;
  heading?: Maybe<Scalars['Float']>;
  plannedRoute?: Maybe<Scalars['String']>;
  truck: Truck;
};

export type MeInfo = {
  __typename?: 'MeInfo';
  clientStore?: Maybe<Scalars['JSON']>;
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  driver?: Maybe<Driver>;
  info?: Maybe<User>;
  partner?: Maybe<Partner>;
  partnerMember?: Maybe<PartnerMember>;
  permissions: Scalars['JSON'];
  /** [DEPRECATED] */
  permissionsNew: Scalars['JSON'];
  service?: Maybe<MeService>;
  settings: Scalars['JSON'];
  superAdmin?: Maybe<SuperAdmin>;
  supplier?: Maybe<Supplier>;
  supplierMember?: Maybe<SupplierMember>;
  type?: Maybe<IdentityTypeEnum>;
};


export type MeInfoClientStoreArgs = {
  name?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<ClientDataStoreScopeEnum>;
};

export type MeService = {
  __typename?: 'MeService';
  hubspotToken?: Maybe<Scalars['String']>;
};

export type Member = {
  __typename?: 'Member';
  active: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identities: Array<Identity>;
  identity?: Maybe<Identity>;
  name: Scalars['String'];
  role: Scalars['String'];
};

export type MemberInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountPay: AccountPayPayload;
  authConfirmIdentity: AuthConfirmIdentityPayload;
  authForgotPassword: AuthForgotPasswordPayload;
  authResetPassword: AuthResetPasswordPayload;
  authSignIn: AuthSignInPayload;
  authSignUp: AuthSignUpPayload;
  authValidateResetToken: AuthValidateResetTokenPayload;
  availabilityBlockOffCreate: AvailabilityTimeBlockOffCreatePayload;
  availabilityBlockOffDelete: AvailabilityTimeBlockOffDeletePayload;
  availabilityBlockOffUpdate: AvailabilityTimeBlockOffUpdatePayload;
  cartClear: CartClearPayload;
  cartCreateOrders: CartCreateOrdersPayload;
  cartGroupUpdate: CartGroupUpdatePayload;
  cartItemCreate: CartItemCreatePayload;
  cartItemRemove: CartItemRemovePayload;
  cartItemUpdate: CartItemUpdatePayload;
  cartMerge: CartMergePayload;
  cartReplaceSupplier: CartReplaceSupplierPayload;
  cartUpdate: CartUpdatePayload;
  channelMessageCreate: ChannelMessageCreatePayload;
  channelMessageDelete: ChannelMessageDeletePayload;
  channelMessageRead: ChannelMessageReadPayload;
  cityCreate: CityCreatePayload;
  contractorAccountTopUp: ContractorAccountTopUpPayload;
  contractorAccountUpdate: ContractorAccountUpdatePayload;
  contractorAddDocument: ContractorAddDocumentPayload;
  contractorBilldRequest: ContractorBilldRequestPayload;
  contractorConfirmIdentity: ContractorConfirmIdentityPayload;
  contractorCreate: ContractorCreatePayload;
  contractorDisconnect: ContractorDisconnectPayload;
  contractorForgotPassword: ContractorForgotPasswordPayload;
  /** DEPRECATED */
  contractorManagerAdd: ContractorManagerAddPayload;
  /** DEPRECATED */
  contractorManagerRemove: ContractorManagerRemovePayload;
  /** DEPRECATED */
  contractorManagerResetPassword: ContractorManagerResetPasswordPayload;
  /** DEPRECATED */
  contractorManagerUpdate: ContractorManagerUpdatePayload;
  contractorMemberAdd: ContractorMemberAddPayload;
  contractorMemberMakeOwner: ContractorMemberMakeOwnerPayload;
  contractorMemberRemove: ContractorMemberRemovePayload;
  contractorMemberResetPassword: ContractorMemberResetPasswordPayload;
  contractorMemberUpdate: ContractorMemberUpdatePayload;
  contractorMerge: ContractorMergePayload;
  contractorNoteUpdate: ContractorNoteUpdatePayload;
  contractorPartnerUpdate: ContractorPartnerUpdatePayload;
  contractorResetPassword: ContractorResetPasswordPayload;
  contractorSendPassword: ContractorSendPasswordPayload;
  contractorSignIn: ContractorSignInPayload;
  contractorSignUp: ContractorSignUpPayload;
  contractorSkidUpdate: ContractorSkidUpdatePayload;
  contractorSubscriptionRequestTrial: ContractorSubscriptionRequestTrialPayload;
  contractorUpdate: ContractorUpdatePayload;
  contractorUpdateFlags: ContractorUpdateFlagsPayload;
  contractorValidateResetToken: ContractorValidateResetTokenPayload;
  createDriverTaskDocument: DriverTaskDocumentCreatePayload;
  deliveryMethodCreate: DeliveryMethodCreatePayload;
  deliveryMethodDelete: DeliveryMethodDeletePayload;
  deliveryMethodUpdate: DeliveryMethodUpdatePayload;
  deliveryTransactionApprove: DeliveryTransactionApprovePayload;
  deliveryTransactionConfirm: DeliveryTransactionConfirmPayload;
  deliveryTransactionCreate: DeliveryTransactionCreatePayload;
  deliveryTransactionDocumentCreate: DeliveryTransactionDocumentCreatePayload;
  deliveryTransactionUpdate: DeliveryTransactionUpdatePayload;
  driverCompleteDay: DriverCompleteDayPayload;
  driverConfirmIdentity: DriverConfirmIdentityPayload;
  driverCreate: DriverCreatePayload;
  driverCreateBlockOff: DriverBlockOffCreatePayload;
  driverDeleteBlockOff: DriverBlockOffDeletePayload;
  driverDisconnect: DriverDisconnectPayload;
  driverForgotPassword: DriverForgotPasswordPayload;
  driverNoteUpdate: DriverNoteUpdatePayload;
  driverRemove: DriverRemovePayload;
  driverResetPassword: DriverResetPasswordPayload;
  driverSetPassword: DriverSetPasswordPayload;
  driverSignIn: DriverSignInPayload;
  driverSignUp: DriverSignUpPayload;
  driverStartDay: DriverStartDayPayload;
  driverTaskAccept: DriverTaskAcceptPayload;
  driverTaskArrive: DriverTaskArrivePayload;
  driverTaskBatchUpdate: DriverTaskBatchUpdatePayload;
  driverTaskCancel: DriverTaskCancelPayload;
  driverTaskComplete: DriverTaskCompletePayload;
  driverTaskCreate: DriverTaskCreatePayload;
  driverTaskNoteAdd: DriverTaskNoteAddPayload;
  driverTaskNoteRemove: DriverTaskNoteRemovePayload;
  driverTaskOnSiteJobComplete: DriverTaskOnSiteJobCompletePayload;
  driverTaskOnSiteJobStart: DriverTaskOnSiteJobStartPayload;
  driverTaskRemove: DriverTaskRemovePayload;
  driverTaskReturn: DriverTaskReturnPayload;
  driverTaskRevert: DriverTaskRevertPayload;
  driverTaskSetExported: DriverTaskSetExportedPayload;
  driverTaskStart: DriverTaskStartPayload;
  driverTaskUpdate: DriverTaskUpdatePayload;
  driverTripCreate: DriverTripCreatePayload;
  driverTripPrepare: DriverTripPreparePayload;
  driverTripRecalculate: DriverTripRecalculatePayload;
  driverTripRemove: DriverTripRemovePayload;
  driverTripUpdate: DriverTripUpdatePayload;
  driverUpdate: DriverUpdatePayload;
  driverUpdateBlockOff: DriverBlockOffUpdatePayload;
  driverUpdatePosition: DriverUpdatePositionPayload;
  driverValidateResetToken: DriverValidateResetTokenPayload;
  exportPostAction: ExportPostActionPayload;
  feeCreate: FeeCreatePayload;
  feeDelete: FeeDeletePayload;
  feePriceCreate: FeePriceCreatePayload;
  feePriceDelete: FeePriceDeletePayload;
  feePriceUpdate: FeePriceUpdatePayload;
  feeUpdate: FeeUpdatePayload;
  financeSetExported: PartnerFinanceSetExportedPayload;
  financeSetInvoiced: PartnerFinanceSetInvoicedPayload;
  financeSetPaid: PartnerFinanceSetPaidPayload;
  financeSetPaidOrCollect: PartnerFinanceSetPaidOrCollectPayload;
  groupedPaymentAttachOfflinePayment: GroupedPaymentAttachOfflinePaymentPayload;
  groupedPaymentCreate: GroupedPaymentCreatePayload;
  internalCandidateRequestCreate: InternalCandidateRequestCreatePayload;
  inventoryBatchUpdate: InventoryBatchUpdatePayload;
  inventoryRecipeBatchUpdate: InventoryRecipeBatchUpdatePayload;
  inventoryRecipeRemove: InventoryRecipeRemovePayload;
  inventoryRecipeUpdate: InventoryRecipeUpdatePayload;
  inventoryTransactionActualize: InventoryTransactionActualizePayload;
  inventoryTransactionCreate: InventoryTransactionCreatePayload;
  inventoryTransactionRemove: InventoryTransactionRemovePayload;
  inventoryTransactionUpdate: InventoryTransactionUpdatePayload;
  inventoryUpdate: InventoryUpdatePayload;
  inviteConfirm: InviteConfirmPayload;
  inviteReject: InviteRejectPayload;
  optionCreate: OptionCreatePayload;
  optionDelete: OptionDeletePayload;
  optionPriceCreate: OptionPriceCreatePayload;
  optionPriceDelete: OptionPriceDeletePayload;
  optionPriceUpdate: OptionPriceUpdatePayload;
  optionUpdate: OptionUpdatePayload;
  orderAcceptQuote: OrderAcceptQuotePayload;
  orderAddPaymentMethod: OrderAddPaymentMethodPayload;
  orderAlertClose: OrderAlertClosePayload;
  orderArchiveChange: OrderArchiveChangePayload;
  orderAskForPayment: OrderAskForPaymentPayload;
  orderAskToConfirm: OrderAskToConfirmPayload;
  orderAttachOfflinePayment: AttachOfflinePaymentPayload;
  orderBatchApplyFeePrices: OrderBatchApplyFeePricesPayload;
  orderBook: OrderBookPayload;
  orderCancel: OrderCancelPayload;
  orderChangeContractor: OrderChangeContractorPayload;
  orderChargeManually: OrderChargeManuallyPayload;
  orderClone: OrderClonePayload;
  orderComplete: OrderCompletePayload;
  orderConfirm: OrderConfirmPayload;
  orderCreate: OrderCreatePayload;
  orderDeliveringDone: OrderDeliveringDonePayload;
  orderDeliveringStarted: OrderDeliveringStartedPayload;
  /** DEPRECATED */
  orderDriverNoteAdd: OrderDriverNoteAddPayload;
  /** DEPRECATED */
  orderDriverNoteRemove: OrderDriverNoteRemovePayload;
  /** DEPRECATED */
  orderDriverNoteUpdate: OrderDriverNoteUpdatePayload;
  orderGenerateDeliverySlip: OrderGenerateDeliverySlipPayload;
  orderGenerateInvoice: OrderGenerateInvoicePayload;
  orderHold: OrderHoldPayload;
  orderImageAdd: OrderImageAddPayload;
  orderImageRemove: OrderImageRemovePayload;
  orderLive: OrderLivePayload;
  orderMessageCreate: OrderMessageCreatePayload;
  orderMessageRead: OrderMessageReadPayload;
  orderNoteUpdate: OrderNoteUpdatePayload;
  orderPay: OrderPayPayload;
  orderPendingComplete: OrderPendingCompletePayload;
  orderPickupDone: OrderPickupDonePayload;
  orderPickupStarted: OrderPickupStartedPayload;
  orderRate: OrderRatePayload;
  orderReadChange: OrderReadChangePayload;
  orderReadyToPickup: OrderReadyToPickupPayload;
  orderRefreshQuote: OrderRefreshQuotePayload;
  orderRefundToCreditMemo: OrderCreditMemoRefundPayload;
  orderReject: OrderRejectPayload;
  orderRelease: OrderReleasePayload;
  orderRemove: OrderRemovePayload;
  orderRemovePaymentMethod: OrderRemovePaymentMethodPayload;
  orderResourceAdd: OrderResourceAddPayload;
  orderResourceRemove: OrderResourceRemovePayload;
  orderRestore: OrderRestorePayload;
  orderSendInvoice: OrderSendInvoicePayload;
  orderSendNotification: OrderSendNotificationPayload;
  orderSwap: OrderSwapPayload;
  orderTaxZeroOut: OrderTaxZeroOutPayload;
  orderTransactionCancel: OrderTransactionCancelPayload;
  orderTransactionCapture: OrderTransactionCapturePayload;
  orderTruckArrive: OrderTruckArrivePayload;
  orderTruckBatchUpdate: OrderTruckBatchUpdatePayload;
  orderTruckCancel: OrderTruckCancelPayload;
  orderTruckComplete: OrderTruckCompletePayload;
  /** Update delivery list to order truck */
  orderTruckDeliveryListUpdate: OrderTruckDeliveryListUpdatePayload;
  orderTruckNoteAdd: OrderTruckNoteAddPayload;
  orderTruckNoteRemove: OrderTruckNoteRemovePayload;
  orderTruckOnSiteJobComplete: OrderTruckOnSiteJobCompletePayload;
  orderTruckOnSiteJobStart: OrderTruckOnSiteJobStartPayload;
  orderTruckOptionAccept: OrderTruckOptionAcceptPayload;
  orderTruckOptionReject: OrderTruckOptionRejectPayload;
  /** Add pin drop to order truck */
  orderTruckPinDropAdd: OrderTruckPinDropAddPayload;
  orderTruckReturn: OrderTruckReturnPayload;
  orderTruckRevert: OrderTruckRevertPayload;
  /** Add signature to order truck */
  orderTruckSignatureAdd: OrderTruckSignatureAddPayload;
  orderTruckStart: OrderTruckStartPayload;
  orderTruckUpdate: OrderTruckUpdatePayload;
  orderUpdate: OrderUpdatePayload;
  orderUpdateAdditionalInfo: OrderUpdateAdditionalInfoPayload;
  orderUpdateFlags: OrderUpdateFlagsPayload;
  orderValidate: OrderValidatePayload;
  orderWaitingForPickup: OrderWaitingForPickupPayload;
  partnerAccountPayout: PartnerAccountPayoutPayload;
  partnerAccountRequestPayout: PartnerAccountRequestPayoutPayload;
  partnerAccountStripeOnboarding: PartnerAccountStripeOnboardingPayload;
  partnerContractorAccept: PartnerContractorAcceptPayload;
  partnerContractorAccountRequest: PartnerContractorAccountRequestPayload;
  partnerContractorBilldRequest: PartnerContractorBilldRequestPayload;
  partnerContractorCancel: PartnerContractorCancelPayload;
  partnerContractorConnect: PartnerContractorConnectPayload;
  partnerContractorDeletePrices: PartnerContractorDeletePricesPayload;
  partnerContractorInvite: PartnerContractorInvitePayload;
  partnerContractorInviteResend: PartnerContractorInviteResendPayload;
  partnerContractorPriceAdded: PartnerContractorPriceAddedPayload;
  partnerContractorPriceRequest: PartnerContractorPriceRequestPayload;
  partnerContractorQuoteRequest: PartnerContractorQuoteRequestPayload;
  partnerContractorReject: PartnerContractorRejectPayload;
  partnerContractorUpdate: PartnerContractorUpdatePayload;
  partnerCreate: PartnerCreatePayload;
  partnerDriverInvite: PartnerDriverInvitePayload;
  partnerMemberCreate: PartnerMemberCreatePayload;
  partnerMemberRemove: PartnerMemberRemovePayload;
  partnerMemberResetPassword: PartnerMemberResetPasswordPayload;
  partnerMemberUpdate: PartnerMemberUpdatePayload;
  partnerSubscriptionUpdate: PartnerSubscriptionUpdatePayload;
  partnerTaxCreate: PartnerTaxCreatePayload;
  partnerTaxRemove: PartnerTaxRemovePayload;
  partnerTaxToggleAvalara: PartnerTaxToggleAvalaraPayload;
  partnerTaxUpdate: PartnerTaxUpdatePayload;
  partnerTaxZeroOut: PartnerTaxZeroOutPayload;
  partnerUpdate: PartnerUpdatePayload;
  paymentCreate: PaymentCreatePayload;
  paymentLinkCancel: PaymentLinkCancelPayload;
  paymentLinkCreate: PaymentLinkCreatePayload;
  paymentLinkPay: PaymentLinkPayPayload;
  paymentLinkSend: PaymentLinkSendPayload;
  paymentMethodPrepare: PaymentMethodPreparePayload;
  paymentMethodSave: PaymentMethodSavePayload;
  paymentPrepareCard: PaymentPrepareCardPayload;
  plantCreate: PlantCreatePayload;
  plantDeliveryMethodRemove: PlantDeliveryMethodRemovePayload;
  plantProductCreate: PlantProductCreatePayload;
  plantProductDelete: PlantProductDeletePayload;
  plantProductUpdate: PlantProductUpdatePayload;
  plantRemove: PlantRemovePayload;
  plantUpdate: PlantUpdatePayload;
  plantUpdateOptions: PlantUpdateOptionsPayload;
  plantUpdateProductDecorates: PlantUpdateProductDecoratesPayload;
  plantUpdateProductTypes: PlantUpdateProductTypesPayload;
  productCategoryBatchUpdate: ProductCategoryBatchUpdatePayload;
  productCategoryCreate: ProductCategoryCreatePayload;
  productCategoryDelete: ProductCategoryDeletePayload;
  productCategoryUpdate: ProductCategoryUpdatePayload;
  productDecorateBatchUpdate: ProductDecorateBatchUpdatePayload;
  productDecorateCreate: ProductDecorateCreatePayload;
  productDecoratePriceCreate: ProductDecoratePriceCreatePayload;
  productDecoratePriceUpdate: ProductDecoratePriceUpdatePayload;
  productDecorateUpdate: ProductDecorateUpdatePayload;
  productDependenciesRemove: ProductDependenciesRemovePayload;
  productIngredientCreate: ProductIngredientCreatePayload;
  productIngredientRemove: ProductIngredientRemovePayload;
  productIngredientUpdate: ProductIngredientUpdatePayload;
  productTypeBatchUpdate: ProductTypeBatchUpdatePayload;
  productTypeCreate: ProductTypeCreatePayload;
  productTypeCreateCustom: ProductTypeCreateCustomPayload;
  productTypeDelete: ProductTypeDeletePayload;
  productTypeLike: ProductTypeLikePayload;
  productTypePriceCreate: ProductTypePriceCreatePayload;
  productTypePriceDelete: ProductTypePriceDeletePayload;
  productTypePriceUpdate: ProductTypePriceUpdatePayload;
  productTypeUnlike: ProductTypeUnlikePayload;
  productTypeUpdate: ProductTypeUpdatePayload;
  projectClone: ProjectClonePayload;
  projectComplete: ProjectCompletePayload;
  projectCreate: ProjectCreatePayload;
  projectImageAdd: ProjectImageAddPayload;
  projectImageRemove: ProjectImageRemovePayload;
  projectNoteAdd: ProjectNoteAddPayload;
  projectNoteRemove: ProjectNoteRemovePayload;
  /** DEPRECATED */
  projectNoteUpdate: ProjectNoteUpdatePayload;
  projectPricesUpdate: ProjectPricesUpdatePayload;
  projectQuoteAccept: ProjectQuoteAcceptPayload;
  projectQuoteRequest: ProjectQuoteRequestPayload;
  projectRemove: ProjectRemovePayload;
  projectResourceAdd: ProjectResourceAddPayload;
  projectResourceRemove: ProjectResourceRemovePayload;
  projectStart: ProjectStartPayload;
  projectUpdate: ProjectUpdatePayload;
  projectUpdatePriceGroups: ProjectUpdatePriceGroupsPayload;
  questionaryAnswerSave: QuestionaryAnswerSavePayload;
  resourceTransform: ResourceTransformPayload;
  serviceRequestInfo: ServiceRequestInfoPayload;
  skidTransactionDelete: SkidTransactionDeletePayload;
  supplierCreate: SupplierCreatePayload;
  supplierMemberCreate: SupplierMemberCreatePayload;
  supplierMemberRemove: SupplierMemberRemovePayload;
  supplierMemberResetPassword: SupplierMemberResetPasswordPayload;
  supplierMemberUpdate: SupplierMemberUpdatePayload;
  supplierUpdate: SupplierUpdatePayload;
  transactionSetExported: TransactionSetExportedPayload;
  /** DEPRECATED */
  truckAccept: TruckAcceptPayload;
  /** DEPRECATED */
  truckArrive: TruckArrivePayload;
  /** DEPRECATED */
  truckCancel: TruckCancelPayload;
  /** DEPRECATED */
  truckComplete: TruckCompletePayload;
  truckCreate: TruckCreatePayload;
  truckCreateBlockOff: TruckBlockOffCreatePayload;
  truckDeleteBlockOff: TruckBlockOffDeletePayload;
  truckNoteUpdate: TruckNoteUpdatePayload;
  truckRemove: TruckRemovePayload;
  /** DEPRECATED */
  truckReturn: TruckReturnPayload;
  /** DEPRECATED */
  truckRevert: TruckRevertPayload;
  /** DEPRECATED */
  truckStart: TruckStartPayload;
  truckUpdate: TruckUpdatePayload;
  truckUpdateBlockOff: TruckBlockOffUpdatePayload;
  updateDriverTaskDocument: DriverTaskDocumentUpdatePayload;
  userClientStoreSet: UserClientStoreSetPayload;
  widgetCreate: WidgetCreatePayload;
  widgetDelete: WidgetDeletePayload;
  widgetUpdate: WidgetUpdatePayload;
  workingDayUpdate: WorkingDayUpdatePayload;
};


export type MutationAccountPayArgs = {
  payment: PaymentInput;
};


export type MutationAuthConfirmIdentityArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  type: IdentityTypeEnum;
};


export type MutationAuthForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type: IdentityTypeEnum;
};


export type MutationAuthResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  resetToken: Scalars['String'];
  type: IdentityTypeEnum;
};


export type MutationAuthSignInArgs = {
  email?: InputMaybe<IdentityEmailInput>;
  oauth?: InputMaybe<IdentityOauth2Input>;
  partner?: InputMaybe<IdInput>;
  phone?: InputMaybe<IdentityPhoneInput>;
  type: IdentityTypeEnum;
};


export type MutationAuthSignUpArgs = {
  email: IdentityEmailInput;
};


export type MutationAuthValidateResetTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  resetToken: Scalars['String'];
  type: IdentityTypeEnum;
};


export type MutationAvailabilityBlockOffCreateArgs = {
  input: Array<AvailabilityTimeBlockOffCreateInput>;
};


export type MutationAvailabilityBlockOffDeleteArgs = {
  input: Array<IdInput>;
};


export type MutationAvailabilityBlockOffUpdateArgs = {
  advanced?: InputMaybe<Scalars['Boolean']>;
  input: Array<AvailabilityTimeBlockOffUpdateInput>;
};


export type MutationCartClearArgs = {
  cart?: InputMaybe<IdInput>;
};


export type MutationCartCreateOrdersArgs = {
  cart?: InputMaybe<IdInput>;
  deliveryDetails?: InputMaybe<Array<Scalars['String']>>;
  paymentMethod?: InputMaybe<IdInput>;
  projectType?: InputMaybe<Scalars['String']>;
};


export type MutationCartGroupUpdateArgs = {
  cart?: InputMaybe<IdInput>;
  group?: InputMaybe<Scalars['Int']>;
  input: CartGroupUpdate;
};


export type MutationCartItemCreateArgs = {
  cart?: InputMaybe<IdInput>;
  input: CartItemCreate;
};


export type MutationCartItemRemoveArgs = {
  cartItem: IdInput;
};


export type MutationCartItemUpdateArgs = {
  cartItem: IdInput;
  input: CartItemUpdate;
};


export type MutationCartMergeArgs = {
  cart: IdInput;
};


export type MutationCartReplaceSupplierArgs = {
  cart?: InputMaybe<IdInput>;
  supplier: IdInput;
};


export type MutationCartUpdateArgs = {
  cart?: InputMaybe<IdInput>;
  input: CartUpdate;
};


export type MutationChannelMessageCreateArgs = {
  attachments?: InputMaybe<Array<ResourceInput>>;
  channel: IdInput;
  text: Scalars['String'];
};


export type MutationChannelMessageDeleteArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationChannelMessageReadArgs = {
  channel: IdInput;
  messages: Array<IdInput>;
};


export type MutationCityCreateArgs = {
  countryCode: Scalars['String'];
  countryStateCode: Scalars['String'];
  name: Scalars['String'];
};


export type MutationContractorAccountTopUpArgs = {
  account: IdInput;
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
};


export type MutationContractorAccountUpdateArgs = {
  account: IdInput;
  autoCollect?: InputMaybe<Scalars['Boolean']>;
  autoCollectGroup?: InputMaybe<AccountAutoCollectGroupEnum>;
  credit?: InputMaybe<Scalars['Float']>;
  due?: InputMaybe<Scalars['Float']>;
  overdueDays?: InputMaybe<Scalars['Int']>;
  unlimited?: InputMaybe<Scalars['Boolean']>;
  veryOverdueDays?: InputMaybe<Scalars['Int']>;
};


export type MutationContractorAddDocumentArgs = {
  document: Scalars['Upload'];
};


export type MutationContractorBilldRequestArgs = {
  contractor: IdInput;
};


export type MutationContractorConfirmIdentityArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationContractorCreateArgs = {
  accountingEmail?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingAddressNew?: InputMaybe<AddressInput>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddressNew?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companySize?: InputMaybe<Scalars['String']>;
  contractorType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<IdInput>;
  creditAccount?: InputMaybe<Scalars['Boolean']>;
  creditLimit?: InputMaybe<Scalars['Float']>;
  customField1?: InputMaybe<Scalars['String']>;
  customField2?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  exportCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  priceGroup?: InputMaybe<PriceGroupEnum>;
};


export type MutationContractorDisconnectArgs = {
  contractor?: InputMaybe<IdInput>;
};


export type MutationContractorForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationContractorManagerAddArgs = {
  contractor?: InputMaybe<IdInput>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationContractorManagerRemoveArgs = {
  manager: IdInput;
};


export type MutationContractorManagerResetPasswordArgs = {
  manager: IdInput;
};


export type MutationContractorManagerUpdateArgs = {
  identity?: InputMaybe<IdentityUpdateInput>;
  info?: InputMaybe<ContractorMemberUpdateInfo>;
  manager: IdInput;
};


export type MutationContractorMemberAddArgs = {
  contractor?: InputMaybe<IdInput>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<IdInput>>;
};


export type MutationContractorMemberMakeOwnerArgs = {
  contractorMember: IdInput;
  replaceIdentities?: InputMaybe<Scalars['Boolean']>;
};


export type MutationContractorMemberRemoveArgs = {
  contractorMember: IdInput;
};


export type MutationContractorMemberResetPasswordArgs = {
  manager: IdInput;
};


export type MutationContractorMemberUpdateArgs = {
  contractorMember: IdInput;
  identity?: InputMaybe<IdentityUpdateInput>;
  info?: InputMaybe<ContractorMemberUpdateInfo>;
  roles?: InputMaybe<Array<IdInput>>;
};


export type MutationContractorMergeArgs = {
  destination: IdInput;
  source: IdInput;
};


export type MutationContractorNoteUpdateArgs = {
  contractor: IdInput;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationContractorPartnerUpdateArgs = {
  partner: IdInput;
  selected: Scalars['Boolean'];
};


export type MutationContractorResetPasswordArgs = {
  contractor?: InputMaybe<IdInput>;
  email?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  resetToken?: InputMaybe<Scalars['String']>;
};


export type MutationContractorSendPasswordArgs = {
  contractor: IdInput;
};


export type MutationContractorSignInArgs = {
  contractor?: InputMaybe<IdInput>;
  email?: InputMaybe<IdentityEmailInput>;
  oauth?: InputMaybe<IdentityOauth2Input>;
  phone?: InputMaybe<IdentityPhoneInput>;
};


export type MutationContractorSignUpArgs = {
  identity?: InputMaybe<ContractorIdentityInputData>;
  info?: InputMaybe<ContractorUpdateInfoInput>;
  referralCode?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<ContractorSourceInputData>;
};


export type MutationContractorSkidUpdateArgs = {
  contractor: IdInput;
  input: Array<ContractorSkidUpdateInput>;
  reason: SkidTransactionReasonEnum;
};


export type MutationContractorUpdateArgs = {
  companyInfo?: InputMaybe<ContractorUpdateCompanyInfoInput>;
  contractor?: InputMaybe<IdInput>;
  credit?: InputMaybe<Scalars['Float']>;
  identity?: InputMaybe<IdentityUpdateInput>;
  info?: InputMaybe<ContractorUpdateInfoInput>;
  paymentsInfo?: InputMaybe<ContractorUpdatePaymentsInfoInput>;
  priceGroups?: InputMaybe<Array<ContractorPriceGroupCreateInput>>;
  productTypePrices?: InputMaybe<Array<ProductTypePriceCreateInput>>;
};


export type MutationContractorUpdateFlagsArgs = {
  contractor: IdInput;
  flags: Scalars['JSON'];
};


export type MutationContractorValidateResetTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  resetToken: Scalars['String'];
};


export type MutationCreateDriverTaskDocumentArgs = {
  driverTask: IdInput;
  file: Scalars['Upload'];
};


export type MutationDeliveryMethodCreateArgs = {
  input: DeliveryMethodCreateInput;
};


export type MutationDeliveryMethodDeleteArgs = {
  input: IdInput;
};


export type MutationDeliveryMethodUpdateArgs = {
  input: DeliveryMethodUpdateInput;
};


export type MutationDeliveryTransactionApproveArgs = {
  deliveryTransaction: IdInput;
};


export type MutationDeliveryTransactionConfirmArgs = {
  deliveryTransaction: IdInput;
};


export type MutationDeliveryTransactionCreateArgs = {
  debugInfo?: InputMaybe<Scalars['JSON']>;
  input: DeliveryTransactionCreateInput;
};


export type MutationDeliveryTransactionDocumentCreateArgs = {
  driverTask: IdInput;
  file: Scalars['Upload'];
  processAsync?: InputMaybe<Scalars['Boolean']>;
  resourceTransform?: InputMaybe<ResourceTransformInput>;
};


export type MutationDeliveryTransactionUpdateArgs = {
  deliveryTransaction?: InputMaybe<IdInput>;
  input: DeliveryTransactionUpdateInput;
};


export type MutationDriverCompleteDayArgs = {
  input: DriverWorkingDayInput;
  workingDay: IdInput;
};


export type MutationDriverConfirmIdentityArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationDriverCreateArgs = {
  email: Scalars['String'];
  info?: InputMaybe<DriverInfoInput>;
  phone: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};


export type MutationDriverCreateBlockOffArgs = {
  category?: InputMaybe<DriverBlockOffEnum>;
  driver: IdInput;
  from: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type MutationDriverDeleteBlockOffArgs = {
  id: Scalars['ID'];
};


export type MutationDriverForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationDriverNoteUpdateArgs = {
  driver: IdInput;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationDriverRemoveArgs = {
  driver: IdInput;
};


export type MutationDriverResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  resetToken: Scalars['String'];
};


export type MutationDriverSetPasswordArgs = {
  driver: IdInput;
  password: Scalars['String'];
};


export type MutationDriverSignInArgs = {
  email?: InputMaybe<IdentityEmailInput>;
  phone?: InputMaybe<IdentityPhoneInput>;
};


export type MutationDriverSignUpArgs = {
  identity: DriverIdentityInputData;
};


export type MutationDriverStartDayArgs = {
  input: DriverWorkingDayInput;
};


export type MutationDriverTaskAcceptArgs = {
  driverTask: IdInput;
};


export type MutationDriverTaskArriveArgs = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  debugInfo?: InputMaybe<Scalars['JSON']>;
  driverTask: IdInput;
  location?: InputMaybe<LocationInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverTaskBatchUpdateArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  input: Array<DriverTaskBatchUpdateInput>;
};


export type MutationDriverTaskCancelArgs = {
  driverTask: IdInput;
};


export type MutationDriverTaskCompleteArgs = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['String']>;
  debugInfo?: InputMaybe<Scalars['JSON']>;
  deliveredAt?: InputMaybe<Scalars['String']>;
  driverTask: IdInput;
  fullUnloaded?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationInput>;
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  returningAt?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
};


export type MutationDriverTaskCreateArgs = {
  input: DriverTaskCreate;
};


export type MutationDriverTaskNoteAddArgs = {
  attachments?: InputMaybe<Array<ResourceInput>>;
  driverTask: IdInput;
  global?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationDriverTaskNoteRemoveArgs = {
  note: IdInput;
};


export type MutationDriverTaskOnSiteJobCompleteArgs = {
  driverTask: IdInput;
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobMetric?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
};


export type MutationDriverTaskOnSiteJobStartArgs = {
  driverTask: IdInput;
  onsiteJobMetric?: InputMaybe<Scalars['Float']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
};


export type MutationDriverTaskRemoveArgs = {
  driverTask: IdInput;
};


export type MutationDriverTaskReturnArgs = {
  debugInfo?: InputMaybe<Scalars['JSON']>;
  driverTask: IdInput;
  location?: InputMaybe<LocationInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  returningAt?: InputMaybe<Scalars['String']>;
};


export type MutationDriverTaskRevertArgs = {
  driverTask: IdInput;
};


export type MutationDriverTaskSetExportedArgs = {
  driverTask?: InputMaybe<IdInput>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverTaskStartArgs = {
  debugInfo?: InputMaybe<Scalars['JSON']>;
  driverTask: IdInput;
  location?: InputMaybe<LocationInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['String']>;
};


export type MutationDriverTaskUpdateArgs = {
  debugInfo?: InputMaybe<Scalars['JSON']>;
  driverTask: IdInput;
  input?: InputMaybe<DriverTaskUpdate>;
};


export type MutationDriverTripCreateArgs = {
  input: DriverTripCreate;
  optimize?: InputMaybe<Scalars['Boolean']>;
  recalculate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverTripPrepareArgs = {
  driverTasks: Array<DriverTripPrepareInputDriverTask>;
  optimize?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverTripRecalculateArgs = {
  driverTrip: IdInput;
  optimize?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverTripRemoveArgs = {
  driverTrip: IdInput;
};


export type MutationDriverTripUpdateArgs = {
  driverTrip: IdInput;
  input: DriverTripUpdate;
  optimize?: InputMaybe<Scalars['Boolean']>;
  recalculate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriverUpdateArgs = {
  driver?: InputMaybe<IdInput>;
  identity?: InputMaybe<IdentityUpdateInput>;
  info?: InputMaybe<DriverInfoInput>;
};


export type MutationDriverUpdateBlockOffArgs = {
  category?: InputMaybe<DriverBlockOffEnum>;
  driverBlockOff: IdInput;
  from?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type MutationDriverUpdatePositionArgs = {
  location: LocationInput;
};


export type MutationDriverValidateResetTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  resetToken: Scalars['String'];
};


export type MutationExportPostActionArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  params: Scalars['String'];
};


export type MutationFeeCreateArgs = {
  fee: FeeCreateInput;
};


export type MutationFeeDeleteArgs = {
  input: IdInput;
};


export type MutationFeePriceCreateArgs = {
  feePrice: FeePriceInput;
};


export type MutationFeePriceDeleteArgs = {
  feePrice: IdInput;
};


export type MutationFeePriceUpdateArgs = {
  input: FeePriceUpdateInput;
};


export type MutationFeeUpdateArgs = {
  input: FeeUpdateInput;
};


export type MutationFinanceSetExportedArgs = {
  partnerFinance?: InputMaybe<IdInput>;
  partnerFinances?: InputMaybe<Array<IdInput>>;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFinanceSetInvoicedArgs = {
  partnerFinance: IdInput;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFinanceSetPaidArgs = {
  partnerFinance: IdInput;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFinanceSetPaidOrCollectArgs = {
  action: FinanceOfflineActionsEnum;
  orders: Array<IdInput>;
};


export type MutationGroupedPaymentAttachOfflinePaymentArgs = {
  date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  groupedPayment: IdInput;
  offlineType?: InputMaybe<TransactionOfflineTypeEnum>;
};


export type MutationGroupedPaymentCreateArgs = {
  input: Array<GroupedPaymentCreateInput>;
};


export type MutationInternalCandidateRequestCreateArgs = {
  candidate: CareerCandidateInput;
  job: IdInput;
  requestPayload: CareerCandidateRequestCreateInput;
};


export type MutationInventoryBatchUpdateArgs = {
  input: Array<InventoryUpdateInput>;
};


export type MutationInventoryRecipeBatchUpdateArgs = {
  input: Array<InventoryRecipeUpdateInput>;
};


export type MutationInventoryRecipeRemoveArgs = {
  inventoryRecipe: IdInput;
};


export type MutationInventoryRecipeUpdateArgs = {
  input: InventoryRecipeUpdateInput;
};


export type MutationInventoryTransactionActualizeArgs = {
  inventoryTransaction: IdInput;
};


export type MutationInventoryTransactionCreateArgs = {
  input: InventoryTransactionCreateInput;
};


export type MutationInventoryTransactionRemoveArgs = {
  inventoryTransaction: IdInput;
};


export type MutationInventoryTransactionUpdateArgs = {
  input: InventoryTransactionUpdateInput;
};


export type MutationInventoryUpdateArgs = {
  input: InventoryUpdateInput;
};


export type MutationInviteConfirmArgs = {
  city?: InputMaybe<IdInput>;
  country?: InputMaybe<IdInput>;
  email?: InputMaybe<Scalars['String']>;
  invite: IdInput;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationInviteRejectArgs = {
  invite: IdInput;
};


export type MutationOptionCreateArgs = {
  from?: InputMaybe<IdInput>;
  input?: InputMaybe<OptionCreateInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationOptionDeleteArgs = {
  input: IdInput;
};


export type MutationOptionPriceCreateArgs = {
  optionPrice: OptionPriceInput;
};


export type MutationOptionPriceDeleteArgs = {
  optionPrice: IdInput;
};


export type MutationOptionPriceUpdateArgs = {
  input: OptionPriceUpdateInput;
};


export type MutationOptionUpdateArgs = {
  input: OptionUpdateInput;
  supplier?: InputMaybe<IdInput>;
};


export type MutationOrderAcceptQuoteArgs = {
  deliveryTime?: InputMaybe<Scalars['String']>;
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderAddPaymentMethodArgs = {
  order: IdInput;
  paymentCard?: InputMaybe<PaymentMethodCardInput>;
  paymentMethod?: InputMaybe<Scalars['ID']>;
  provider: Scalars['String'];
  update?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderAlertCloseArgs = {
  alerts: Array<IdInput>;
  order: IdInput;
};


export type MutationOrderArchiveChangeArgs = {
  change: IdInput;
};


export type MutationOrderAskForPaymentArgs = {
  order: IdInput;
};


export type MutationOrderAskToConfirmArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderAttachOfflinePaymentArgs = {
  amount: Scalars['Float'];
  date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  offlineType?: InputMaybe<TransactionOfflineTypeEnum>;
  order?: InputMaybe<IdInput>;
};


export type MutationOrderBatchApplyFeePricesArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  feePrices: Array<IdInput>;
  orders: Array<IdInput>;
};


export type MutationOrderBookArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderCancelArgs = {
  order?: InputMaybe<IdInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<OrderCancelReasonType>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationOrderChangeContractorArgs = {
  contractor: IdInput;
  contractorMember?: InputMaybe<IdInput>;
  input?: InputMaybe<OrderChangeContractorInput>;
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderChargeManuallyArgs = {
  order: IdInput;
};


export type MutationOrderCloneArgs = {
  deliveryTime: Scalars['String'];
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderCompleteArgs = {
  order?: InputMaybe<IdInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationOrderConfirmArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderCreateArgs = {
  contractor?: InputMaybe<IdInput>;
  contractorMember?: InputMaybe<IdInput>;
  draft?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<OrderCreateInput>;
  partner?: InputMaybe<IdInput>;
  payment?: InputMaybe<PaymentInput>;
  plant?: InputMaybe<IdInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  quote?: InputMaybe<Scalars['Boolean']>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationOrderDeliveringDoneArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderDeliveringStartedArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderDriverNoteAddArgs = {
  note: Scalars['String'];
  order: IdInput;
  truckIndex?: InputMaybe<Scalars['Int']>;
};


export type MutationOrderDriverNoteRemoveArgs = {
  noteIndices: Array<Scalars['Int']>;
  order: IdInput;
  truckIndex?: InputMaybe<Scalars['Int']>;
};


export type MutationOrderDriverNoteUpdateArgs = {
  note: Scalars['String'];
  noteIndex: Scalars['Int'];
  order: IdInput;
  truckIndex?: InputMaybe<Scalars['Int']>;
};


export type MutationOrderGenerateDeliverySlipArgs = {
  order: IdInput;
};


export type MutationOrderGenerateInvoiceArgs = {
  order: IdInput;
};


export type MutationOrderHoldArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderImageAddArgs = {
  image?: InputMaybe<OrderImageInput>;
  images?: InputMaybe<Array<OrderImageInput>>;
  order: IdInput;
};


export type MutationOrderImageRemoveArgs = {
  images: Array<IdInput>;
  order: IdInput;
};


export type MutationOrderLiveArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderMessageCreateArgs = {
  order: IdInput;
  text: Scalars['String'];
};


export type MutationOrderMessageReadArgs = {
  messages: Array<IdInput>;
  order: IdInput;
};


export type MutationOrderNoteUpdateArgs = {
  order: IdInput;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationOrderPayArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  billingAddress?: InputMaybe<AddressInput>;
  contractor?: InputMaybe<IdInput>;
  force?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<IdInput>;
  payment: PaymentInput;
  replacePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  skipAddPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationOrderPendingCompleteArgs = {
  order?: InputMaybe<IdInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationOrderPickupDoneArgs = {
  order: IdInput;
};


export type MutationOrderPickupStartedArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderRateArgs = {
  order: OrderRateInput;
};


export type MutationOrderReadChangeArgs = {
  changes?: InputMaybe<Array<IdInput>>;
  groups?: InputMaybe<Array<OrderChangeGroupEnum>>;
  order: IdInput;
};


export type MutationOrderReadyToPickupArgs = {
  order: IdInput;
  pickupTime?: InputMaybe<Scalars['String']>;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderRefreshQuoteArgs = {
  deliveryTime?: InputMaybe<Scalars['String']>;
  order: IdInput;
};


export type MutationOrderRefundToCreditMemoArgs = {
  amount: Scalars['Float'];
  order: IdInput;
};


export type MutationOrderRejectArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
  reason: RejectReasonEnum;
  time?: InputMaybe<Scalars['String']>;
};


export type MutationOrderReleaseArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderRemoveArgs = {
  order: IdInput;
};


export type MutationOrderRemovePaymentMethodArgs = {
  order: IdInput;
};


export type MutationOrderResourceAddArgs = {
  order: IdInput;
  resources: Array<OrderResourceInput>;
};


export type MutationOrderResourceRemoveArgs = {
  order: IdInput;
  resources: Array<IdInput>;
};


export type MutationOrderRestoreArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderSendInvoiceArgs = {
  order: IdInput;
};


export type MutationOrderSendNotificationArgs = {
  order: IdInput;
  type: OrderTruckStatusEnum;
};


export type MutationOrderSwapArgs = {
  driver?: InputMaybe<IdInput>;
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
  swapTime?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<IdInput>;
};


export type MutationOrderTaxZeroOutArgs = {
  orderPrice: IdInput;
  zeroOut: Scalars['Boolean'];
};


export type MutationOrderTransactionCancelArgs = {
  transaction: IdInput;
};


export type MutationOrderTransactionCaptureArgs = {
  transaction: IdInput;
};


export type MutationOrderTruckArriveArgs = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  orderTruck: IdInput;
};


export type MutationOrderTruckBatchUpdateArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  input: Array<OrderTruckUpdateInput>;
};


export type MutationOrderTruckCancelArgs = {
  orderTruck: IdInput;
};


export type MutationOrderTruckCompleteArgs = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  deliveredAt?: InputMaybe<Scalars['String']>;
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  orderTruck: IdInput;
  returningAt?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
};


export type MutationOrderTruckDeliveryListUpdateArgs = {
  deliveryItems?: InputMaybe<Array<OrderDeliveryItemInput>>;
  orderTruck: IdInput;
};


export type MutationOrderTruckNoteAddArgs = {
  attachments?: InputMaybe<Array<ResourceInput>>;
  global?: InputMaybe<Scalars['Boolean']>;
  orderTruck: IdInput;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationOrderTruckNoteRemoveArgs = {
  note: IdInput;
};


export type MutationOrderTruckOnSiteJobCompleteArgs = {
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  orderTruck: IdInput;
  pto?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
};


export type MutationOrderTruckOnSiteJobStartArgs = {
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  orderTruck: IdInput;
  pto?: InputMaybe<Scalars['Float']>;
};


export type MutationOrderTruckOptionAcceptArgs = {
  option?: InputMaybe<IdInput>;
  orderTruckOption: IdInput;
  quantity?: InputMaybe<Scalars['Float']>;
};


export type MutationOrderTruckOptionRejectArgs = {
  orderTruckOption: IdInput;
};


export type MutationOrderTruckPinDropAddArgs = {
  address?: InputMaybe<AddressInput>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<ResourceInput>;
  orderTruck: IdInput;
};


export type MutationOrderTruckReturnArgs = {
  orderTruck: IdInput;
  returningAt?: InputMaybe<Scalars['String']>;
};


export type MutationOrderTruckRevertArgs = {
  orderTruck: IdInput;
};


export type MutationOrderTruckSignatureAddArgs = {
  author?: InputMaybe<Scalars['String']>;
  orderTruck: IdInput;
  signature?: InputMaybe<ResourceInput>;
  skip?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderTruckStartArgs = {
  orderTruck: IdInput;
  startedAt?: InputMaybe<Scalars['String']>;
};


export type MutationOrderTruckUpdateArgs = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  deliveredAt?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<OrderTruckOptionInput>>;
  orderTruck: IdInput;
  plant?: InputMaybe<IdInput>;
  ptoOnComplete?: InputMaybe<Scalars['Float']>;
  ptoOnStart?: InputMaybe<Scalars['Float']>;
  quantitySecondary?: InputMaybe<Scalars['Float']>;
  removeDriver?: InputMaybe<Scalars['Boolean']>;
  removeTruck?: InputMaybe<Scalars['Boolean']>;
  returningAt?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  timeGapAfter?: InputMaybe<Scalars['Int']>;
  timeGapBefore?: InputMaybe<Scalars['Int']>;
  timeGapOnsite?: InputMaybe<Scalars['Int']>;
  truck?: InputMaybe<IdInput>;
};


export type MutationOrderUpdateArgs = {
  advancedMode?: InputMaybe<Scalars['Boolean']>;
  askToConfirm?: InputMaybe<Scalars['Boolean']>;
  contractorMember?: InputMaybe<IdInput>;
  keepPayment?: InputMaybe<Scalars['Boolean']>;
  order: OrderUpdateInput;
  payment?: InputMaybe<PaymentInput>;
  plant?: InputMaybe<IdInput>;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderUpdateAdditionalInfoArgs = {
  additional: Scalars['JSON'];
  askToConfirm?: InputMaybe<Scalars['Boolean']>;
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOrderUpdateFlagsArgs = {
  flags: Scalars['JSON'];
  order: IdInput;
};


export type MutationOrderValidateArgs = {
  contractorMember?: InputMaybe<IdInput>;
  order: OrderValidateInput;
  partner?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
};


export type MutationOrderWaitingForPickupArgs = {
  order: IdInput;
  pickupTime?: InputMaybe<Scalars['String']>;
  quiet?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPartnerAccountPayoutArgs = {
  amount: Scalars['Float'];
  partner: IdInput;
};


export type MutationPartnerAccountRequestPayoutArgs = {
  transactions: Array<IdInput>;
};


export type MutationPartnerAccountStripeOnboardingArgs = {
  accountType: Scalars['String'];
  supplier: IdInput;
};


export type MutationPartnerContractorAcceptArgs = {
  contractor: IdInput;
};


export type MutationPartnerContractorAccountRequestArgs = {
  partner: IdInput;
};


export type MutationPartnerContractorCancelArgs = {
  contractor?: InputMaybe<IdInput>;
  partner?: InputMaybe<IdInput>;
};


export type MutationPartnerContractorConnectArgs = {
  input: Array<PartnerContractorConnectInput>;
};


export type MutationPartnerContractorDeletePricesArgs = {
  contractor: IdInput;
};


export type MutationPartnerContractorInviteArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  input: Array<PartnerContractorInviteInput>;
};


export type MutationPartnerContractorPriceAddedArgs = {
  contractor: IdInput;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPartnerContractorPriceRequestArgs = {
  partner: IdInput;
};


export type MutationPartnerContractorQuoteRequestArgs = {
  order: IdInput;
  partner: IdInput;
};


export type MutationPartnerContractorRejectArgs = {
  contractor: IdInput;
};


export type MutationPartnerContractorUpdateArgs = {
  accountInfo?: InputMaybe<Scalars['String']>;
  partnerContractor: IdInput;
};


export type MutationPartnerCreateArgs = {
  input: PartnerCreateInput;
};


export type MutationPartnerDriverInviteArgs = {
  input: Array<PartnerDriverInviteInput>;
};


export type MutationPartnerMemberCreateArgs = {
  input: PartnerMemberCreateInput;
};


export type MutationPartnerMemberRemoveArgs = {
  input: IdInput;
};


export type MutationPartnerMemberResetPasswordArgs = {
  input?: InputMaybe<IdInput>;
};


export type MutationPartnerMemberUpdateArgs = {
  input: CommonMemberUpdateInput;
};


export type MutationPartnerSubscriptionUpdateArgs = {
  input: PartnerSubscriptionUpdateInput;
};


export type MutationPartnerTaxCreateArgs = {
  input: PartnerTaxCreateInput;
};


export type MutationPartnerTaxRemoveArgs = {
  partnerTax: IdInput;
};


export type MutationPartnerTaxToggleAvalaraArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationPartnerTaxUpdateArgs = {
  input: PartnerTaxUpdateInput;
};


export type MutationPartnerTaxZeroOutArgs = {
  contractor?: InputMaybe<IdInput>;
  fee: IdInput;
  project?: InputMaybe<IdInput>;
  zeroOut: Scalars['Boolean'];
};


export type MutationPartnerUpdateArgs = {
  input: PartnerUpdateInput;
};


export type MutationPaymentCreateArgs = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  source: Scalars['String'];
};


export type MutationPaymentLinkCancelArgs = {
  paymentLink: IdInput;
};


export type MutationPaymentLinkCreateArgs = {
  input: PaymentLinkCreateInput;
};


export type MutationPaymentLinkPayArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  payment: PaymentInput;
  paymentLink: IdInput;
};


export type MutationPaymentLinkSendArgs = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  paymentLink: IdInput;
  phones?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPaymentMethodPrepareArgs = {
  additional?: InputMaybe<Scalars['JSON']>;
  contractor?: InputMaybe<IdInput>;
  partnerSubscription?: InputMaybe<IdInput>;
  provider: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationPaymentMethodSaveArgs = {
  additional?: InputMaybe<Scalars['JSON']>;
  card: PaymentMethodCardInput;
  contractor?: InputMaybe<IdInput>;
  forFutureUse?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<IdInput>;
  partnerSubscription?: InputMaybe<IdInput>;
  provider: PaymentMethodProviderEnum;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationPaymentPrepareCardArgs = {
  contractor?: InputMaybe<IdInput>;
  provider: Scalars['String'];
};


export type MutationPlantCreateArgs = {
  input?: InputMaybe<PlantCreateInput>;
};


export type MutationPlantDeliveryMethodRemoveArgs = {
  category: IdInput;
  deliveryMethod: IdInput;
  plant: IdInput;
};


export type MutationPlantProductCreateArgs = {
  category: IdInput;
  plant: IdInput;
};


export type MutationPlantProductDeleteArgs = {
  category: IdInput;
  plant: IdInput;
};


export type MutationPlantProductUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  category: IdInput;
  plant: IdInput;
};


export type MutationPlantRemoveArgs = {
  plant: IdInput;
};


export type MutationPlantUpdateArgs = {
  input?: InputMaybe<PlantUpdateInput>;
};


export type MutationPlantUpdateOptionsArgs = {
  options: Array<PlantOptionInput>;
  plant: IdInput;
};


export type MutationPlantUpdateProductDecoratesArgs = {
  plant: IdInput;
  productDecorates: Array<PlantProductDecorateInput>;
};


export type MutationPlantUpdateProductTypesArgs = {
  plant: IdInput;
  productTypes: Array<PlantProductTypeInput>;
};


export type MutationProductCategoryBatchUpdateArgs = {
  input: Array<ProductCategoryUpdateInput>;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductCategoryCreateArgs = {
  from?: InputMaybe<IdInput>;
  input?: InputMaybe<ProductCategoryCreateInput>;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductCategoryDeleteArgs = {
  input: IdInput;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductCategoryUpdateArgs = {
  input: ProductCategoryUpdateInput;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductDecorateBatchUpdateArgs = {
  input: Array<ProductDecorateUpdateInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductDecorateCreateArgs = {
  from?: InputMaybe<IdInput>;
  input?: InputMaybe<ProductDecorateCreateInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductDecoratePriceCreateArgs = {
  input: ProductDecoratePriceCreateInput;
};


export type MutationProductDecoratePriceUpdateArgs = {
  input: ProductDecoratePriceUpdateInput;
};


export type MutationProductDecorateUpdateArgs = {
  input: ProductDecorateUpdateInput;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductDependenciesRemoveArgs = {
  category: IdInput;
};


export type MutationProductIngredientCreateArgs = {
  input: ProductIngredientCreateInput;
};


export type MutationProductIngredientRemoveArgs = {
  productIngredient: IdInput;
};


export type MutationProductIngredientUpdateArgs = {
  input: ProductIngredientUpdateInput;
};


export type MutationProductTypeBatchUpdateArgs = {
  input: Array<ProductTypeUpdateInput>;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductTypeCreateArgs = {
  from?: InputMaybe<IdInput>;
  input?: InputMaybe<ProductTypeCreateInput>;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProductTypeCreateCustomArgs = {
  address: AddressInput;
  input: ProductTypeCreateCustomInput;
  partner?: InputMaybe<IdInput>;
};


export type MutationProductTypeDeleteArgs = {
  input: IdInput;
};


export type MutationProductTypeLikeArgs = {
  productTypes: Array<IdInput>;
};


export type MutationProductTypePriceCreateArgs = {
  input: ProductTypePriceCreateInput;
};


export type MutationProductTypePriceDeleteArgs = {
  input: ProductTypePriceUpdateInput;
};


export type MutationProductTypePriceUpdateArgs = {
  input: ProductTypePriceUpdateInput;
};


export type MutationProductTypeUnlikeArgs = {
  productTypes: Array<IdInput>;
};


export type MutationProductTypeUpdateArgs = {
  input: ProductTypeUpdateInput;
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type MutationProjectCloneArgs = {
  project: IdInput;
};


export type MutationProjectCompleteArgs = {
  project: IdInput;
};


export type MutationProjectCreateArgs = {
  contractor?: InputMaybe<IdInput>;
  input: ProjectCreateInput;
};


export type MutationProjectImageAddArgs = {
  images: Array<ProjectImageInput>;
  project: IdInput;
};


export type MutationProjectImageRemoveArgs = {
  images: Array<IdInput>;
  project: IdInput;
};


export type MutationProjectNoteAddArgs = {
  attachments?: InputMaybe<Array<ResourceInput>>;
  project: IdInput;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationProjectNoteRemoveArgs = {
  note: IdInput;
};


export type MutationProjectNoteUpdateArgs = {
  note: Scalars['String'];
  noteIndex: Scalars['Int'];
  project: IdInput;
};


export type MutationProjectPricesUpdateArgs = {
  input?: InputMaybe<ProjectPricesUpdateInput>;
};


export type MutationProjectQuoteAcceptArgs = {
  note?: InputMaybe<Scalars['String']>;
  project: IdInput;
  resource: Scalars['Upload'];
};


export type MutationProjectQuoteRequestArgs = {
  project: IdInput;
};


export type MutationProjectRemoveArgs = {
  project: IdInput;
};


export type MutationProjectResourceAddArgs = {
  project: IdInput;
  resources: Array<ProjectResourceInput>;
};


export type MutationProjectResourceRemoveArgs = {
  project: IdInput;
  resources: Array<IdInput>;
};


export type MutationProjectStartArgs = {
  project: IdInput;
};


export type MutationProjectUpdateArgs = {
  input: ProjectUpdateInput;
};


export type MutationProjectUpdatePriceGroupsArgs = {
  priceGroups?: InputMaybe<Array<ProjectPriceGroupCreateInput>>;
  project: IdInput;
};


export type MutationQuestionaryAnswerSaveArgs = {
  answers: Scalars['JSON'];
  completed?: InputMaybe<Scalars['Boolean']>;
  contractor?: InputMaybe<IdInput>;
  order?: InputMaybe<IdInput>;
  orderTruck?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  questionary?: InputMaybe<IdInput>;
  reason: QuestionaryReasonEnum;
  step?: InputMaybe<Scalars['String']>;
};


export type MutationResourceTransformArgs = {
  resource: IdInput;
  resourceTransform: ResourceTransformInput;
};


export type MutationServiceRequestInfoArgs = {
  input: ServiceRequestInfoInput;
};


export type MutationSkidTransactionDeleteArgs = {
  input: IdInput;
};


export type MutationSupplierCreateArgs = {
  input: SupplierCreateInput;
};


export type MutationSupplierMemberCreateArgs = {
  input: SupplierMemberCreateInput;
};


export type MutationSupplierMemberRemoveArgs = {
  input: IdInput;
};


export type MutationSupplierMemberResetPasswordArgs = {
  input?: InputMaybe<IdInput>;
};


export type MutationSupplierMemberUpdateArgs = {
  input: CommonMemberUpdateInput;
};


export type MutationSupplierUpdateArgs = {
  input: SupplierUpdateInput;
};


export type MutationTransactionSetExportedArgs = {
  transaction?: InputMaybe<IdInput>;
  transactions?: InputMaybe<Array<IdInput>>;
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationTruckAcceptArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckArriveArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckCancelArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckCompleteArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckCreateArgs = {
  input: TruckCreateInput;
};


export type MutationTruckCreateBlockOffArgs = {
  category?: InputMaybe<TruckBlockOffEnum>;
  from: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  truck: IdInput;
};


export type MutationTruckDeleteBlockOffArgs = {
  id: Scalars['ID'];
};


export type MutationTruckNoteUpdateArgs = {
  text?: InputMaybe<Scalars['String']>;
  truck: IdInput;
};


export type MutationTruckRemoveArgs = {
  input: TruckRemoveInput;
};


export type MutationTruckReturnArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckRevertArgs = {
  order: IdInput;
  truck: IdInput;
};


export type MutationTruckStartArgs = {
  order: IdInput;
  quiet?: InputMaybe<Scalars['Boolean']>;
  truck: IdInput;
};


export type MutationTruckUpdateArgs = {
  input: TruckUpdateInput;
};


export type MutationTruckUpdateBlockOffArgs = {
  category?: InputMaybe<TruckBlockOffEnum>;
  from?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  truckBlockOff: IdInput;
};


export type MutationUpdateDriverTaskDocumentArgs = {
  driverTaskDocument: IdInput;
  file: Scalars['Upload'];
};


export type MutationUserClientStoreSetArgs = {
  expiration?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ClientDataStoreScopeEnum>;
  value: Scalars['JSON'];
};


export type MutationWidgetCreateArgs = {
  input: WidgetCreateInput;
};


export type MutationWidgetDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationWidgetUpdateArgs = {
  input: WidgetUpdateInput;
};


export type MutationWorkingDayUpdateArgs = {
  finishedAt?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  workingDay: IdInput;
};

export type Note = {
  __typename?: 'Note';
  attachments: Array<Resource>;
  author?: Maybe<User>;
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  readAt?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NoteList = {
  __typename?: 'NoteList';
  count: Scalars['Int'];
  values: Array<Note>;
};

export enum OauthProviderEnum {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  Vendasta = 'vendasta'
}

export enum OneTimeCodeEnum {
  Canceling = 'canceling',
  Holding = 'holding',
  Internal = 'internal',
  SameDayDeliveryChange = 'same_day_delivery_change',
  WaitingTime = 'waiting_time',
  WaitingTimeDeposit = 'waiting_time_deposit'
}

export type Option = {
  __typename?: 'Option';
  /** Flag to show visible status, for dashboard */
  active: Scalars['Boolean'];
  category: ProductCategory;
  contractorVisibility: Scalars['Boolean'];
  customized: Scalars['Boolean'];
  defautQuantityFromSecondaryProductCategory: Scalars['Boolean'];
  driverVisibility: Scalars['Boolean'];
  exportCode?: Maybe<Scalars['String']>;
  group: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  oneOfGroup: Scalars['Boolean'];
  partner?: Maybe<Partner>;
  prices?: Maybe<OptionPriceList>;
  required: Scalars['Boolean'];
  serviceName: Scalars['String'];
  sortOrder: Scalars['Int'];
  step?: Maybe<Scalars['Float']>;
  taxable: Scalars['Boolean'];
  units?: Maybe<Scalars['String']>;
};


export type OptionPricesArgs = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<PricesModeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type OptionCreateInput = {
  category: IdInput;
  contractorVisibility?: InputMaybe<Scalars['Boolean']>;
  driverVisibility?: InputMaybe<Scalars['Boolean']>;
  exportCode?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  oneOfGroup?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of OptionCreate */
export type OptionCreatePayload = {
  __typename?: 'OptionCreatePayload';
  option?: Maybe<Option>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OptionDelete */
export type OptionDeletePayload = {
  __typename?: 'OptionDeletePayload';
  success: Scalars['Boolean'];
};

export type OptionList = {
  __typename?: 'OptionList';
  count: Scalars['Int'];
  groups: Array<Maybe<Scalars['String']>>;
  values: Array<Option>;
};

export type OptionPrice = {
  __typename?: 'OptionPrice';
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  option: Option;
  plant?: Maybe<Plant>;
  price: Price;
};

export type OptionPriceCreateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  option: IdInput;
  plant?: InputMaybe<IdInput>;
  price: PriceInput;
  product?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of OptionPriceCreate */
export type OptionPriceCreatePayload = {
  __typename?: 'OptionPriceCreatePayload';
  optionPrice?: Maybe<Price>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OptionPriceDelete */
export type OptionPriceDeletePayload = {
  __typename?: 'OptionPriceDeletePayload';
  success: Scalars['Boolean'];
};

export type OptionPriceInput = {
  city?: InputMaybe<IdInput>;
  content?: InputMaybe<Scalars['String']>;
  contractor?: InputMaybe<IdInput>;
  currency?: InputMaybe<Scalars['String']>;
  formula?: InputMaybe<IdInput>;
  formulaArguments?: InputMaybe<Scalars['JSON']>;
  group?: InputMaybe<PriceGroupEnum>;
  option: IdInput;
  plant?: InputMaybe<IdInput>;
  product?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OptionPriceList = {
  __typename?: 'OptionPriceList';
  count: Scalars['Int'];
  values: Array<OptionPrice>;
};

export type OptionPricePaginatedInstance = {
  __typename?: 'OptionPricePaginatedInstance';
  active?: Maybe<Scalars['Boolean']>;
  option: Option;
  prices: Array<OptionPrice>;
};

export type OptionPricePaginatedList = {
  __typename?: 'OptionPricePaginatedList';
  count: Scalars['Int'];
  groups: Array<Scalars['String']>;
  values: Array<OptionPricePaginatedInstance>;
};

export type OptionPriceUpdateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  id: Scalars['ID'];
  plant?: InputMaybe<IdInput>;
  price?: InputMaybe<PriceInput>;
  product?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of OptionPriceUpdate */
export type OptionPriceUpdatePayload = {
  __typename?: 'OptionPriceUpdatePayload';
  optionPrice?: Maybe<OptionPrice>;
  success: Scalars['Boolean'];
};

export type OptionUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  clearImage?: InputMaybe<Scalars['Boolean']>;
  contractorVisibility?: InputMaybe<Scalars['Boolean']>;
  driverVisibility?: InputMaybe<Scalars['Boolean']>;
  exportCode?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  oneOfGroup?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of OptionUpdate */
export type OptionUpdatePayload = {
  __typename?: 'OptionUpdatePayload';
  option?: Maybe<Option>;
  success: Scalars['Boolean'];
};

export type Order = {
  __typename?: 'Order';
  additional?: Maybe<Scalars['JSON']>;
  address: Address;
  adminNote?: Maybe<Note>;
  adminNotes: Scalars['String'];
  alerts: Array<OrderAlert>;
  askForPayment?: Maybe<Scalars['Boolean']>;
  availableActions: Array<Scalars['String']>;
  availableForExport: Scalars['Boolean'];
  changesInfo: OrderChangesInfo;
  chargedManually: Scalars['Boolean'];
  city: City;
  contractor: Contractor;
  contractorMember?: Maybe<ContractorMember>;
  contractorNote?: Maybe<Note>;
  countryState: CountryStateInstance;
  currency: Scalars['String'];
  customPrices: Scalars['Boolean'];
  cutoffTime?: Maybe<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['String']>;
  deliveryDetails: Scalars['String'];
  deliveryMethod: DeliveryMethod;
  deliveryTime: Scalars['String'];
  deliveryWindow: Scalars['Int'];
  driverNotes: Array<OrderDriverNotes>;
  fees: Array<Fee>;
  flags: Scalars['JSON'];
  hasToBeRated: Scalars['Boolean'];
  history: OrderHistory;
  holdLimits: Scalars['Int'];
  id: Scalars['ID'];
  images: Array<OrderImage>;
  /** Link to order invoice */
  invoice?: Maybe<Scalars['String']>;
  invoiceNotes: Scalars['String'];
  invoiceTotalPrice: Scalars['Float'];
  lastCallTime?: Maybe<Scalars['String']>;
  lastPaymentFailureReason?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  linkToPayment?: Maybe<Scalars['String']>;
  lockToCancelTime: Scalars['String'];
  lockToUpdateTime: Scalars['String'];
  notes?: Maybe<NoteList>;
  /** [DEPRECATED] */
  number: Scalars['ID'];
  options: Array<Option>;
  origin: Scalars['String'];
  partner?: Maybe<Partner>;
  partnerContractor?: Maybe<PartnerContractor>;
  paymentErrors?: Maybe<Array<OrderPaymentError>>;
  paymentIntents: Array<PaymentIntent>;
  paymentLinkPossibleValue: Scalars['Float'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodSource?: Maybe<Scalars['JSON']>;
  paymentMode: Scalars['String'];
  paymentStatus: Scalars['String'];
  pendingDriverOptions: Array<OrderTruckOption>;
  pendingPossibleTime?: Maybe<Scalars['Boolean']>;
  permissions: Scalars['JSON'];
  pickup?: Maybe<Scalars['Boolean']>;
  pickupTime?: Maybe<Scalars['String']>;
  plant: Plant;
  possibleExtraHold?: Maybe<Scalars['Float']>;
  possibleProcessingFees?: Maybe<Array<OrderProcessingFeeInstance>>;
  pouringTime: Scalars['String'];
  prettyId: Scalars['String'];
  priceMode: Scalars['String'];
  prices: Array<OrderPrice>;
  processingFees: Array<OrderProcessingFeeInstance>;
  product: ProductCategory;
  project?: Maybe<Project>;
  projectType: Scalars['String'];
  purchaseNumber?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  quantitySecondary: Scalars['Float'];
  ratings: OrderRatings;
  rejectedDetails?: Maybe<OrderRejectedDetails>;
  resources: OrderResourceList;
  route: Route;
  secondaryUnits?: Maybe<Scalars['String']>;
  skids: Array<Skid>;
  source?: Maybe<Scalars['String']>;
  sourceInfo?: Maybe<SourceInfo>;
  status: Scalars['String'];
  supplier: Supplier;
  supplierDeliveryInstructions: Scalars['String'];
  swappedOrder?: Maybe<Order>;
  testMode: Scalars['Boolean'];
  timeBetweenTrucks: Scalars['Int'];
  timeRequestedWithTruck: Scalars['Int'];
  timezone: Scalars['String'];
  totalPaid: Scalars['Float'];
  totalPaidProcessingFee: Scalars['Float'];
  totalPrice: Scalars['Float'];
  /** [DEPRECATED] */
  transactions: TransactionList;
  truckStatus: Scalars['String'];
  trucks: Array<Scalars['Float']>;
  trucksConfig: TrucksConfig;
  trucksDrivers: Array<OrderTruck>;
  trucksSecondary: Array<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  unloadingMethod: Scalars['String'];
  unloadingMethodDetails: Scalars['String'];
  updatedAt: Scalars['String'];
};


export type OrderAdditionalArgs = {
  reason?: InputMaybe<QuestionaryReasonEnum>;
};


export type OrderNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<IdentityTypeEnum>;
};


export type OrderPaymentIntentsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPaymentMethodArgs = {
  legacy?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPossibleProcessingFeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
};


export type OrderResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<OrderResourceTypeEnum>>;
};


export type OrderStatusArgs = {
  detailed?: InputMaybe<Scalars['Boolean']>;
};


export type OrderTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrderAcceptQuote */
export type OrderAcceptQuotePayload = {
  __typename?: 'OrderAcceptQuotePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderAddPaymentMethod */
export type OrderAddPaymentMethodPayload = {
  __typename?: 'OrderAddPaymentMethodPayload';
  paymentMethod?: Maybe<PaymentMethod>;
  success: Scalars['Boolean'];
};

export type OrderAlert = {
  __typename?: 'OrderAlert';
  action: OrderAlertTypeAction;
  id: Scalars['String'];
  level: Scalars['String'];
  message: Scalars['String'];
};

/** Autogenerated return type of OrderAlertClose */
export type OrderAlertClosePayload = {
  __typename?: 'OrderAlertClosePayload';
  success: Scalars['Boolean'];
};

export type OrderAlertTypeAction = {
  __typename?: 'OrderAlertTypeAction';
  name: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of OrderArchiveChange */
export type OrderArchiveChangePayload = {
  __typename?: 'OrderArchiveChangePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderAskForPayment */
export type OrderAskForPaymentPayload = {
  __typename?: 'OrderAskForPaymentPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderAskToConfirm */
export type OrderAskToConfirmPayload = {
  __typename?: 'OrderAskToConfirmPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderBatchApplyFeePrices */
export type OrderBatchApplyFeePricesPayload = {
  __typename?: 'OrderBatchApplyFeePricesPayload';
  job?: Maybe<JobStatus>;
  orders?: Maybe<Array<Order>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderBook */
export type OrderBookPayload = {
  __typename?: 'OrderBookPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderCancel */
export type OrderCancelPayload = {
  __typename?: 'OrderCancelPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderCancelReasonType = {
  details?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type OrderChange = {
  __typename?: 'OrderChange';
  archived: Scalars['Boolean'];
  change: Scalars['JSON'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  order: Order;
  source: Scalars['String'];
  type: Scalars['String'];
  viewed: Scalars['Boolean'];
};

export type OrderChangeContractorInput = {
  address: AddressInput;
  project?: InputMaybe<IdInput>;
};

/** Autogenerated return type of OrderChangeContractor */
export type OrderChangeContractorPayload = {
  __typename?: 'OrderChangeContractorPayload';
  order: Order;
  success: Scalars['Boolean'];
};

export enum OrderChangeGroupEnum {
  Address = 'address',
  DeliveryTime = 'delivery_time',
  Product = 'product',
  Trucks = 'trucks'
}

export type OrderChanges = {
  __typename?: 'OrderChanges';
  count: Scalars['Int'];
  values: Array<OrderChange>;
};

export type OrderChangesInfo = {
  __typename?: 'OrderChangesInfo';
  changeAddress: Scalars['Int'];
  changeDeliveryTime: Scalars['Int'];
  changeProduct: Scalars['Int'];
  changeTrucks: Scalars['Int'];
  countUnread: Scalars['Int'];
};

/** Autogenerated return type of OrderChargeManually */
export type OrderChargeManuallyPayload = {
  __typename?: 'OrderChargeManuallyPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderClone */
export type OrderClonePayload = {
  __typename?: 'OrderClonePayload';
  order: Order;
  success: Scalars['Boolean'];
};

export type OrderCluster = {
  __typename?: 'OrderCluster';
  count: Scalars['Int'];
  id: Scalars['ID'];
  location: Location;
  value?: Maybe<Order>;
  values: Array<OrderClusterValue>;
};

export type OrderClusterValue = {
  __typename?: 'OrderClusterValue';
  id: Scalars['ID'];
};

/** Autogenerated return type of OrderComplete */
export type OrderCompletePayload = {
  __typename?: 'OrderCompletePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderConfirm */
export type OrderConfirmPayload = {
  __typename?: 'OrderConfirmPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderCreateInput = {
  additional?: InputMaybe<Scalars['JSON']>;
  address: AddressInput;
  adminNotes?: InputMaybe<Scalars['String']>;
  autogenerateProject?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  deliveryDetails?: InputMaybe<Scalars['String']>;
  deliveryItems?: InputMaybe<Array<Array<OrderDeliveryItemInput>>>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  deliveryWindow?: InputMaybe<Scalars['Int']>;
  fees?: InputMaybe<Array<OrderFeePriceInput>>;
  invoiceNotes?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<OrderOptionPriceInput>>;
  paymentMode?: InputMaybe<OrderPaymentModeEnum>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  pickupTime?: InputMaybe<Scalars['String']>;
  priceMode?: InputMaybe<OrderPriceModeEnum>;
  product: ProductInput;
  project?: InputMaybe<IdInput>;
  projectType?: InputMaybe<Scalars['String']>;
  purchaseNumber?: InputMaybe<Scalars['String']>;
  requested?: InputMaybe<Scalars['Boolean']>;
  timeBetweenTrucks?: InputMaybe<Scalars['Int']>;
  toBeConfirmed?: InputMaybe<Scalars['Boolean']>;
  totalPrice: Scalars['Float'];
  trucks?: InputMaybe<Array<Scalars['Float']>>;
  trucksSecondary?: InputMaybe<Array<Scalars['Float']>>;
};

/** Autogenerated return type of OrderCreate */
export type OrderCreatePayload = {
  __typename?: 'OrderCreatePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderCreditMemoRefund */
export type OrderCreditMemoRefundPayload = {
  __typename?: 'OrderCreditMemoRefundPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderDeliveringDone */
export type OrderDeliveringDonePayload = {
  __typename?: 'OrderDeliveringDonePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderDeliveringStarted */
export type OrderDeliveringStartedPayload = {
  __typename?: 'OrderDeliveringStartedPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderDeliveryItem = {
  __typename?: 'OrderDeliveryItem';
  id?: Maybe<Scalars['ID']>;
  productType: ProductType;
  quantity: Scalars['Float'];
  status?: Maybe<DeliveryItemStatusEnum>;
  units?: Maybe<Scalars['String']>;
};

export type OrderDeliveryItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  productType?: InputMaybe<IdInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<DeliveryItemStatusEnum>;
};

/** Autogenerated return type of OrderDriverNoteAdd */
export type OrderDriverNoteAddPayload = {
  __typename?: 'OrderDriverNoteAddPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderDriverNoteRemove */
export type OrderDriverNoteRemovePayload = {
  __typename?: 'OrderDriverNoteRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderDriverNoteUpdate */
export type OrderDriverNoteUpdatePayload = {
  __typename?: 'OrderDriverNoteUpdatePayload';
  success: Scalars['Boolean'];
};

export type OrderDriverNotes = {
  __typename?: 'OrderDriverNotes';
  id?: Maybe<Scalars['ID']>;
  notes: Array<Scalars['String']>;
};

export type OrderFeePriceInput = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: InputMaybe<IdInput>;
  value?: InputMaybe<Scalars['Float']>;
  zeroOutReason?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of OrderGenerateDeliverySlip */
export type OrderGenerateDeliverySlipPayload = {
  __typename?: 'OrderGenerateDeliverySlipPayload';
  success: Scalars['Boolean'];
  url: Scalars['String'];
};

/** Autogenerated return type of OrderGenerateInvoice */
export type OrderGenerateInvoicePayload = {
  __typename?: 'OrderGenerateInvoicePayload';
  success: Scalars['Boolean'];
  url: Scalars['String'];
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  initial: OrderHistoryItem;
  updates: Array<OrderHistoryItem>;
};

export type OrderHistoryItem = {
  __typename?: 'OrderHistoryItem';
  data: Scalars['JSON'];
  time: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrderHold */
export type OrderHoldPayload = {
  __typename?: 'OrderHoldPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderImage = {
  __typename?: 'OrderImage';
  contractorMember?: Maybe<ContractorMember>;
  createdAt: Scalars['String'];
  driver?: Maybe<Driver>;
  id: Scalars['ID'];
  image: Resource;
  type: Scalars['String'];
};

/** Autogenerated return type of OrderImageAdd */
export type OrderImageAddPayload = {
  __typename?: 'OrderImageAddPayload';
  image?: Maybe<OrderImage>;
  images?: Maybe<Array<OrderImage>>;
  success: Scalars['Boolean'];
};

export type OrderImageInput = {
  image: ResourceInput;
  type: Scalars['String'];
};

/** Autogenerated return type of OrderImageRemove */
export type OrderImageRemovePayload = {
  __typename?: 'OrderImageRemovePayload';
  success: Scalars['Boolean'];
};

export type OrderList = {
  __typename?: 'OrderList';
  count: Scalars['Int'];
  values: Array<Order>;
};

export type OrderListExtended = {
  __typename?: 'OrderListExtended';
  clusters: Array<OrderCluster>;
  count: Scalars['Int'];
  values: Array<Order>;
};


export type OrderListExtendedClustersArgs = {
  precision: Scalars['Float'];
};

/** Autogenerated return type of OrderLive */
export type OrderLivePayload = {
  __typename?: 'OrderLivePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderMessage = {
  __typename?: 'OrderMessage';
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  text: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of OrderMessageCreate */
export type OrderMessageCreatePayload = {
  __typename?: 'OrderMessageCreatePayload';
  message?: Maybe<OrderMessage>;
  success: Scalars['Boolean'];
};

export type OrderMessageList = {
  __typename?: 'OrderMessageList';
  count: Scalars['Int'];
  order: Order;
  values: Array<OrderMessage>;
};

/** Autogenerated return type of OrderMessageRead */
export type OrderMessageReadPayload = {
  __typename?: 'OrderMessageReadPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderNoteUpdate */
export type OrderNoteUpdatePayload = {
  __typename?: 'OrderNoteUpdatePayload';
  note?: Maybe<Note>;
  success: Scalars['Boolean'];
};

export type OrderOptionPriceInput = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: InputMaybe<IdInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of OrderPay */
export type OrderPayPayload = {
  __typename?: 'OrderPayPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  intent?: Maybe<Scalars['JSON']>;
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type OrderPaymentError = {
  __typename?: 'OrderPaymentError';
  text: Scalars['String'];
  time: Scalars['String'];
};

export enum OrderPaymentModeEnum {
  Default = 'default',
  Offline = 'offline',
  PartnerAccount = 'partner_account'
}

export enum OrderPaymentStatusEnum {
  Account = 'account',
  Failed = 'failed',
  None = 'none',
  Paid = 'paid',
  PartiallyPaid = 'partially_paid',
  Pending = 'pending',
  WaitingForPayment = 'waiting_for_payment'
}

/** Autogenerated return type of OrderPendingComplete */
export type OrderPendingCompletePayload = {
  __typename?: 'OrderPendingCompletePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderPickupConfigInstance = {
  __typename?: 'OrderPickupConfigInstance';
  autoApplyPickupInterval: Scalars['Boolean'];
  pickupInterval?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of OrderPickupDone */
export type OrderPickupDonePayload = {
  __typename?: 'OrderPickupDonePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderPickupStarted */
export type OrderPickupStartedPayload = {
  __typename?: 'OrderPickupStartedPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderPreparatoryConfig = {
  __typename?: 'OrderPreparatoryConfig';
  additionalInfoQuestionary?: Maybe<Questionary>;
  availabilityTimes: AvailabilityTimes;
  availableProductTypes: Array<ProductType>;
  cities?: Maybe<Array<City>>;
  countries: Array<Country>;
  fees: Array<OrderPreparatoryConfigFeePrice>;
  options: Array<OrderPreparatoryConfigOptionPrice>;
  partners: Array<Partner>;
  paymentMethods: Array<PaymentMethod>;
  pickup: Scalars['Boolean'];
  pickupConfig: OrderPickupConfigInstance;
  plantConfig?: Maybe<PlantConfigInstance>;
  plants: Array<Plant>;
  plantsGeofence: Array<Scalars['String']>;
  /**
   * returns (pickup)plants with
   *                                                                   the quantity of explicit product type
   */
  plantsInventory: Array<PlantInventoryList>;
  possibleProcessingFees?: Maybe<Array<ProcessingFeeInstance>>;
  processingFees: Array<OrderPreparatoryConfigFeePrice>;
  productDecorates: Array<OrderPreparatoryConfigProductDecoratePrice>;
  productTypes: Array<OrderPreparatoryConfigProductTypePrice>;
  products: Array<ProductCategory>;
  quantitiesConfig: QuantitiesConfig;
  route: Route;
  skids: Array<OrderPreparatoryConfigSkidPrice>;
  supplierDeliveryInstructions?: Maybe<Scalars['String']>;
  taxFromZeroOuted: OrderPreparatoryConfigFeePrice;
  taxZeroOuted: OrderPreparatoryConfigFeePrice;
  taxes: Array<OrderPreparatoryConfigFeePrice>;
  totalPrice: OrderPreparatoryConfigTotalPrice;
  trucksConfig: TrucksConfig;
  trucksConfigs: Array<TrucksConfig>;
};


export type OrderPreparatoryConfigAvailabilityTimesArgs = {
  days?: InputMaybe<Array<Scalars['String']>>;
  pickupTime?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigAvailableProductTypesArgs = {
  keepPlant?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigCitiesArgs = {
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigFeesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['Boolean']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  mergeWithExisting?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<FeeTypeEnum>>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigOptionsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type OrderPreparatoryConfigPaymentMethodsArgs = {
  projectType?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Array<Scalars['String']>>;
};


export type OrderPreparatoryConfigPlantsArgs = {
  location?: InputMaybe<LocationInput>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<RegionInput>;
  supplier?: InputMaybe<IdInput>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigPlantsGeofenceArgs = {
  pickup?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<RegionInput>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigPlantsInventoryArgs = {
  productType: IdInput;
  region?: InputMaybe<RegionInput>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigPossibleProcessingFeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<IdInput>;
  paymentProvider: Scalars['String'];
};


export type OrderPreparatoryConfigProcessingFeesArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type OrderPreparatoryConfigProductDecoratesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  productTypePrice?: InputMaybe<IdInput>;
};


export type OrderPreparatoryConfigProductTypesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  keepPlant?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  perSupplier?: InputMaybe<Scalars['Boolean']>;
  productType?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  withCombinations?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigProductsArgs = {
  region?: InputMaybe<RegionInput>;
  withPossibles?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigQuantitiesConfigArgs = {
  productType: IdInput;
};


export type OrderPreparatoryConfigTaxFromZeroOutedArgs = {
  taxPrice: IdInput;
};


export type OrderPreparatoryConfigTaxZeroOutedArgs = {
  taxPrice: IdInput;
};


export type OrderPreparatoryConfigTaxesArgs = {
  currency?: InputMaybe<Scalars['String']>;
  internal?: InputMaybe<Scalars['Boolean']>;
};


export type OrderPreparatoryConfigTotalPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type OrderPreparatoryConfigFeePrice = {
  __typename?: 'OrderPreparatoryConfigFeePrice';
  fee: Fee;
  price: Price;
};

export type OrderPreparatoryConfigInput = {
  address?: InputMaybe<AddressInput>;
  category?: InputMaybe<IdInput>;
  deliveryItems?: InputMaybe<Array<Array<OrderDeliveryItemInput>>>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Array<OrderFeePriceInput>>;
  options?: InputMaybe<Array<OrderOptionPriceInput>>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  pickupTime?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  productPrices?: InputMaybe<Array<ProductPriceInput>>;
  project?: InputMaybe<IdInput>;
  skids?: InputMaybe<Array<OrderSkidPriceInput>>;
  timeBetweenTrucks?: InputMaybe<Scalars['Int']>;
  trucks?: InputMaybe<Array<Scalars['Float']>>;
  trucksSecondary?: InputMaybe<Array<Scalars['Float']>>;
};

export type OrderPreparatoryConfigOptionPrice = {
  __typename?: 'OrderPreparatoryConfigOptionPrice';
  option: Option;
  price: Price;
};

export type OrderPreparatoryConfigProductDecoratePrice = {
  __typename?: 'OrderPreparatoryConfigProductDecoratePrice';
  price: Price;
  productDecorate: ProductDecorate;
};

export type OrderPreparatoryConfigProductTypePrice = {
  __typename?: 'OrderPreparatoryConfigProductTypePrice';
  price: Price;
  priceMode?: Maybe<OrderPriceModeEnum>;
  productType: ProductType;
  supplier?: Maybe<Supplier>;
  units: Scalars['String'];
  virtualPrice?: Maybe<ProductTypeVirtualPrice>;
};

export type OrderPreparatoryConfigSkidPrice = {
  __typename?: 'OrderPreparatoryConfigSkidPrice';
  price: Price;
  quantity: Scalars['Int'];
  skid: Skid;
  totalPrice?: Maybe<Scalars['Float']>;
};

export type OrderPreparatoryConfigTotalPrice = {
  __typename?: 'OrderPreparatoryConfigTotalPrice';
  components: Array<OrderPrice>;
  value: Scalars['Float'];
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  anchorPrice?: Maybe<OrderPrice>;
  description?: Maybe<Scalars['String']>;
  fee?: Maybe<Fee>;
  id?: Maybe<Scalars['ID']>;
  option?: Maybe<Option>;
  price: Price;
  productDecorate?: Maybe<ProductDecorate>;
  productType?: Maybe<ProductType>;
  quantity?: Maybe<Scalars['Float']>;
  skid?: Maybe<Skid>;
  taxable: Scalars['Boolean'];
  units?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
  virtualPrice?: Maybe<ProductTypeVirtualPrice>;
  zeroOutReason?: Maybe<Scalars['String']>;
};

export enum OrderPriceModeEnum {
  Account = 'account',
  Default = 'default',
  Without = 'without'
}

export type OrderProcessingFeeInstance = {
  __typename?: 'OrderProcessingFeeInstance';
  conditionsDescription: Array<Scalars['String']>;
  fee?: Maybe<Fee>;
  value?: Maybe<Scalars['Float']>;
};

export type OrderRateInput = {
  brokrete?: InputMaybe<Scalars['Float']>;
  driver?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  product?: InputMaybe<Scalars['Float']>;
  supplier?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of OrderRate */
export type OrderRatePayload = {
  __typename?: 'OrderRatePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderRatings = {
  __typename?: 'OrderRatings';
  brokrete?: Maybe<Scalars['Int']>;
  driver?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['Int']>;
  supplier?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of OrderReadChange */
export type OrderReadChangePayload = {
  __typename?: 'OrderReadChangePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderReadyToPickup */
export type OrderReadyToPickupPayload = {
  __typename?: 'OrderReadyToPickupPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderRefreshQuote */
export type OrderRefreshQuotePayload = {
  __typename?: 'OrderRefreshQuotePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderReject */
export type OrderRejectPayload = {
  __typename?: 'OrderRejectPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderRejectedDetails = {
  __typename?: 'OrderRejectedDetails';
  description: Scalars['String'];
  reason: Scalars['String'];
  time?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrderRelease */
export type OrderReleasePayload = {
  __typename?: 'OrderReleasePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderRemove */
export type OrderRemovePayload = {
  __typename?: 'OrderRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderRemovePaymentMethod */
export type OrderRemovePaymentMethodPayload = {
  __typename?: 'OrderRemovePaymentMethodPayload';
  success: Scalars['Boolean'];
};

export type OrderResource = {
  __typename?: 'OrderResource';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  resource: Resource;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrderResourceAdd */
export type OrderResourceAddPayload = {
  __typename?: 'OrderResourceAddPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  resources?: Maybe<Array<OrderResource>>;
  success: Scalars['Boolean'];
};

export type OrderResourceInput = {
  resource: ResourceInput;
  type: OrderResourceTypeEnum;
};

export type OrderResourceList = {
  __typename?: 'OrderResourceList';
  count: Scalars['Int'];
  values: Array<OrderResource>;
};

/** Autogenerated return type of OrderResourceRemove */
export type OrderResourceRemovePayload = {
  __typename?: 'OrderResourceRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export enum OrderResourceTypeEnum {
  After = 'after',
  Before = 'before',
  During = 'during'
}

/** Autogenerated return type of OrderRestore */
export type OrderRestorePayload = {
  __typename?: 'OrderRestorePayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderSendInvoice */
export type OrderSendInvoicePayload = {
  __typename?: 'OrderSendInvoicePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderSendNotification */
export type OrderSendNotificationPayload = {
  __typename?: 'OrderSendNotificationPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderSkidPriceInput = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: InputMaybe<IdInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
};

export enum OrderSourceEnum {
  Admin = 'admin',
  App = 'app',
  Web = 'web'
}

export enum OrderStateEnum {
  Arrived = 'arrived',
  Booked = 'booked',
  Confirmed = 'confirmed',
  Departed = 'departed',
  Returned = 'returned'
}

/** Autogenerated return type of OrderSwap */
export type OrderSwapPayload = {
  __typename?: 'OrderSwapPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
  swapOrder?: Maybe<Order>;
};

/** Autogenerated return type of OrderTaxZeroOut */
export type OrderTaxZeroOutPayload = {
  __typename?: 'OrderTaxZeroOutPayload';
  order: Order;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderTransactionCancel */
export type OrderTransactionCancelPayload = {
  __typename?: 'OrderTransactionCancelPayload';
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

/** Autogenerated return type of OrderTransactionCapture */
export type OrderTransactionCapturePayload = {
  __typename?: 'OrderTransactionCapturePayload';
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type OrderTruck = {
  __typename?: 'OrderTruck';
  actualRoute?: Maybe<Scalars['String']>;
  additional?: Maybe<Scalars['JSON']>;
  additionalDriverTasks: Array<DriverTask>;
  arrivedAt?: Maybe<Scalars['String']>;
  availableActions: Array<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['String']>;
  deliveryItems: Array<OrderDeliveryItem>;
  deliveryTime?: Maybe<Scalars['String']>;
  deliveryTransactionTarget?: Maybe<DriverTask>;
  driver?: Maybe<Driver>;
  driverTask: DriverTask;
  estimatedDuration?: Maybe<Scalars['Int']>;
  eta?: Maybe<Scalars['String']>;
  /** Link to order truck eticket */
  eticket?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['Float']>;
  /** [DEPRECATED] Truck index in the order */
  id: Scalars['Int'];
  location?: Maybe<Location>;
  notes: Array<Scalars['String']>;
  notesNew: OrderTruckNoteList;
  onsiteJobCompletedAt?: Maybe<Scalars['String']>;
  onsiteJobStartedAt?: Maybe<Scalars['String']>;
  options: Array<OrderTruckOption>;
  order?: Maybe<Order>;
  permissions: Scalars['JSON'];
  pickupDeliveryTransaction?: Maybe<DeliveryTransaction>;
  pinDrop?: Maybe<OrderTruckPinDrop>;
  plannedRoute?: Maybe<Scalars['String']>;
  plannedRouteDuration?: Maybe<Scalars['Int']>;
  plannedRouteVersion?: Maybe<Scalars['Int']>;
  plant?: Maybe<Plant>;
  possibleDriverOptions: Array<Option>;
  ptoOnComplete?: Maybe<Scalars['Float']>;
  ptoOnStart?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  quantitySecondary?: Maybe<Scalars['Float']>;
  returningAt?: Maybe<Scalars['String']>;
  routeDetails?: Maybe<Scalars['JSON']>;
  signature: OrderTruckSignature;
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** The time (in min) it takes for a truck to return back */
  timeGapAfter?: Maybe<Scalars['Int']>;
  /** The time (in min) it takes for a truck to get on site */
  timeGapBefore?: Maybe<Scalars['Int']>;
  /** The time (in min) it takes for a truck to do job on site */
  timeGapOnsite?: Maybe<Scalars['Int']>;
  truck?: Maybe<Truck>;
  /** Truck UUID */
  truckId: Scalars['ID'];
  updatedAt: Scalars['String'];
};


export type OrderTruckAdditionalArgs = {
  reason?: InputMaybe<QuestionaryReasonEnum>;
};

/** Autogenerated return type of OrderTruckArrive */
export type OrderTruckArrivePayload = {
  __typename?: 'OrderTruckArrivePayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

export type OrderTruckBatchUpdateError = {
  __typename?: 'OrderTruckBatchUpdateError';
  error: Scalars['String'];
  id: Scalars['ID'];
};

/** Autogenerated return type of OrderTruckBatchUpdate */
export type OrderTruckBatchUpdatePayload = {
  __typename?: 'OrderTruckBatchUpdatePayload';
  errors?: Maybe<Array<OrderTruckBatchUpdateError>>;
  job?: Maybe<JobStatus>;
  orderTrucks?: Maybe<Array<OrderTruck>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderTruckCancel */
export type OrderTruckCancelPayload = {
  __typename?: 'OrderTruckCancelPayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

export type OrderTruckCluster = {
  __typename?: 'OrderTruckCluster';
  count: Scalars['Int'];
  id: Scalars['ID'];
  location: Location;
  value?: Maybe<MapTruck>;
  values: Array<OrderTruckClusterValue>;
};

export type OrderTruckClusterValue = {
  __typename?: 'OrderTruckClusterValue';
  id: Scalars['ID'];
};

/** Autogenerated return type of OrderTruckComplete */
export type OrderTruckCompletePayload = {
  __typename?: 'OrderTruckCompletePayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderTruckDeliveryListUpdate */
export type OrderTruckDeliveryListUpdatePayload = {
  __typename?: 'OrderTruckDeliveryListUpdatePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

export type OrderTruckList = {
  __typename?: 'OrderTruckList';
  count: Scalars['Int'];
  values: Array<OrderTruck>;
};

export type OrderTruckNote = {
  __typename?: 'OrderTruckNote';
  attachments: Array<Resource>;
  author?: Maybe<User>;
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  readAt?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of OrderTruckNoteAdd */
export type OrderTruckNoteAddPayload = {
  __typename?: 'OrderTruckNoteAddPayload';
  note?: Maybe<OrderTruckNote>;
  notes: Array<OrderTruckNote>;
  success: Scalars['Boolean'];
};

export type OrderTruckNoteList = {
  __typename?: 'OrderTruckNoteList';
  count: Scalars['Int'];
  values: Array<OrderTruckNote>;
};

/** Autogenerated return type of OrderTruckNoteRemove */
export type OrderTruckNoteRemovePayload = {
  __typename?: 'OrderTruckNoteRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderTruckOnSiteJobComplete */
export type OrderTruckOnSiteJobCompletePayload = {
  __typename?: 'OrderTruckOnSiteJobCompletePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

/** Autogenerated return type of OrderTruckOnSiteJobStart */
export type OrderTruckOnSiteJobStartPayload = {
  __typename?: 'OrderTruckOnSiteJobStartPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

export type OrderTruckOption = {
  __typename?: 'OrderTruckOption';
  createdByUser?: Maybe<User>;
  id: Scalars['ID'];
  option: Option;
  orderTruck: OrderTruck;
  quantity: Scalars['Float'];
  status: Scalars['String'];
};

/** Autogenerated return type of OrderTruckOptionAccept */
export type OrderTruckOptionAcceptPayload = {
  __typename?: 'OrderTruckOptionAcceptPayload';
  order: Order;
  success: Scalars['Boolean'];
};

export type OrderTruckOptionInput = {
  option: IdInput;
  quantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of OrderTruckOptionReject */
export type OrderTruckOptionRejectPayload = {
  __typename?: 'OrderTruckOptionRejectPayload';
  order: Order;
  success: Scalars['Boolean'];
};

export type OrderTruckPinDrop = {
  __typename?: 'OrderTruckPinDrop';
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Resource>;
};

/** Autogenerated return type of OrderTruckPinDropAdd */
export type OrderTruckPinDropAddPayload = {
  __typename?: 'OrderTruckPinDropAddPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

/** Autogenerated return type of OrderTruckReturn */
export type OrderTruckReturnPayload = {
  __typename?: 'OrderTruckReturnPayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderTruckRevert */
export type OrderTruckRevertPayload = {
  __typename?: 'OrderTruckRevertPayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

export type OrderTruckSignature = {
  __typename?: 'OrderTruckSignature';
  author?: Maybe<Scalars['String']>;
  image?: Maybe<Resource>;
  status?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrderTruckSignatureAdd */
export type OrderTruckSignatureAddPayload = {
  __typename?: 'OrderTruckSignatureAddPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

/** Autogenerated return type of OrderTruckStart */
export type OrderTruckStartPayload = {
  __typename?: 'OrderTruckStartPayload';
  orderTruck: OrderTruck;
  success: Scalars['Boolean'];
};

export enum OrderTruckStatusEnum {
  Delayed = 'delayed',
  Early = 'early',
  Late = 'late',
  OnTime = 'on_time',
  ReadyToPickup = 'ready_to_pickup'
}

export type OrderTruckUpdateInput = {
  arrivedAt?: InputMaybe<Scalars['String']>;
  autoUpdateTrip?: InputMaybe<Scalars['Boolean']>;
  deliveredAt?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  id: Scalars['ID'];
  onsiteJobCompletedAt?: InputMaybe<Scalars['String']>;
  onsiteJobStartedAt?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  ptoOnComplete?: InputMaybe<Scalars['Float']>;
  ptoOnStart?: InputMaybe<Scalars['Float']>;
  quantitySecondary?: InputMaybe<Scalars['Float']>;
  removeDriver?: InputMaybe<Scalars['Boolean']>;
  removeTruck?: InputMaybe<Scalars['Boolean']>;
  returningAt?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  timeGapAfter?: InputMaybe<Scalars['Int']>;
  timeGapBefore?: InputMaybe<Scalars['Int']>;
  timeGapOnsite?: InputMaybe<Scalars['Int']>;
  truck?: InputMaybe<IdInput>;
};

/** Autogenerated return type of OrderTruckUpdate */
export type OrderTruckUpdatePayload = {
  __typename?: 'OrderTruckUpdatePayload';
  orderTruck?: Maybe<OrderTruck>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderUpdateAdditionalInfo */
export type OrderUpdateAdditionalInfoPayload = {
  __typename?: 'OrderUpdateAdditionalInfoPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderUpdateFlags */
export type OrderUpdateFlagsPayload = {
  __typename?: 'OrderUpdateFlagsPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderUpdateInput = {
  additional?: InputMaybe<Scalars['JSON']>;
  address?: InputMaybe<AddressInput>;
  adminNotes?: InputMaybe<Scalars['String']>;
  deliveries?: InputMaybe<Array<InputMaybe<IdInput>>>;
  deliveryDetails?: InputMaybe<Scalars['String']>;
  deliveryItems?: InputMaybe<Array<Array<OrderDeliveryItemInput>>>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  /**
   * assigns plant to order_truck
   *                                                                                with driver and truck
   */
  deliveryPlants?: InputMaybe<Array<InputMaybe<IdInput>>>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  deliveryTimes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryTrucks?: InputMaybe<Array<InputMaybe<IdInput>>>;
  deliveryWindow?: InputMaybe<Scalars['Int']>;
  desiredSlump?: InputMaybe<Scalars['Int']>;
  drivers?: InputMaybe<Array<InputMaybe<IdInput>>>;
  fees?: InputMaybe<Array<OrderFeePriceInput>>;
  id: Scalars['ID'];
  invoiceNotes?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<OrderOptionPriceInput>>;
  paymentMode?: InputMaybe<OrderPaymentModeEnum>;
  pickupTime?: InputMaybe<Scalars['String']>;
  priceMode?: InputMaybe<OrderPriceModeEnum>;
  product?: InputMaybe<ProductInput>;
  project?: InputMaybe<IdInput>;
  projectType?: InputMaybe<Scalars['String']>;
  purchaseNumber?: InputMaybe<Scalars['String']>;
  recalculateFees?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<OrderStateEnum>;
  timeBetweenTrucks?: InputMaybe<Scalars['Int']>;
  timeRequestedWithTruck?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  truckStatus?: InputMaybe<OrderTruckStatusEnum>;
  trucks?: InputMaybe<Array<Scalars['Float']>>;
  trucksSecondary?: InputMaybe<Array<Scalars['Float']>>;
  unloadingMethod?: InputMaybe<Scalars['String']>;
  unloadingMethodDetails?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of OrderUpdate */
export type OrderUpdatePayload = {
  __typename?: 'OrderUpdatePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type OrderValidateInput = {
  address: AddressInput;
  deliveryTime?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Array<IdInput>>;
  id?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<IdInput>>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  product: ProductInput;
  timeBetweenTrucks?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  trucks?: InputMaybe<Array<Scalars['Float']>>;
  trucksSecondary?: InputMaybe<Array<Scalars['Float']>>;
};

/** Autogenerated return type of OrderValidate */
export type OrderValidatePayload = {
  __typename?: 'OrderValidatePayload';
  errorReason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of OrderWaitingForPickup */
export type OrderWaitingForPickupPayload = {
  __typename?: 'OrderWaitingForPickupPayload';
  order?: Maybe<Order>;
  success: Scalars['Boolean'];
};

export type Partner = {
  __typename?: 'Partner';
  account?: Maybe<PartnerAccount>;
  address?: Maybe<Address>;
  appAndroidUrl: Scalars['String'];
  appConfigurations?: Maybe<PartnerAppConfigurationList>;
  appIosUrl: Scalars['String'];
  banner?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  config?: Maybe<PartnerConfig>;
  contractorAppAndroidBuild?: Maybe<Resource>;
  countryState: CountryStateInstance;
  description?: Maybe<Scalars['String']>;
  driverAppAndroidBuild?: Maybe<Resource>;
  driverAppAndroidUrl: Scalars['String'];
  driverAppIosUrl: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  hasApp: Scalars['Boolean'];
  hasCreditAccount: Scalars['Boolean'];
  id: Scalars['ID'];
  inviteContractorBanner?: Maybe<Scalars['String']>;
  inviteManagerBanner?: Maybe<Scalars['String']>;
  largeLogo?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mainAppVisible: Scalars['Boolean'];
  members?: Maybe<PartnerMemberList>;
  name?: Maybe<Scalars['String']>;
  onboarding?: Maybe<PartnerOnboarding>;
  /** [DEPRECATED] */
  paid: Scalars['Boolean'];
  permissions: Scalars['JSON'];
  phone?: Maybe<Scalars['String']>;
  plants?: Maybe<PlantList>;
  prettyIdPrefix?: Maybe<Scalars['String']>;
  productCategories?: Maybe<ProductCategoryList>;
  qrAppUrl?: Maybe<Scalars['String']>;
  qrDriverUrl?: Maybe<Scalars['String']>;
  shortCaption?: Maybe<Scalars['String']>;
  signatureConsentText?: Maybe<Scalars['String']>;
  subscription?: Maybe<PartnerSubscription>;
  suppliers?: Maybe<SupplierList>;
  taxes: Array<Fee>;
  termsAndConditions?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};


export type PartnerAppConfigurationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type PartnerMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PartnerPlantsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PartnerProductCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PartnerSuppliersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  balance: Scalars['Float'];
  currency: Scalars['String'];
  fundsAvailablePeriod?: Maybe<Scalars['Int']>;
  offlineBanks?: Maybe<Array<PartnerAccountBankRequisites>>;
  partner: Partner;
  paymentHandling?: Maybe<Scalars['String']>;
  payoutFeeAdminCoef?: Maybe<Scalars['Float']>;
  payoutFeeAppCoef?: Maybe<Scalars['Float']>;
  payoutFeeWebCoef?: Maybe<Scalars['Float']>;
  stripeOnboardingProgress?: Maybe<Scalars['String']>;
  transactions: PartnerAccountTransactionList;
};


export type PartnerAccountTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PartnerAccountBankRequisites = {
  __typename?: 'PartnerAccountBankRequisites';
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  bankNumber?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type PartnerAccountBankRequisitesInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  bankNumber?: InputMaybe<Scalars['String']>;
  routingNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PartnerAccountPayout */
export type PartnerAccountPayoutPayload = {
  __typename?: 'PartnerAccountPayoutPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerAccountRequestPayout */
export type PartnerAccountRequestPayoutPayload = {
  __typename?: 'PartnerAccountRequestPayoutPayload';
  success: Scalars['Boolean'];
};

export type PartnerAccountStatsConfig = {
  __typename?: 'PartnerAccountStatsConfig';
  fundsAvailablePeriod: Scalars['Int'];
  payoutFeeAdminCoef: Scalars['Float'];
  payoutFeeAppCoef: Scalars['Float'];
  payoutFeePartnerAppCoef: Scalars['Float'];
  payoutFeeWebCoef: Scalars['Float'];
};

export type PartnerAccountStatsInstance = {
  __typename?: 'PartnerAccountStatsInstance';
  admin: PartnerAccountStatsSource;
  app: PartnerAccountStatsSource;
  brokrete: PartnerAccountStatsSource;
  config: PartnerAccountStatsConfig;
  csvUrl?: Maybe<Scalars['String']>;
  partnerApp: PartnerAccountStatsSource;
  storefront: PartnerAccountStatsSource;
  total: PartnerAccountStatsValues;
  web: PartnerAccountStatsSource;
};

export type PartnerAccountStatsSource = {
  __typename?: 'PartnerAccountStatsSource';
  available: Scalars['Float'];
  graph: Array<Scalars['JSON']>;
  readyForPayout: Scalars['Float'];
  total: Scalars['Float'];
  totalByAccount: Scalars['Float'];
};

export type PartnerAccountStatsValues = {
  __typename?: 'PartnerAccountStatsValues';
  available: Scalars['Float'];
  readyForPayout: Scalars['Float'];
  total: Scalars['Float'];
  totalByAccount: Scalars['Float'];
};

/** Autogenerated return type of PartnerAccountStripeOnboarding */
export type PartnerAccountStripeOnboardingPayload = {
  __typename?: 'PartnerAccountStripeOnboardingPayload';
  success: Scalars['Boolean'];
  url: Scalars['String'];
};

export type PartnerAccountTransactionInstance = {
  __typename?: 'PartnerAccountTransactionInstance';
  amount: Scalars['Float'];
  financeAccount: FinanceAccount;
  order?: Maybe<Order>;
  partnerAccount: PartnerAccount;
  payoutAvailableAt?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
};

export type PartnerAccountTransactionList = {
  __typename?: 'PartnerAccountTransactionList';
  count: Scalars['Int'];
  values: Array<PartnerAccountTransactionInstance>;
};

export type PartnerAppConfigurationInstance = {
  __typename?: 'PartnerAppConfigurationInstance';
  buildNumber?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  platform?: Maybe<Scalars['String']>;
  releaseBuildNumber?: Maybe<Scalars['String']>;
  releaseVersion?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PartnerAppConfigurationList = {
  __typename?: 'PartnerAppConfigurationList';
  count: Scalars['Int'];
  values: Array<PartnerAppConfigurationInstance>;
};

export type PartnerClientConfigInstance = {
  __typename?: 'PartnerClientConfigInstance';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PartnerClientConfigList = {
  __typename?: 'PartnerClientConfigList';
  count: Scalars['Int'];
  values: Array<PartnerClientConfigInstance>;
};

export type PartnerClientTipDetails = {
  __typename?: 'PartnerClientTipDetails';
  height: Scalars['String'];
  width: Scalars['String'];
};

export type PartnerClientTipInstance = {
  __typename?: 'PartnerClientTipInstance';
  details: PartnerClientTipDetails;
  id: Scalars['String'];
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PartnerConfig = {
  __typename?: 'PartnerConfig';
  notificationEmail?: Maybe<Scalars['String']>;
  notificationPhone?: Maybe<Scalars['String']>;
  oneSignalApiKey?: Maybe<Scalars['String']>;
  oneSignalAppId?: Maybe<Scalars['String']>;
  serviceEmail?: Maybe<Scalars['String']>;
  servicePhone?: Maybe<Scalars['String']>;
  slackBilldWebhookUrl?: Maybe<Scalars['String']>;
  slackOrderWebhookUrl?: Maybe<Scalars['String']>;
};

export type PartnerConfigInput = {
  notificationEmail?: InputMaybe<Scalars['String']>;
  notificationPhone?: InputMaybe<Scalars['String']>;
  oneSignalApiKey?: InputMaybe<Scalars['String']>;
  oneSignalAppId?: InputMaybe<Scalars['String']>;
  slackBilldWebhookUrl?: InputMaybe<Scalars['String']>;
  slackOrderWebhookUrl?: InputMaybe<Scalars['String']>;
};

export type PartnerContractor = {
  __typename?: 'PartnerContractor';
  accountInfo?: Maybe<Scalars['String']>;
  accountStatus: PartnerContractorAccountStatusEnum;
  billdStatus: PartnerContractorBilldStatusEnum;
  contractor: Contractor;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  locked?: Maybe<Scalars['Boolean']>;
  onboardingCompleted: Scalars['Boolean'];
  owner: Scalars['Boolean'];
  partner: Partner;
  priceAdded: Scalars['Boolean'];
  priceDetails: PartnerContractorPriceDetails;
  priceMode: Scalars['String'];
  priceStatus: PartnerContractorPriceStatusEnum;
  selected: Scalars['Boolean'];
  source: PartnerContractorSourceEnum;
  sourceString?: Maybe<Scalars['String']>;
  status: PartnerContractorStatusEnum;
  statusChangedAt: Scalars['String'];
};

/** Autogenerated return type of PartnerContractorAccept */
export type PartnerContractorAcceptPayload = {
  __typename?: 'PartnerContractorAcceptPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerContractorAccountRequest */
export type PartnerContractorAccountRequestPayload = {
  __typename?: 'PartnerContractorAccountRequestPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export enum PartnerContractorAccountStatusEnum {
  Accepted = 'accepted',
  None = 'none',
  RequestExisted = 'request_existed',
  RequestNew = 'request_new'
}

/** Autogenerated return type of PartnerContractorBilldRequest */
export type PartnerContractorBilldRequestPayload = {
  __typename?: 'PartnerContractorBilldRequestPayload';
  success: Scalars['Boolean'];
};

export enum PartnerContractorBilldStatusEnum {
  Accepted = 'accepted',
  None = 'none',
  Rejected = 'rejected',
  Requested = 'requested'
}

/** Autogenerated return type of PartnerContractorCancel */
export type PartnerContractorCancelPayload = {
  __typename?: 'PartnerContractorCancelPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export type PartnerContractorConnectInput = {
  accountInfo?: InputMaybe<Scalars['String']>;
  partner: IdInput;
};

/** Autogenerated return type of PartnerContractorConnect */
export type PartnerContractorConnectPayload = {
  __typename?: 'PartnerContractorConnectPayload';
  partnerContractors: Array<PartnerContractor>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerContractorDeletePrices */
export type PartnerContractorDeletePricesPayload = {
  __typename?: 'PartnerContractorDeletePricesPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export type PartnerContractorInput = {
  country?: InputMaybe<IdInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PartnerContractorInviteInput = {
  accountingEmail?: InputMaybe<Scalars['String']>;
  billingAddressNew?: InputMaybe<AddressInput>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddressNew?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companySize?: InputMaybe<Scalars['String']>;
  contractorType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<IdInput>;
  creditAccount?: InputMaybe<Scalars['Boolean']>;
  creditLimit?: InputMaybe<Scalars['Float']>;
  customField1?: InputMaybe<Scalars['String']>;
  customField2?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  exportCode?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  manager1Email?: InputMaybe<Scalars['String']>;
  manager1Name?: InputMaybe<Scalars['String']>;
  manager1Phone?: InputMaybe<Scalars['String']>;
  manager2Email?: InputMaybe<Scalars['String']>;
  manager2Name?: InputMaybe<Scalars['String']>;
  manager2Phone?: InputMaybe<Scalars['String']>;
  manager3Email?: InputMaybe<Scalars['String']>;
  manager3Name?: InputMaybe<Scalars['String']>;
  manager3Phone?: InputMaybe<Scalars['String']>;
  manager4Email?: InputMaybe<Scalars['String']>;
  manager4Name?: InputMaybe<Scalars['String']>;
  manager4Phone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  priceGroup?: InputMaybe<PriceGroupEnum>;
  secondaryEmail?: InputMaybe<Scalars['String']>;
  secondaryPhone?: InputMaybe<Scalars['String']>;
  skipInviteEmail?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of PartnerContractorInvite */
export type PartnerContractorInvitePayload = {
  __typename?: 'PartnerContractorInvitePayload';
  contractors?: Maybe<Array<Contractor>>;
  job?: Maybe<JobStatus>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerContractorInviteResend */
export type PartnerContractorInviteResendPayload = {
  __typename?: 'PartnerContractorInviteResendPayload';
  success: Scalars['Boolean'];
};

export type PartnerContractorList = {
  __typename?: 'PartnerContractorList';
  count: Scalars['Int'];
  values: Array<PartnerContractor>;
};

/** Autogenerated return type of PartnerContractorPriceAdded */
export type PartnerContractorPriceAddedPayload = {
  __typename?: 'PartnerContractorPriceAddedPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export type PartnerContractorPriceDetails = {
  __typename?: 'PartnerContractorPriceDetails';
  groups: Scalars['Int'];
  personal: Scalars['Int'];
};

/** Autogenerated return type of PartnerContractorPriceRequest */
export type PartnerContractorPriceRequestPayload = {
  __typename?: 'PartnerContractorPriceRequestPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export enum PartnerContractorPriceStatusEnum {
  Done = 'done',
  None = 'none',
  Pending = 'pending'
}

/** Autogenerated return type of PartnerContractorQuoteRequest */
export type PartnerContractorQuoteRequestPayload = {
  __typename?: 'PartnerContractorQuoteRequestPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerContractorReject */
export type PartnerContractorRejectPayload = {
  __typename?: 'PartnerContractorRejectPayload';
  partnerContractor?: Maybe<PartnerContractor>;
  success: Scalars['Boolean'];
};

export enum PartnerContractorSourceEnum {
  AccountRequest = 'account_request',
  Invite = 'invite',
  Order = 'order',
  PriceRequest = 'price_request',
  QuoteRequest = 'quote_request',
  Signup = 'signup'
}

export enum PartnerContractorStatusEnum {
  Accepted = 'accepted',
  Disabled = 'disabled',
  Incoming = 'incoming',
  Rejected = 'rejected'
}

/** Autogenerated return type of PartnerContractorUpdate */
export type PartnerContractorUpdatePayload = {
  __typename?: 'PartnerContractorUpdatePayload';
  partnerContractor: PartnerContractor;
  success: Scalars['Boolean'];
};

export type PartnerContractorsInput = {
  add?: InputMaybe<Array<PartnerContractorInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PartnerCreateInput = {
  address?: InputMaybe<AddressInput>;
  code: Scalars['String'];
  countryState: IdInput;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  logo?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PartnerCreate */
export type PartnerCreatePayload = {
  __typename?: 'PartnerCreatePayload';
  partner?: Maybe<Partner>;
  success: Scalars['Boolean'];
};

export type PartnerDriver = {
  __typename?: 'PartnerDriver';
  driver: Driver;
  partner: Partner;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
};

export type PartnerDriverInviteInput = {
  city?: InputMaybe<IdInput>;
  color?: InputMaybe<Scalars['String']>;
  driverType?: InputMaybe<DriverTypeEnum>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type PartnerDriverInviteList = {
  __typename?: 'PartnerDriverInviteList';
  driver?: Maybe<Driver>;
  invite?: Maybe<Invite>;
};

/** Autogenerated return type of PartnerDriverInvite */
export type PartnerDriverInvitePayload = {
  __typename?: 'PartnerDriverInvitePayload';
  success: Scalars['Boolean'];
  values: Array<PartnerDriverInviteList>;
};

export type PartnerDriverList = {
  __typename?: 'PartnerDriverList';
  count: Scalars['Int'];
  values: Array<PartnerDriver>;
};

export enum PartnerDriverSourceEnum {
  Invite = 'invite',
  Signup = 'signup'
}

export enum PartnerDriverStatusEnum {
  Accepted = 'accepted',
  Disabled = 'disabled',
  Incoming = 'incoming',
  Rejected = 'rejected'
}

export type PartnerDriversInput = {
  add?: InputMaybe<Array<IdInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PartnerFinance = {
  __typename?: 'PartnerFinance';
  amount: Scalars['Float'];
  autoCollect?: Maybe<Scalars['String']>;
  availableActions: Array<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creditStatus?: Maybe<Scalars['String']>;
  creditTerm?: Maybe<Scalars['Int']>;
  creditTermAmount: Scalars['Float'];
  currency: Scalars['String'];
  exported?: Maybe<Scalars['Boolean']>;
  getPaid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiced?: Maybe<Scalars['Boolean']>;
  linkedPayouts?: Maybe<Array<PartnerPayoutInstance>>;
  offline?: Maybe<Scalars['Boolean']>;
  order: Order;
  origin?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  partner: Partner;
  payout?: Maybe<Scalars['Float']>;
  payoutFeeAmount?: Maybe<Scalars['Float']>;
  payoutFeeTax?: Maybe<Scalars['Float']>;
  payoutMode: Scalars['String'];
  payoutRate: Scalars['Float'];
  platformFee?: Maybe<Scalars['Float']>;
  processingFeeAmount?: Maybe<Scalars['Float']>;
  processingFeeTax?: Maybe<Scalars['Float']>;
  processingRate: Scalars['Float'];
  source: Scalars['String'];
  status: Scalars['String'];
};

export type PartnerFinanceAccountList = {
  __typename?: 'PartnerFinanceAccountList';
  count: Scalars['Int'];
  values: Array<FinanceAccount>;
};

export type PartnerFinanceList = {
  __typename?: 'PartnerFinanceList';
  count: Scalars['Int'];
  values: Array<PartnerFinance>;
};

/** Autogenerated return type of PartnerFinanceSetExported */
export type PartnerFinanceSetExportedPayload = {
  __typename?: 'PartnerFinanceSetExportedPayload';
  partnerFinance?: Maybe<PartnerFinance>;
  partnerFinances?: Maybe<Array<PartnerFinance>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerFinanceSetInvoiced */
export type PartnerFinanceSetInvoicedPayload = {
  __typename?: 'PartnerFinanceSetInvoicedPayload';
  partnerFinance: PartnerFinance;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerFinanceSetPaidOrCollect */
export type PartnerFinanceSetPaidOrCollectPayload = {
  __typename?: 'PartnerFinanceSetPaidOrCollectPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerFinanceSetPaid */
export type PartnerFinanceSetPaidPayload = {
  __typename?: 'PartnerFinanceSetPaidPayload';
  partnerFinance: PartnerFinance;
  success: Scalars['Boolean'];
};

export type PartnerList = {
  __typename?: 'PartnerList';
  availableCategories: Array<ProductCategory>;
  count: Scalars['Int'];
  values: Array<Partner>;
};

export type PartnerMember = {
  __typename?: 'PartnerMember';
  active: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identities: Array<Identity>;
  identity?: Maybe<Identity>;
  name: Scalars['String'];
  partner: Partner;
  role: Scalars['String'];
  roles?: Maybe<Array<Role>>;
  status?: Maybe<Scalars['String']>;
  statusChangedAt?: Maybe<Scalars['String']>;
  workingTimezone?: Maybe<Scalars['String']>;
};

export type PartnerMemberCreateInput = {
  member: MemberInput;
  partner: IdInput;
  roles?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of PartnerMemberCreate */
export type PartnerMemberCreatePayload = {
  __typename?: 'PartnerMemberCreatePayload';
  member: PartnerMember;
  success: Scalars['Boolean'];
};

export type PartnerMemberList = {
  __typename?: 'PartnerMemberList';
  count: Scalars['Int'];
  values: Array<PartnerMember>;
};

/** Autogenerated return type of PartnerMemberRemove */
export type PartnerMemberRemovePayload = {
  __typename?: 'PartnerMemberRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerMemberResetPassword */
export type PartnerMemberResetPasswordPayload = {
  __typename?: 'PartnerMemberResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerMemberUpdate */
export type PartnerMemberUpdatePayload = {
  __typename?: 'PartnerMemberUpdatePayload';
  member: PartnerMember;
  success: Scalars['Boolean'];
};

export type PartnerOnboarding = {
  __typename?: 'PartnerOnboarding';
  status?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['String']>;
};

export type PartnerPayoutInstance = {
  __typename?: 'PartnerPayoutInstance';
  amount: Scalars['Float'];
  availableActions: Array<Scalars['String']>;
  availableForExport: Scalars['Boolean'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  externalLink?: Maybe<Scalars['String']>;
  financeAccount?: Maybe<FinanceAccount>;
  finances: Array<PartnerFinance>;
  id: Scalars['ID'];
  number: Scalars['ID'];
  paidOutAt?: Maybe<Scalars['String']>;
  partner: Partner;
  prettyId: Scalars['String'];
  status: Scalars['String'];
  transactions: Array<PartnerPayoutTransactionInstance>;
  updatedAt: Scalars['String'];
  warning: Scalars['Boolean'];
};

export type PartnerPayoutList = {
  __typename?: 'PartnerPayoutList';
  count: Scalars['Int'];
  values: Array<PartnerPayoutInstance>;
};

export type PartnerPayoutTransactionInstance = {
  __typename?: 'PartnerPayoutTransactionInstance';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  feeAmount: Scalars['Float'];
  transaction?: Maybe<Transaction>;
  type: Scalars['String'];
};

export type PartnerProductCategoriesInput = {
  add?: InputMaybe<Array<PartnerProductCategoryInput>>;
  change?: InputMaybe<Array<PartnerProductCategoryInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PartnerProductCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type PartnerProductTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type PartnerProductTypesInput = {
  add?: InputMaybe<Array<PartnerProductTypeInput>>;
  change?: InputMaybe<Array<PartnerProductTypeInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PartnerStatus = {
  __typename?: 'PartnerStatus';
  allProductsAvailableInTheStore: Scalars['Json'];
  allProductsHavePrices: Scalars['Json'];
  countLocation: Scalars['Json'];
  countProductsAdded: Scalars['Json'];
  firstOrderPaidWithCc: Scalars['Json'];
  firstOrderPlaced: Scalars['Json'];
  firstPayoutReceived: Scalars['Json'];
  notAvailableProducts: Scalars['Json'];
  quickbooksConnectStatusWithButtonFix: Scalars['Json'];
  stripeConnectStatusWithButtonFix: Scalars['Json'];
};

export type PartnerSubscription = {
  __typename?: 'PartnerSubscription';
  createdAt: Scalars['ISO8601DateTime'];
  currentPeriodEndAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentPeriodStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentPeriodUsage: Scalars['Int'];
  financeAccount: FinanceAccount;
  id: Scalars['ID'];
  invoices?: Maybe<PartnerSubscriptionInvoiceList>;
  lastPeriodUsage: Scalars['Int'];
  partner: Partner;
  paymentMethod?: Maybe<PaymentMethod>;
  subscription: SubscriptionInstance;
  ticketsIncluded?: Maybe<Scalars['Int']>;
};


export type PartnerSubscriptionInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PartnerSubscriptionInvoice = {
  __typename?: 'PartnerSubscriptionInvoice';
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  invoicePdfUrl?: Maybe<Scalars['String']>;
  partnerSubscription: PartnerSubscription;
  status: Scalars['String'];
  ticketsIncluded?: Maybe<Scalars['Int']>;
};

export type PartnerSubscriptionInvoiceList = {
  __typename?: 'PartnerSubscriptionInvoiceList';
  count: Scalars['Int'];
  values: Array<PartnerSubscriptionInvoice>;
};

export type PartnerSubscriptionUpdateInput = {
  id: Scalars['ID'];
  paymentMethod?: InputMaybe<IdInput>;
};

/** Autogenerated return type of PartnerSubscriptionUpdate */
export type PartnerSubscriptionUpdatePayload = {
  __typename?: 'PartnerSubscriptionUpdatePayload';
  partnerSubscription?: Maybe<PartnerSubscription>;
  success: Scalars['Boolean'];
};

export type PartnerSuppliersInput = {
  add?: InputMaybe<Array<IdInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PartnerTax = {
  __typename?: 'PartnerTax';
  countryState?: Maybe<CountryStateInstance>;
  fee: Fee;
  id: Scalars['ID'];
  internal: Scalars['Boolean'];
  system: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type PartnerTaxCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  countryState?: InputMaybe<IdInput>;
  displayName?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<IdInput>;
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of PartnerTaxCreate */
export type PartnerTaxCreatePayload = {
  __typename?: 'PartnerTaxCreatePayload';
  partnerTax?: Maybe<PartnerTax>;
  success: Scalars['Boolean'];
};

export type PartnerTaxList = {
  __typename?: 'PartnerTaxList';
  count: Scalars['Int'];
  values: Array<PartnerTax>;
};

/** Autogenerated return type of PartnerTaxRemove */
export type PartnerTaxRemovePayload = {
  __typename?: 'PartnerTaxRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerTaxToggleAvalara */
export type PartnerTaxToggleAvalaraPayload = {
  __typename?: 'PartnerTaxToggleAvalaraPayload';
  success: Scalars['Boolean'];
};

export type PartnerTaxUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  countryState?: InputMaybe<IdInput>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of PartnerTaxUpdate */
export type PartnerTaxUpdatePayload = {
  __typename?: 'PartnerTaxUpdatePayload';
  partnerTax?: Maybe<PartnerTax>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PartnerTaxZeroOut */
export type PartnerTaxZeroOutPayload = {
  __typename?: 'PartnerTaxZeroOutPayload';
  success: Scalars['Boolean'];
};

export type PartnerUpdateInput = {
  address?: InputMaybe<AddressInput>;
  allowCreditCard?: InputMaybe<Scalars['Boolean']>;
  allowOffline?: InputMaybe<Scalars['Boolean']>;
  banner?: InputMaybe<Scalars['Upload']>;
  caption?: InputMaybe<Scalars['String']>;
  clearBanner?: InputMaybe<Scalars['Boolean']>;
  clearLargeLogo?: InputMaybe<Scalars['Boolean']>;
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<PartnerConfigInput>;
  contractors?: InputMaybe<PartnerContractorsInput>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  drivers?: InputMaybe<PartnerDriversInput>;
  email?: InputMaybe<Scalars['String']>;
  fundsAvailablePeriod?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  inviteContractorBanner?: InputMaybe<Scalars['Upload']>;
  inviteManagerBanner?: InputMaybe<Scalars['Upload']>;
  largeLogo?: InputMaybe<Scalars['Upload']>;
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  offlineBanks?: InputMaybe<Array<PartnerAccountBankRequisitesInput>>;
  payoutFeeAdminCoef?: InputMaybe<Scalars['Float']>;
  payoutFeeAppCoef?: InputMaybe<Scalars['Float']>;
  payoutFeePartnerAppCoef?: InputMaybe<Scalars['Float']>;
  payoutFeeWebCoef?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  prettyIdPrefix?: InputMaybe<Scalars['String']>;
  productCategories?: InputMaybe<PartnerProductCategoriesInput>;
  productTypes?: InputMaybe<PartnerProductTypesInput>;
  serviceEmail?: InputMaybe<Scalars['String']>;
  servicePhone?: InputMaybe<Scalars['String']>;
  shortCaption?: InputMaybe<Scalars['String']>;
  signatureConsentText?: InputMaybe<Scalars['String']>;
  suppliers?: InputMaybe<PartnerSuppliersInput>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PartnerUpdate */
export type PartnerUpdatePayload = {
  __typename?: 'PartnerUpdatePayload';
  partner?: Maybe<Partner>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PaymentCreate */
export type PaymentCreatePayload = {
  __typename?: 'PaymentCreatePayload';
  success: Scalars['Boolean'];
};

export type PaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  cardInfo?: InputMaybe<CardInfoInput>;
  currency?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<IdInput>;
  /** Stripe PM id */
  paymentMethodId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  active: Scalars['Boolean'];
  amount?: Maybe<Scalars['Float']>;
  availableActions: Array<Scalars['String']>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  groupedPayment?: Maybe<PaymentLink>;
  id: Scalars['ID'];
  mode: Scalars['String'];
  order?: Maybe<Order>;
  paymentLink?: Maybe<PaymentLink>;
  paymentTransaction?: Maybe<Transaction>;
  prettyId: Scalars['String'];
  processingAmount?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  statusChangedAt?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  amount: Scalars['Float'];
  contractor?: Maybe<Contractor>;
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  expiredAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items: Array<PaymentIntent>;
  link?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  paymentMethods?: Maybe<Array<PaymentLinkPaymentMethodInstance>>;
  paymentTransaction?: Maybe<Transaction>;
  paymentType: Scalars['String'];
  prettyId?: Maybe<Scalars['String']>;
  processingAmount?: Maybe<Scalars['Float']>;
  processingFees?: Maybe<Array<PaymentLinkProcessingFeeInstance>>;
  status: Scalars['String'];
  statusChangedAt: Scalars['String'];
  testMode: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};


export type PaymentLinkProcessingFeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PaymentLinkCancel */
export type PaymentLinkCancelPayload = {
  __typename?: 'PaymentLinkCancelPayload';
  paymentLink?: Maybe<PaymentLink>;
  success: Scalars['Boolean'];
};

export type PaymentLinkCreateInput = {
  orders: Array<IdInput>;
};

/** Autogenerated return type of PaymentLinkCreate */
export type PaymentLinkCreatePayload = {
  __typename?: 'PaymentLinkCreatePayload';
  paymentLink?: Maybe<PaymentLink>;
  success: Scalars['Boolean'];
};

export type PaymentLinkList = {
  __typename?: 'PaymentLinkList';
  count: Scalars['Int'];
  values: Array<PaymentLink>;
};

/** Autogenerated return type of PaymentLinkPay */
export type PaymentLinkPayPayload = {
  __typename?: 'PaymentLinkPayPayload';
  clientSecret?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['JSON']>;
  paymentLink?: Maybe<PaymentLink>;
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type PaymentLinkPaymentMethodInstance = {
  __typename?: 'PaymentLinkPaymentMethodInstance';
  paymentMethod: PaymentMethod;
  processingFee?: Maybe<PaymentLinkProcessingFeeInstance>;
};

export type PaymentLinkProcessingFeeInstance = {
  __typename?: 'PaymentLinkProcessingFeeInstance';
  conditionsDescription: Array<Scalars['String']>;
  fee?: Maybe<Fee>;
  value?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of PaymentLinkSend */
export type PaymentLinkSendPayload = {
  __typename?: 'PaymentLinkSendPayload';
  success: Scalars['Boolean'];
};

export enum PaymentLinkStatusEnum {
  Canceled = 'canceled',
  Error = 'error',
  InTransit = 'in_transit',
  New = 'new',
  Success = 'success'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  account?: Maybe<ContractorAccount>;
  bankAccount?: Maybe<ContractorBankAccount>;
  card?: Maybe<PaymentMethodCard>;
  id?: Maybe<Scalars['ID']>;
  paymentErrors?: Maybe<Array<OrderPaymentError>>;
  possibleProcessingFee?: Maybe<ProcessingFeeInstance>;
  provider?: Maybe<Scalars['String']>;
  requiresAction?: Maybe<Scalars['JSON']>;
};


export type PaymentMethodPossibleProcessingFeeArgs = {
  partner?: InputMaybe<IdInput>;
  target: Scalars['String'];
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  funding?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last4?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PaymentMethodCardInput = {
  brand?: InputMaybe<Scalars['String']>;
  cardholderName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['Int']>;
  expYear?: InputMaybe<Scalars['Int']>;
  last4?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['JSON']>;
  uid?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PaymentMethodPrepare */
export type PaymentMethodPreparePayload = {
  __typename?: 'PaymentMethodPreparePayload';
  data: Scalars['JSON'];
  success: Scalars['Boolean'];
};

export enum PaymentMethodProviderEnum {
  Eway = 'eway',
  Stripe = 'stripe',
  StripeB2bUs = 'stripe_b2b_us'
}

/** Autogenerated return type of PaymentMethodSave */
export type PaymentMethodSavePayload = {
  __typename?: 'PaymentMethodSavePayload';
  paymentMethod: PaymentMethod;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PaymentPrepareCard */
export type PaymentPrepareCardPayload = {
  __typename?: 'PaymentPrepareCardPayload';
  card: Scalars['JSON'];
  success: Scalars['Boolean'];
};

export enum PayoutStatusEnum {
  Canceled = 'canceled',
  Failed = 'failed',
  InTransit = 'in_transit',
  Paid = 'paid',
  Pending = 'pending',
  Processing = 'processing',
  Success = 'success'
}

export type Plant = {
  __typename?: 'Plant';
  address: Address;
  city: City;
  color: Scalars['String'];
  customFields?: Maybe<Array<PlantCustomField>>;
  deliveryMethods: Array<PlantDeliveryMethod>;
  deliveryMethodsP: PlantDeliveryMethodList;
  deliveryRadius: Scalars['Float'];
  deliveryRadiusUnit?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discounts: Array<PlantDiscount>;
  email?: Maybe<Scalars['String']>;
  feePrices: PlantFeePricesList;
  fees: PlantFeesList;
  id: Scalars['ID'];
  image?: Maybe<Resource>;
  inventories: InventoryList;
  invoiceAddress?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  openHours?: Maybe<Array<Array<Scalars['Float']>>>;
  optionPrices: Array<OptionPrice>;
  optionPricesP: OptionPricePaginatedList;
  options: PlantOptionList;
  phone?: Maybe<Scalars['String']>;
  pickup?: Maybe<Scalars['Boolean']>;
  prettyIdPrefix?: Maybe<Scalars['String']>;
  productCategories: Array<ProductCategory>;
  productDecoratePrices: Array<ProductDecoratePrice>;
  productDecoratePricesP: ProductDecoratePricePaginatedList;
  productDecorates: PlantProductDecorateList;
  productTypePrices: Array<ProductTypePrice>;
  productTypePricesP: ProductTypePricePaginatedList;
  productTypes: PlantProductTypeList;
  serviceName: Scalars['String'];
  settings: PlantSettings;
  supplier: Supplier;
  timezone: Scalars['String'];
};


export type PlantDeliveryMethodsArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantDeliveryMethodsPArgs = {
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantDiscountsArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantFeePricesArgs = {
  category?: InputMaybe<IdInput>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<FeeTypeEnum>>;
  withPossiblePrices?: InputMaybe<Scalars['Boolean']>;
};


export type PlantFeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<FeeTypeEnum>>;
};


export type PlantInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantOptionPricesArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
};


export type PlantOptionPricesPArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantOptionsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<IdInput>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantPickupArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantProductDecoratePricesArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
};


export type PlantProductDecoratePricesPArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantProductDecoratesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<IdInput>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantProductTypePricesArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
};


export type PlantProductTypePricesPArgs = {
  category?: InputMaybe<IdInput>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PlantProductTypesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<IdInput>;
  enabledForFee?: InputMaybe<IdInput>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  notEnabledForFee?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PlantByCategory = {
  __typename?: 'PlantByCategory';
  category: ProductCategory;
  count: Scalars['Int'];
};

export type PlantCluster = {
  __typename?: 'PlantCluster';
  count: Scalars['Int'];
  countByCategory: Array<PlantClusterByCategory>;
  countBySupplier: Array<PlantClusterBySupplier>;
  id: Scalars['ID'];
  location: Location;
  value?: Maybe<Plant>;
  values: Array<PlantClusterValue>;
};

export type PlantClusterByCategory = {
  __typename?: 'PlantClusterByCategory';
  category: ProductCategory;
  count: Scalars['Int'];
};

export type PlantClusterBySupplier = {
  __typename?: 'PlantClusterBySupplier';
  count: Scalars['Int'];
  supplier: Supplier;
};

export type PlantClusterValue = {
  __typename?: 'PlantClusterValue';
  id: Scalars['ID'];
  location: Location;
  name: Scalars['String'];
};

export type PlantConfigInstance = {
  __typename?: 'PlantConfigInstance';
  deliveryMethod: DeliveryMethod;
  id: Scalars['ID'];
  pickup: Scalars['Boolean'];
  plant: Plant;
  product: ProductCategory;
  selfPickup: Scalars['Boolean'];
};

export type PlantCountByGroup = {
  __typename?: 'PlantCountByGroup';
  count: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
};

export type PlantCreateInput = {
  address: AddressInput;
  city: IdInput;
  color?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<PlantCustomFieldInput>>;
  deliveryRadius: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<ResourceInput>;
  invoiceAddress?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openHours?: InputMaybe<Array<Array<Scalars['Float']>>>;
  phone?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of PlantCreate */
export type PlantCreatePayload = {
  __typename?: 'PlantCreatePayload';
  plant?: Maybe<Plant>;
  success: Scalars['Boolean'];
};

export type PlantCustomField = {
  __typename?: 'PlantCustomField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PlantCustomFieldInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PlantDeliveryMethod = {
  __typename?: 'PlantDeliveryMethod';
  category: ProductCategory;
  deliveryMethod: DeliveryMethod;
};

export type PlantDeliveryMethodList = {
  __typename?: 'PlantDeliveryMethodList';
  count: Scalars['Int'];
  values: Array<PlantDeliveryMethod>;
};

/** Autogenerated return type of PlantDeliveryMethodRemove */
export type PlantDeliveryMethodRemovePayload = {
  __typename?: 'PlantDeliveryMethodRemovePayload';
  success: Scalars['Boolean'];
};

export type PlantDeliveryMethodsInput = {
  category: IdInput;
  values: Array<IdInput>;
};

export type PlantDiscount = {
  __typename?: 'PlantDiscount';
  amount: Scalars['Float'];
  discount: Scalars['Float'];
  product: ProductCategory;
};

export type PlantDiscountInput = {
  product: IdInput;
  values: Array<PlantDiscountItemInput>;
};

export type PlantDiscountItemInput = {
  amount: Scalars['Float'];
  discount: Scalars['Float'];
};

export type PlantDriverInput = {
  add?: InputMaybe<Array<PlantDriverItemInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type PlantDriverItemInput = {
  id: Scalars['ID'];
};

export type PlantFeeDeleteInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlantFeeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlantFeePrice = {
  __typename?: 'PlantFeePrice';
  fee: Fee;
  permissions: FeePricePermissions;
  prices: Array<FeePrice>;
};

export type PlantFeePriceDeleteInput = {
  contractor?: InputMaybe<IdInput>;
  fee?: InputMaybe<IdInput>;
  id?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<IdInput>;
};

export type PlantFeePriceUpdateInput = {
  contractor?: InputMaybe<IdInput>;
  fee: IdInput;
  group?: InputMaybe<Scalars['String']>;
  price: PriceInput;
  product?: InputMaybe<IdInput>;
};

export type PlantFeePricesInput = {
  change?: InputMaybe<Array<PlantFeePriceUpdateInput>>;
  remove?: InputMaybe<Array<PlantFeePriceDeleteInput>>;
};

export type PlantFeePricesList = {
  __typename?: 'PlantFeePricesList';
  count: Scalars['Int'];
  groups: Array<Scalars['String']>;
  values: Array<PlantFeePrice>;
};

export type PlantFeesInput = {
  add?: InputMaybe<Array<PlantFeeInput>>;
  change?: InputMaybe<Array<PlantFeeInput>>;
  remove?: InputMaybe<Array<PlantFeeDeleteInput>>;
};

export type PlantFeesInstance = {
  __typename?: 'PlantFeesInstance';
  active: Scalars['Boolean'];
  fee: Fee;
};

export type PlantFeesList = {
  __typename?: 'PlantFeesList';
  count: Scalars['Int'];
  values: Array<PlantFeesInstance>;
};

export type PlantInventoryList = {
  __typename?: 'PlantInventoryList';
  plant: Plant;
  quantity?: Maybe<Scalars['Int']>;
};

export type PlantList = {
  __typename?: 'PlantList';
  clusters: Array<PlantCluster>;
  count: Scalars['Int'];
  countByCategory: Array<PlantByCategory>;
  navigation?: Maybe<PlantNavigation>;
  values: Array<Plant>;
};


export type PlantListClustersArgs = {
  precision: Scalars['Float'];
};


export type PlantListNavigationArgs = {
  plant: IdInput;
};

export type PlantNavigation = {
  __typename?: 'PlantNavigation';
  next?: Maybe<Plant>;
  position?: Maybe<Scalars['Int']>;
  prev?: Maybe<Plant>;
};

export type PlantOptionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlantOptionInstance = {
  __typename?: 'PlantOptionInstance';
  active: Scalars['Boolean'];
  option: Option;
};

export type PlantOptionList = {
  __typename?: 'PlantOptionList';
  count: Scalars['Int'];
  countByGroup: Array<PlantCountByGroup>;
  groups: Array<Scalars['String']>;
  values: Array<PlantOptionInstance>;
};

export type PlantOptionsInput = {
  add?: InputMaybe<Array<PlantOptionInput>>;
  change?: InputMaybe<Array<PlantOptionInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of PlantProductCreate */
export type PlantProductCreatePayload = {
  __typename?: 'PlantProductCreatePayload';
  success: Scalars['Boolean'];
};

export type PlantProductDecorate = {
  __typename?: 'PlantProductDecorate';
  active: Scalars['Boolean'];
  productDecorate: ProductDecorate;
};

export type PlantProductDecorateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlantProductDecorateList = {
  __typename?: 'PlantProductDecorateList';
  count: Scalars['Int'];
  countByGroup: Array<PlantCountByGroup>;
  groups: Array<Scalars['String']>;
  values: Array<PlantProductDecorate>;
};

export type PlantProductDecoratesInput = {
  add?: InputMaybe<Array<PlantProductDecorateInput>>;
  change?: InputMaybe<Array<PlantProductDecorateInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of PlantProductDelete */
export type PlantProductDeletePayload = {
  __typename?: 'PlantProductDeletePayload';
  success: Scalars['Boolean'];
};

export type PlantProductList = {
  __typename?: 'PlantProductList';
  count: Scalars['Int'];
  values: Array<ProductCategory>;
};

export type PlantProductType = {
  __typename?: 'PlantProductType';
  active: Scalars['Boolean'];
  productType: ProductType;
};

export type PlantProductTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type PlantProductTypeList = {
  __typename?: 'PlantProductTypeList';
  count: Scalars['Int'];
  countByGroup: Array<PlantCountByGroup>;
  groups: Array<Scalars['String']>;
  values: Array<PlantProductType>;
};

export type PlantProductTypesInput = {
  add?: InputMaybe<Array<PlantProductTypeInput>>;
  change?: InputMaybe<Array<PlantProductTypeInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of PlantProductUpdate */
export type PlantProductUpdatePayload = {
  __typename?: 'PlantProductUpdatePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PlantRemove */
export type PlantRemovePayload = {
  __typename?: 'PlantRemovePayload';
  success: Scalars['Boolean'];
};

export type PlantSettings = {
  __typename?: 'PlantSettings';
  availabilityTimes: Array<PlantSettingsAvailabilityTimes>;
  booking: Array<PlantSettingsBooking>;
  quantities: Array<PlantSettingsQuantities>;
  termsAndConditions: Array<PlantSettingsTermsAndConditions>;
};


export type PlantSettingsAvailabilityTimesArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantSettingsBookingArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantSettingsQuantitiesArgs = {
  category?: InputMaybe<IdInput>;
};


export type PlantSettingsTermsAndConditionsArgs = {
  category?: InputMaybe<IdInput>;
};

export type PlantSettingsAvailabilityTimes = {
  __typename?: 'PlantSettingsAvailabilityTimes';
  category?: Maybe<ProductCategory>;
  deliveryWindow: Scalars['Int'];
  possibleDeliveryWindows: Array<Scalars['Int']>;
  possibleSteps: Array<Scalars['Int']>;
  step: Scalars['Int'];
  values: Array<Array<Scalars['Int']>>;
  workingHoursLimits: Array<Scalars['Int']>;
};

export type PlantSettingsAvailabilityTimesInput = {
  category: IdInput;
  deliveryWindow?: InputMaybe<Scalars['Int']>;
  step: Scalars['Int'];
  values: Array<Array<Scalars['Int']>>;
};

export type PlantSettingsBooking = {
  __typename?: 'PlantSettingsBooking';
  cancelingFeePrice?: Maybe<Price>;
  category?: Maybe<ProductCategory>;
  holdingFeePrice?: Maybe<Price>;
  lockToCancelTime: Scalars['Int'];
  lockToHoldTime: Scalars['Int'];
  lockToModifyTime: Scalars['Int'];
  maxCountToHold: Scalars['Int'];
  pickup?: Maybe<Scalars['Boolean']>;
};

export type PlantSettingsBookingInput = {
  cancelingFeePrice?: InputMaybe<PriceInput>;
  category: IdInput;
  holdingFeePrice?: InputMaybe<PriceInput>;
  lockToCancelTime?: InputMaybe<Scalars['Int']>;
  lockToHoldTime?: InputMaybe<Scalars['Int']>;
  lockToModifyTime?: InputMaybe<Scalars['Int']>;
  maxCountToHold?: InputMaybe<Scalars['Int']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
};

export type PlantSettingsInput = {
  availabilityTimes?: InputMaybe<Array<PlantSettingsAvailabilityTimesInput>>;
  booking?: InputMaybe<Array<PlantSettingsBookingInput>>;
  quantities?: InputMaybe<Array<PlantSettingsQuantitiesInput>>;
  termsAndConditions?: InputMaybe<Array<PlantSettingsTermsAndConditionsInput>>;
};

export type PlantSettingsQuantities = {
  __typename?: 'PlantSettingsQuantities';
  balanceTruck?: Maybe<Scalars['Float']>;
  category?: Maybe<ProductCategory>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  maxTrucksQuantity?: Maybe<Scalars['Float']>;
  minOrderAmount?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  minTruckCapacity?: Maybe<Scalars['Float']>;
  secondaryMinTruckCapacity?: Maybe<Scalars['Float']>;
  secondaryStep?: Maybe<Scalars['Float']>;
  secondaryTruckCapacity?: Maybe<Scalars['Float']>;
  secondaryUnits?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['Float']>;
  truckCapacity?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
};

export type PlantSettingsQuantitiesInput = {
  balanceTruck?: InputMaybe<Scalars['Float']>;
  category: IdInput;
  deliveryMethod?: InputMaybe<IdInput>;
  maxTrucksQuantity?: InputMaybe<Scalars['Float']>;
  minOrderAmount?: InputMaybe<Scalars['Float']>;
  minOrderQuantity?: InputMaybe<Scalars['Float']>;
  minTruckCapacity?: InputMaybe<Scalars['Float']>;
  secondaryMinTruckCapacity?: InputMaybe<Scalars['Float']>;
  secondaryStep?: InputMaybe<Scalars['Float']>;
  secondaryTruckCapacity?: InputMaybe<Scalars['Float']>;
  secondaryUnits?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['Float']>;
  truckCapacity?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
};

export type PlantSettingsTermsAndConditions = {
  __typename?: 'PlantSettingsTermsAndConditions';
  additionalCharges: Scalars['String'];
  category?: Maybe<ProductCategory>;
  contractorRequirements: Scalars['String'];
  deliveryDisclaimers: Scalars['String'];
  note: Scalars['String'];
  policy: Scalars['String'];
};

export type PlantSettingsTermsAndConditionsInput = {
  additionalCharges?: InputMaybe<Scalars['String']>;
  category: IdInput;
  contractorRequirements?: InputMaybe<Scalars['String']>;
  deliveryDisclaimers?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
};

export type PlantUpdateInput = {
  address?: InputMaybe<AddressInput>;
  city?: InputMaybe<IdInput>;
  color?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<PlantCustomFieldInput>>;
  deliveryMethods?: InputMaybe<PlantDeliveryMethodsInput>;
  deliveryRadius?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  discounts?: InputMaybe<PlantDiscountInput>;
  drivers?: InputMaybe<PlantDriverInput>;
  email?: InputMaybe<Scalars['String']>;
  feePrices?: InputMaybe<PlantFeePricesInput>;
  fees?: InputMaybe<PlantFeesInput>;
  id: Scalars['ID'];
  image?: InputMaybe<ResourceInput>;
  invoiceAddress?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openHours?: InputMaybe<Array<Array<Scalars['Float']>>>;
  optionPrices?: InputMaybe<Array<OptionPriceCreateInput>>;
  options?: InputMaybe<Array<IdInput>>;
  optionsAcr?: InputMaybe<PlantOptionsInput>;
  phone?: InputMaybe<Scalars['String']>;
  prettyIdPrefix?: InputMaybe<Scalars['String']>;
  prettyIdSuffixForSelfPickup?: InputMaybe<Scalars['String']>;
  productDecoratePrices?: InputMaybe<Array<ProductDecoratePriceCreateInput>>;
  productDecorates?: InputMaybe<Array<IdInput>>;
  productDecoratesAcr?: InputMaybe<PlantProductDecoratesInput>;
  productTypePrices?: InputMaybe<Array<ProductTypePriceCreateInput>>;
  productTypes?: InputMaybe<Array<IdInput>>;
  productTypesAcr?: InputMaybe<PlantProductTypesInput>;
  serviceName?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<PlantSettingsInput>;
  trucks?: InputMaybe<Array<IdInput>>;
};

/** Autogenerated return type of PlantUpdateOptions */
export type PlantUpdateOptionsPayload = {
  __typename?: 'PlantUpdateOptionsPayload';
  options: Array<PlantOptionInstance>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PlantUpdate */
export type PlantUpdatePayload = {
  __typename?: 'PlantUpdatePayload';
  plant?: Maybe<Plant>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PlantUpdateProductDecorates */
export type PlantUpdateProductDecoratesPayload = {
  __typename?: 'PlantUpdateProductDecoratesPayload';
  productDecorates: Array<PlantProductDecorate>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PlantUpdateProductTypes */
export type PlantUpdateProductTypesPayload = {
  __typename?: 'PlantUpdateProductTypesPayload';
  productTypes: Array<PlantProductType>;
  success: Scalars['Boolean'];
};

export type Price = {
  __typename?: 'Price';
  content: Scalars['String'];
  currency: Scalars['String'];
  custom: Scalars['Boolean'];
  exchangeRate: Scalars['Float'];
  formula?: Maybe<Formula>;
  formulaArguments?: Maybe<Scalars['JSON']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  originalValue: Scalars['Float'];
  plant?: Maybe<Plant>;
  priority: Scalars['Int'];
  value: Scalars['Float'];
};

export enum PriceGroupEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  Default = 'default'
}

export type PriceInput = {
  content?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  formula?: InputMaybe<IdInput>;
  formulaArguments?: InputMaybe<Scalars['JSON']>;
  value?: InputMaybe<Scalars['Float']>;
};

export enum PricesModeEnum {
  /** All prices, the same as not specifying a mode */
  All = 'ALL',
  /** Alias for ROOT */
  Base = 'BASE',
  /** Location prices only */
  Location = 'LOCATION',
  /** Root prices only */
  Root = 'ROOT'
}

export type ProcessingFeeInstance = {
  __typename?: 'ProcessingFeeInstance';
  conditionsDescription: Array<Scalars['String']>;
  fee?: Maybe<Fee>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** Flag to show visible status, for dashboard */
  active: Scalars['Boolean'];
  /** [DEPRECATED] */
  details: ProductDetails;
  exportCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  industry: Scalars['String'];
  industryColor: Scalars['String'];
  name: Scalars['String'];
  permissions: ProductCategoryPermissions;
  primaryComponent?: Maybe<ProductCategoryConfigComponent>;
  productTypes: ProductTypeList;
  root?: Maybe<ProductCategory>;
  secondaryComponent?: Maybe<ProductCategoryConfigComponent>;
  serviceName: Scalars['String'];
  sortOrder: Scalars['Int'];
  travelRate?: Maybe<ProductCategoryConfigTravelRate>;
  usage: ProductCategoryUsage;
};


export type ProductCategoryUsageArgs = {
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of ProductCategoryBatchUpdate */
export type ProductCategoryBatchUpdatePayload = {
  __typename?: 'ProductCategoryBatchUpdatePayload';
  productCategories: Array<ProductCategory>;
  success: Scalars['Boolean'];
};

export type ProductCategoryConfigComponent = {
  __typename?: 'ProductCategoryConfigComponent';
  enabled?: Maybe<Scalars['Boolean']>;
  increment?: Maybe<Scalars['Float']>;
  measureAs?: Maybe<ProductCategoryConfigComponentMeasureAsEnum>;
  measureMode?: Maybe<ProductCategoryConfigComponentMeasureModeEnum>;
  minimumQuantity?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type ProductCategoryConfigComponentInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  increment?: InputMaybe<Scalars['Float']>;
  measureAs?: InputMaybe<ProductCategoryConfigComponentMeasureAsEnum>;
  measureMode?: InputMaybe<ProductCategoryConfigComponentMeasureModeEnum>;
  minimumQuantity?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export enum ProductCategoryConfigComponentMeasureAsEnum {
  Custom = 'custom',
  Distance = 'distance',
  Load = 'load',
  Time = 'time'
}

export enum ProductCategoryConfigComponentMeasureModeEnum {
  BothWays = 'both_ways',
  OneWay = 'one_way',
  OnsiteTime = 'onsite_time',
  TotalTime = 'total_time'
}

export type ProductCategoryConfigTravelRate = {
  __typename?: 'ProductCategoryConfigTravelRate';
  enabled?: Maybe<Scalars['Boolean']>;
  increment?: Maybe<Scalars['Float']>;
  minimumQuantity?: Maybe<Scalars['Float']>;
};

export type ProductCategoryConfigTravelRateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  increment?: InputMaybe<Scalars['Float']>;
  minimumQuantity?: InputMaybe<Scalars['Float']>;
};

export type ProductCategoryCreateInput = {
  exportCode?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primaryComponent?: InputMaybe<ProductCategoryConfigComponentInput>;
  secondaryComponent?: InputMaybe<ProductCategoryConfigComponentInput>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  travelRate?: InputMaybe<ProductCategoryConfigTravelRateInput>;
};

/** Autogenerated return type of ProductCategoryCreate */
export type ProductCategoryCreatePayload = {
  __typename?: 'ProductCategoryCreatePayload';
  productCategory?: Maybe<ProductCategory>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProductCategoryDelete */
export type ProductCategoryDeletePayload = {
  __typename?: 'ProductCategoryDeletePayload';
  success: Scalars['Boolean'];
};

export type ProductCategoryList = {
  __typename?: 'ProductCategoryList';
  count: Scalars['Int'];
  values: Array<ProductCategory>;
};

export type ProductCategoryPermissions = {
  __typename?: 'ProductCategoryPermissions';
  decorates: Scalars['Boolean'];
  deliveryFees: Scalars['Boolean'];
  deliveryMethods: Scalars['Boolean'];
  deliveryMode: Scalars['String'];
  fullEdit: Scalars['Boolean'];
  multiProduct: Scalars['Boolean'];
  options: Scalars['Boolean'];
  productColors: Scalars['Boolean'];
  productModifications: Scalars['Boolean'];
  quantity: Scalars['Boolean'];
  seasonalFees: Scalars['Boolean'];
  service?: Maybe<Scalars['JSON']>;
  timebaseFees: Scalars['Boolean'];
  trucks: Scalars['Boolean'];
  underloadFees: Scalars['Boolean'];
  washoutFees: Scalars['Boolean'];
};

export type ProductCategoryUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  exportCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  primaryComponent?: InputMaybe<ProductCategoryConfigComponentInput>;
  secondaryComponent?: InputMaybe<ProductCategoryConfigComponentInput>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  travelRate?: InputMaybe<ProductCategoryConfigTravelRateInput>;
};

/** Autogenerated return type of ProductCategoryUpdate */
export type ProductCategoryUpdatePayload = {
  __typename?: 'ProductCategoryUpdatePayload';
  productCategory?: Maybe<ProductCategory>;
  success: Scalars['Boolean'];
};

export type ProductCategoryUsage = {
  __typename?: 'ProductCategoryUsage';
  plants: Array<Plant>;
};

export type ProductDecorate = {
  __typename?: 'ProductDecorate';
  active: Scalars['Boolean'];
  category?: Maybe<ProductCategory>;
  color?: Maybe<Scalars['String']>;
  /** [DEPRECATED] */
  details: ProductDecorateDetails;
  exportCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  root?: Maybe<ProductType>;
  serviceName: Scalars['String'];
  sortOrder: Scalars['Int'];
  taxable: Scalars['Boolean'];
};

/** Autogenerated return type of ProductDecorateBatchUpdate */
export type ProductDecorateBatchUpdatePayload = {
  __typename?: 'ProductDecorateBatchUpdatePayload';
  productDecorates: Array<ProductDecorate>;
  success: Scalars['Boolean'];
};

export type ProductDecorateCreateInput = {
  category?: InputMaybe<IdInput>;
  color?: InputMaybe<Scalars['String']>;
  exportCode?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProductDecorateCreate */
export type ProductDecorateCreatePayload = {
  __typename?: 'ProductDecorateCreatePayload';
  productDecorate?: Maybe<ProductDecorate>;
  success: Scalars['Boolean'];
};

export type ProductDecorateDetails = {
  __typename?: 'ProductDecorateDetails';
  color?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type ProductDecorateList = {
  __typename?: 'ProductDecorateList';
  count: Scalars['Int'];
  values: Array<ProductDecorate>;
};

export type ProductDecoratePrice = {
  __typename?: 'ProductDecoratePrice';
  city?: Maybe<City>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  plant?: Maybe<Plant>;
  price: Price;
  productDecorate: ProductDecorate;
  productType?: Maybe<ProductType>;
  supplier?: Maybe<Supplier>;
};

export type ProductDecoratePriceCreateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  plant?: InputMaybe<IdInput>;
  price: PriceInput;
  productDecorate: IdInput;
  productType?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of ProductDecoratePriceCreate */
export type ProductDecoratePriceCreatePayload = {
  __typename?: 'ProductDecoratePriceCreatePayload';
  productDecoratePrice?: Maybe<ProductDecoratePrice>;
  success: Scalars['Boolean'];
};

export type ProductDecoratePriceList = {
  __typename?: 'ProductDecoratePriceList';
  count: Scalars['Int'];
  values: Array<ProductDecoratePrice>;
};

export type ProductDecoratePricePaginatedInstance = {
  __typename?: 'ProductDecoratePricePaginatedInstance';
  active?: Maybe<Scalars['Boolean']>;
  prices: Array<ProductDecoratePrice>;
  productDecorate: ProductDecorate;
};

export type ProductDecoratePricePaginatedList = {
  __typename?: 'ProductDecoratePricePaginatedList';
  count: Scalars['Int'];
  groups: Array<Scalars['String']>;
  values: Array<ProductDecoratePricePaginatedInstance>;
};

export type ProductDecoratePriceUpdateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  id: Scalars['ID'];
  plant?: InputMaybe<IdInput>;
  price?: InputMaybe<PriceInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of ProductDecoratePriceUpdate */
export type ProductDecoratePriceUpdatePayload = {
  __typename?: 'ProductDecoratePriceUpdatePayload';
  productDecoratePrice?: Maybe<ProductDecoratePrice>;
  success: Scalars['Boolean'];
};

export type ProductDecorateUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  clearImage?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  exportCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProductDecorateUpdate */
export type ProductDecorateUpdatePayload = {
  __typename?: 'ProductDecorateUpdatePayload';
  productDecorate?: Maybe<ProductDecorate>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProductDependenciesRemove */
export type ProductDependenciesRemovePayload = {
  __typename?: 'ProductDependenciesRemovePayload';
  success: Scalars['Boolean'];
};

export type ProductDependencyInstance = {
  __typename?: 'ProductDependencyInstance';
  orders: Array<Order>;
  plants: Array<Plant>;
  productDecoratePrices: Array<ProductDecoratePrice>;
  productTypePrices: Array<ProductTypePrice>;
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  image?: Maybe<Scalars['String']>;
  serviceKey: Scalars['String'];
  units: Scalars['String'];
};

/** Product Ingredient object. */
export type ProductIngredient = {
  __typename?: 'ProductIngredient';
  id: Scalars['ID'];
  name: Scalars['String'];
  option: Scalars['Boolean'];
  trackable: Scalars['Boolean'];
  units?: Maybe<Scalars['String']>;
};

export type ProductIngredientCreateInput = {
  name: Scalars['String'];
  option: Scalars['Boolean'];
  trackable: Scalars['Boolean'];
  units: Scalars['String'];
};

/** Autogenerated return type of ProductIngredientCreate */
export type ProductIngredientCreatePayload = {
  __typename?: 'ProductIngredientCreatePayload';
  productIngredient?: Maybe<ProductIngredient>;
  success: Scalars['Boolean'];
};

export type ProductIngredientList = {
  __typename?: 'ProductIngredientList';
  count: Scalars['Int'];
  values: Array<ProductIngredient>;
};

/** Autogenerated return type of ProductIngredientRemove */
export type ProductIngredientRemovePayload = {
  __typename?: 'ProductIngredientRemovePayload';
  success: Scalars['Boolean'];
};

export type ProductIngredientUpdateInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  option?: InputMaybe<Scalars['Boolean']>;
  trackable?: InputMaybe<Scalars['Boolean']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProductIngredientUpdate */
export type ProductIngredientUpdatePayload = {
  __typename?: 'ProductIngredientUpdatePayload';
  productIngredient?: Maybe<ProductIngredient>;
  success: Scalars['Boolean'];
};

export type ProductInput = {
  id?: InputMaybe<Scalars['ID']>;
  prices?: InputMaybe<Array<ProductPriceInput>>;
};

export type ProductPriceInput = {
  decorate?: InputMaybe<IdInput>;
  decoratePrice?: InputMaybe<IdInput>;
  decoratePriceContent?: InputMaybe<Scalars['String']>;
  decoratePriceValue?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<IdInput>;
  typePrice?: InputMaybe<IdInput>;
  typePriceContent?: InputMaybe<Scalars['String']>;
  typePriceValue?: InputMaybe<Scalars['Float']>;
};

/** Product Type object. Contains information about product and his modifications */
export type ProductType = {
  __typename?: 'ProductType';
  /** Flag to show visible status, for dashboard */
  active: Scalars['Boolean'];
  additional: Scalars['JSON'];
  /** Category */
  category?: Maybe<ProductCategory>;
  characteristics: Array<Array<Scalars['String']>>;
  colors?: Maybe<Array<ProductDecorate>>;
  combinations?: Maybe<Array<ProductTypeCombinationInstance>>;
  custom: Scalars['Boolean'];
  /** Description test in MD-style */
  description?: Maybe<Scalars['String']>;
  /** The list of images urls for this product */
  descriptionImages?: Maybe<Array<Scalars['String']>>;
  /** The list of files urls for this product */
  descriptionResources?: Maybe<Array<ProductTypeImageResource>>;
  /** [DEPRECATED] */
  details: ProductTypeDetails;
  /** External ID, used in integrations with third part systems. For dashboard */
  exportCode: Scalars['String'];
  /** The hash of filter values for the current product. Uses for filter panel. */
  filter: Scalars['JSON'];
  /** Group name (subcategory) */
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Link to main image */
  image?: Maybe<Scalars['String']>;
  increment?: Maybe<Scalars['Float']>;
  ingredients?: Maybe<Array<ProductIngredient>>;
  inventoryRecipes?: Maybe<Array<InventoryRecipe>>;
  /** Shows how should be measured this product type. Can be primary or secondary */
  measuredAs: Scalars['String'];
  minimumQuantity?: Maybe<Scalars['Float']>;
  modifications: Array<ProductTypeModificationInstance>;
  /** Display name */
  name: Scalars['String'];
  nestedProductTypes?: Maybe<ProductTypeList>;
  option?: Maybe<Scalars['Boolean']>;
  /** [DEPRECATED] */
  optionCombinations?: Maybe<Array<ProductTypeOptionValue>>;
  /** [DEPRECATED] */
  options?: Maybe<ProductTypeOptions>;
  /** Link to the parent product.Not null only if the current product is modification of the parent one.  */
  parent?: Maybe<ProductType>;
  permissions: ProductTypePermissions;
  possibleColors?: Maybe<Array<ProductDecorate>>;
  /** [DEPRECATED] */
  possibleOptionsValues?: Maybe<Array<ProductTypeOptionValue>>;
  prices?: Maybe<ProductTypePriceList>;
  /** [DEPRECATED] */
  root?: Maybe<ProductType>;
  /** Internal (service) name, for dashboard */
  serviceName: Scalars['String'];
  /** Short description text */
  shortDescription?: Maybe<Scalars['String']>;
  /** Sort order, for dashboard */
  sortOrder: Scalars['Int'];
  /** The link to specification file(pdf) */
  specification?: Maybe<Scalars['String']>;
  /** The list of tags assigned to product. For Dashboard */
  tags?: Maybe<Array<Scalars['String']>>;
  taxable: Scalars['Boolean'];
  units?: Maybe<Scalars['String']>;
  virtual?: Maybe<Scalars['Boolean']>;
  /** [DEPRECATED] */
  virtualPrice?: Maybe<ProductTypeVirtualPriceSimple>;
};


/** Product Type object. Contains information about product and his modifications */
export type ProductTypeNestedProductTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Product Type object. Contains information about product and his modifications */
export type ProductTypePricesArgs = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<PricesModeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProductTypeBatchUpdate */
export type ProductTypeBatchUpdatePayload = {
  __typename?: 'ProductTypeBatchUpdatePayload';
  productTypes: Array<ProductType>;
  success: Scalars['Boolean'];
};

export type ProductTypeCombinationAddInput = {
  description?: InputMaybe<Scalars['String']>;
  modifications: Array<IdInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type ProductTypeCombinationChangeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  modifications?: InputMaybe<Array<IdInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type ProductTypeCombinationInput = {
  add?: InputMaybe<Array<ProductTypeCombinationAddInput>>;
  change?: InputMaybe<Array<ProductTypeCombinationChangeInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type ProductTypeCombinationInstance = {
  __typename?: 'ProductTypeCombinationInstance';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modifications?: Maybe<Array<ProductTypeModificationInstance>>;
  value: Scalars['String'];
};

export type ProductTypeCreateCustomInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionImages?: InputMaybe<Array<Scalars['Upload']>>;
  descriptionResources?: InputMaybe<Array<ProductTypeImageAddInput>>;
  image?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  product: IdInput;
  specification?: InputMaybe<Scalars['Upload']>;
};

/** Autogenerated return type of ProductTypeCreateCustom */
export type ProductTypeCreateCustomPayload = {
  __typename?: 'ProductTypeCreateCustomPayload';
  productTypePrice?: Maybe<OrderPreparatoryConfigProductTypePrice>;
  success: Scalars['Boolean'];
};

export type ProductTypeCreateInput = {
  characteristics?: InputMaybe<Array<Array<Scalars['String']>>>;
  colors?: InputMaybe<Array<IdInput>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionImages?: InputMaybe<Array<Scalars['Upload']>>;
  descriptionResources?: InputMaybe<Array<ProductTypeImageAddInput>>;
  exportCode?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  increment?: InputMaybe<Scalars['Float']>;
  minimumQuantity?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<ProductTypeOptionsInput>;
  product: IdInput;
  serviceName?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  specification?: InputMaybe<Scalars['Upload']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProductTypeCreate */
export type ProductTypeCreatePayload = {
  __typename?: 'ProductTypeCreatePayload';
  productType?: Maybe<ProductType>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProductTypeDelete */
export type ProductTypeDeletePayload = {
  __typename?: 'ProductTypeDeletePayload';
  success: Scalars['Boolean'];
};

export type ProductTypeDetails = {
  __typename?: 'ProductTypeDetails';
  description?: Maybe<Scalars['JSON']>;
  group?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  specification?: Maybe<Scalars['JSON']>;
};

export type ProductTypeImageAcrInput = {
  add?: InputMaybe<Array<ProductTypeImageAddInput>>;
  change?: InputMaybe<Array<ProductTypeImageChangeInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type ProductTypeImageAddInput = {
  description?: InputMaybe<Scalars['String']>;
  image: Scalars['Upload'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type ProductTypeImageChangeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type ProductTypeImageResource = {
  __typename?: 'ProductTypeImageResource';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sortOrder?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type ProductTypeLike = {
  __typename?: 'ProductTypeLike';
  contractor?: Maybe<Contractor>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  productType: ProductType;
};

/** Autogenerated return type of ProductTypeLike */
export type ProductTypeLikePayload = {
  __typename?: 'ProductTypeLikePayload';
  favoriteProductTypes: Array<ProductTypeLike>;
  success: Scalars['Boolean'];
};

export type ProductTypeList = {
  __typename?: 'ProductTypeList';
  count: Scalars['Int'];
  groups: Array<Scalars['String']>;
  values: Array<ProductType>;
};

export type ProductTypeModificationAddInput = {
  label?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  values: Array<ProductTypeModificationAddItemInput>;
};

export type ProductTypeModificationAddItemInput = {
  characteristics?: InputMaybe<Array<Array<Scalars['String']>>>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageFullscreen?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  numeric?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type ProductTypeModificationChangeInput = {
  label?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  values: Array<ProductTypeModificationChangeItemInput>;
};

export type ProductTypeModificationChangeItemInput = {
  characteristics?: InputMaybe<Array<Array<Scalars['String']>>>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageFullscreen?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  numeric?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type ProductTypeModificationInput = {
  add?: InputMaybe<Array<ProductTypeModificationAddInput>>;
  change?: InputMaybe<Array<ProductTypeModificationChangeInput>>;
  remove?: InputMaybe<Array<IdInput>>;
};

export type ProductTypeModificationInstance = {
  __typename?: 'ProductTypeModificationInstance';
  characteristics: Array<Array<Scalars['String']>>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageCaption?: Maybe<Scalars['String']>;
  imageFullscreen: Scalars['Boolean'];
  label: Scalars['String'];
  name: Scalars['String'];
  numeric?: Maybe<Scalars['Int']>;
  sortOrder: Scalars['Int'];
  type: Scalars['String'];
};

export type ProductTypeOptionValue = {
  __typename?: 'ProductTypeOptionValue';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modifications?: Maybe<Array<ProductTypeModificationInstance>>;
  value: Scalars['String'];
};

export type ProductTypeOptionValueInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProductTypeOptions = {
  __typename?: 'ProductTypeOptions';
  label: Scalars['String'];
  values: Array<ProductTypeOptionValue>;
};

export type ProductTypeOptionsInput = {
  label?: InputMaybe<Scalars['String']>;
  values: Array<ProductTypeOptionValueInput>;
};

export type ProductTypePermissions = {
  __typename?: 'ProductTypePermissions';
  colors: Scalars['Boolean'];
  fullEdit: Scalars['Boolean'];
  modifications: Scalars['Boolean'];
};

export type ProductTypePrice = {
  __typename?: 'ProductTypePrice';
  city?: Maybe<City>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  partner?: Maybe<Partner>;
  plant?: Maybe<Plant>;
  price: Price;
  productType: ProductType;
  supplier?: Maybe<Supplier>;
};

export type ProductTypePriceCreateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  plant?: InputMaybe<IdInput>;
  price: PriceInput;
  productType: IdInput;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of ProductTypePriceCreate */
export type ProductTypePriceCreatePayload = {
  __typename?: 'ProductTypePriceCreatePayload';
  productTypePrice?: Maybe<ProductTypePrice>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProductTypePriceDelete */
export type ProductTypePriceDeletePayload = {
  __typename?: 'ProductTypePriceDeletePayload';
  success: Scalars['Boolean'];
};

export type ProductTypePriceList = {
  __typename?: 'ProductTypePriceList';
  count: Scalars['Int'];
  values: Array<ProductTypePrice>;
};

export type ProductTypePricePaginatedInstance = {
  __typename?: 'ProductTypePricePaginatedInstance';
  active?: Maybe<Scalars['Boolean']>;
  prices: Array<ProductTypePrice>;
  productType: ProductType;
};

export type ProductTypePricePaginatedList = {
  __typename?: 'ProductTypePricePaginatedList';
  count: Scalars['Int'];
  groups: Array<Scalars['String']>;
  values: Array<ProductTypePricePaginatedInstance>;
};

export type ProductTypePriceUpdateInput = {
  city?: InputMaybe<IdInput>;
  contractor?: InputMaybe<IdInput>;
  group?: InputMaybe<PriceGroupEnum>;
  id: Scalars['ID'];
  plant?: InputMaybe<IdInput>;
  price?: InputMaybe<PriceInput>;
  supplier?: InputMaybe<IdInput>;
};

/** Autogenerated return type of ProductTypePriceUpdate */
export type ProductTypePriceUpdatePayload = {
  __typename?: 'ProductTypePriceUpdatePayload';
  productTypePrice?: Maybe<ProductTypePrice>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProductTypeUnlike */
export type ProductTypeUnlikePayload = {
  __typename?: 'ProductTypeUnlikePayload';
  success: Scalars['Boolean'];
};

export type ProductTypeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addDescriptionImages?: InputMaybe<Array<Scalars['Upload']>>;
  characteristics?: InputMaybe<Array<Array<Scalars['String']>>>;
  colors?: InputMaybe<Array<IdInput>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionResources?: InputMaybe<ProductTypeImageAcrInput>;
  exportCode?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  increment?: InputMaybe<Scalars['Float']>;
  minimumQuantity?: InputMaybe<Scalars['Float']>;
  modifications?: InputMaybe<ProductTypeModificationInput>;
  name?: InputMaybe<Scalars['String']>;
  optionCombinations?: InputMaybe<ProductTypeCombinationInput>;
  options?: InputMaybe<ProductTypeOptionsInput>;
  removeDescriptionImages?: InputMaybe<Array<Scalars['String']>>;
  serviceName?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  specification?: InputMaybe<Scalars['Upload']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  units?: InputMaybe<Scalars['String']>;
  virtualPrice?: InputMaybe<ProductTypeVirtualPriceInput>;
};

/** Autogenerated return type of ProductTypeUpdate */
export type ProductTypeUpdatePayload = {
  __typename?: 'ProductTypeUpdatePayload';
  productType?: Maybe<ProductType>;
  success: Scalars['Boolean'];
};

export type ProductTypeVirtualPrice = {
  __typename?: 'ProductTypeVirtualPrice';
  coverage?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type ProductTypeVirtualPriceInput = {
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProductTypeVirtualPriceSimple = {
  __typename?: 'ProductTypeVirtualPriceSimple';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Project = {
  __typename?: 'Project';
  additionalInfo?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  autogenerated: Scalars['Boolean'];
  availableActions: Array<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientPhone?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  contractor?: Maybe<Contractor>;
  createdAt: Scalars['String'];
  daysToStart: Scalars['Int'];
  deliveryZone?: Maybe<Scalars['String']>;
  estimatedValue?: Maybe<Scalars['Float']>;
  exportCode?: Maybe<Scalars['String']>;
  feePrices: ProjectFeePrices;
  id: Scalars['ID'];
  images: Array<ProjectImage>;
  kind?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Array<Scalars['String']>;
  notesNew: ProjectNoteList;
  number: Scalars['ID'];
  optionPrices: ProjectOptionPrices;
  orders: Array<Order>;
  ordersP: OrderList;
  plant?: Maybe<Plant>;
  possibleCategories: Array<ProductCategory>;
  possibleFees: Array<Fee>;
  possibleOptions: Array<Option>;
  possibleProductTypes: Array<ProductType>;
  prettyId: Scalars['String'];
  priceGroups: ProjectPriceGroupList;
  priceLocked: Scalars['Boolean'];
  productTypePrices: ProjectProductTypePrices;
  purchaseNumber?: Maybe<Scalars['String']>;
  quoteStatus: Scalars['String'];
  resources: ProjectResourceList;
  route?: Maybe<Route>;
  spent: Scalars['Float'];
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  taxable: Scalars['Boolean'];
  taxableApproved: Scalars['Boolean'];
  timezone: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  workOrderNumber?: Maybe<Scalars['String']>;
  workType?: Maybe<Scalars['String']>;
};


export type ProjectFeePricesArgs = {
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProjectOptionPricesArgs = {
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProjectOrdersPArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type ProjectPossibleFeesArgs = {
  category?: InputMaybe<IdInput>;
};


export type ProjectPossibleOptionsArgs = {
  category?: InputMaybe<IdInput>;
};


export type ProjectPossibleProductTypesArgs = {
  category?: InputMaybe<IdInput>;
};


export type ProjectPriceGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  products?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProjectProductTypePricesArgs = {
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProjectResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<ProjectResourceTypeEnum>>;
};


export type ProjectStatusArgs = {
  combined?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ProjectClone */
export type ProjectClonePayload = {
  __typename?: 'ProjectClonePayload';
  project?: Maybe<Project>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProjectComplete */
export type ProjectCompletePayload = {
  __typename?: 'ProjectCompletePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  project: Project;
  success: Scalars['Boolean'];
};

export type ProjectCreateInput = {
  address: AddressInput;
  completedAt?: InputMaybe<Scalars['String']>;
  daysToStart?: InputMaybe<Scalars['Int']>;
  deliveryZone?: InputMaybe<Scalars['String']>;
  estimatedValue?: InputMaybe<Scalars['Float']>;
  exportCode?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  priceLocked?: InputMaybe<Scalars['Boolean']>;
  purchaseNumber?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProjectTypeEnum>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  workOrderNumber?: InputMaybe<Scalars['String']>;
  workType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProjectCreate */
export type ProjectCreatePayload = {
  __typename?: 'ProjectCreatePayload';
  project?: Maybe<Project>;
  success: Scalars['Boolean'];
};

export type ProjectFeePrices = {
  __typename?: 'ProjectFeePrices';
  categories: Array<ProductCategory>;
  count: Scalars['Int'];
  values: Array<FeePrice>;
};

export type ProjectImage = {
  __typename?: 'ProjectImage';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  image: Resource;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ProjectImageAdd */
export type ProjectImageAddPayload = {
  __typename?: 'ProjectImageAddPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  images?: Maybe<Array<ProjectImage>>;
  success: Scalars['Boolean'];
};

export type ProjectImageInput = {
  image: ResourceInput;
};

/** Autogenerated return type of ProjectImageRemove */
export type ProjectImageRemovePayload = {
  __typename?: 'ProjectImageRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export type ProjectList = {
  __typename?: 'ProjectList';
  count: Scalars['Int'];
  values: Array<Project>;
};

export type ProjectNote = {
  __typename?: 'ProjectNote';
  attachments: Array<Resource>;
  author?: Maybe<User>;
  createdAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  readAt?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of ProjectNoteAdd */
export type ProjectNoteAddPayload = {
  __typename?: 'ProjectNoteAddPayload';
  note?: Maybe<ProjectNote>;
  notes: Array<ProjectNote>;
  success: Scalars['Boolean'];
};

export type ProjectNoteList = {
  __typename?: 'ProjectNoteList';
  count: Scalars['Int'];
  values: Array<ProjectNote>;
};

/** Autogenerated return type of ProjectNoteRemove */
export type ProjectNoteRemovePayload = {
  __typename?: 'ProjectNoteRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProjectNoteUpdate */
export type ProjectNoteUpdatePayload = {
  __typename?: 'ProjectNoteUpdatePayload';
  success: Scalars['Boolean'];
};

export type ProjectOptionPrices = {
  __typename?: 'ProjectOptionPrices';
  categories: Array<ProductCategory>;
  count: Scalars['Int'];
  values: Array<OptionPrice>;
};

export type ProjectPriceGroupCreateInput = {
  group: PriceGroupEnum;
  plant?: InputMaybe<IdInput>;
  product?: InputMaybe<IdInput>;
};

export type ProjectPriceGroupInstance = {
  __typename?: 'ProjectPriceGroupInstance';
  group: Scalars['String'];
  plant?: Maybe<Plant>;
  priority: Scalars['Int'];
  product?: Maybe<ProductCategory>;
};

export type ProjectPriceGroupList = {
  __typename?: 'ProjectPriceGroupList';
  count: Scalars['Int'];
  values: Array<ProjectPriceGroupInstance>;
};

export type ProjectPricesUpdateInput = {
  feePrices?: InputMaybe<Array<FeePriceCreateInput>>;
  id: Scalars['ID'];
  optionPrices?: InputMaybe<Array<OptionPriceCreateInput>>;
  productDecoratePrices?: InputMaybe<Array<ProductDecoratePriceCreateInput>>;
  productTypePrices?: InputMaybe<Array<ProductTypePriceCreateInput>>;
};

/** Autogenerated return type of ProjectPricesUpdate */
export type ProjectPricesUpdatePayload = {
  __typename?: 'ProjectPricesUpdatePayload';
  project?: Maybe<Project>;
  success: Scalars['Boolean'];
};

export type ProjectProductTypePrices = {
  __typename?: 'ProjectProductTypePrices';
  categories: Array<ProductCategory>;
  count: Scalars['Int'];
  values: Array<ProductTypePrice>;
};

/** Autogenerated return type of ProjectQuoteAccept */
export type ProjectQuoteAcceptPayload = {
  __typename?: 'ProjectQuoteAcceptPayload';
  project: Project;
  success: Scalars['Boolean'];
};

export enum ProjectQuoteEnum {
  Added = 'added',
  None = 'none',
  Requested = 'requested'
}

/** Autogenerated return type of ProjectQuoteRequest */
export type ProjectQuoteRequestPayload = {
  __typename?: 'ProjectQuoteRequestPayload';
  project: Project;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProjectRemove */
export type ProjectRemovePayload = {
  __typename?: 'ProjectRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export type ProjectResource = {
  __typename?: 'ProjectResource';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  resource: Resource;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ProjectResourceAdd */
export type ProjectResourceAddPayload = {
  __typename?: 'ProjectResourceAddPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  resources?: Maybe<Array<ProjectResource>>;
  success: Scalars['Boolean'];
};

export type ProjectResourceInput = {
  resource: ResourceInput;
  type: ProjectResourceTypeEnum;
};

export type ProjectResourceList = {
  __typename?: 'ProjectResourceList';
  count: Scalars['Int'];
  values: Array<ProjectResource>;
};

/** Autogenerated return type of ProjectResourceRemove */
export type ProjectResourceRemovePayload = {
  __typename?: 'ProjectResourceRemovePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  success: Scalars['Boolean'];
};

export enum ProjectResourceTypeEnum {
  Image = 'image',
  Plans = 'plans',
  Quote = 'quote',
  Specs = 'specs',
  Tax = 'tax'
}

/** Autogenerated return type of ProjectStart */
export type ProjectStartPayload = {
  __typename?: 'ProjectStartPayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  project: Project;
  success: Scalars['Boolean'];
};

export enum ProjectTypeEnum {
  Active = 'active',
  Completed = 'completed',
  Upcoming = 'upcoming'
}

export type ProjectUpdateInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  clientEmail?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  clientPhone?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['String']>;
  daysToStart?: InputMaybe<Scalars['Int']>;
  deliveryZone?: InputMaybe<Scalars['String']>;
  estimatedValue?: InputMaybe<Scalars['Float']>;
  exportCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  priceLocked?: InputMaybe<Scalars['Boolean']>;
  purchaseNumber?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProjectTypeEnum>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  taxableApproved?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  workOrderNumber?: InputMaybe<Scalars['String']>;
  workType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProjectUpdate */
export type ProjectUpdatePayload = {
  __typename?: 'ProjectUpdatePayload';
  contractor?: Maybe<Contractor>;
  contractorMember?: Maybe<ContractorMember>;
  project?: Maybe<Project>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ProjectUpdatePriceGroups */
export type ProjectUpdatePriceGroupsPayload = {
  __typename?: 'ProjectUpdatePriceGroupsPayload';
  success: Scalars['Boolean'];
};

export type QuantitiesConfig = {
  __typename?: 'QuantitiesConfig';
  min: Scalars['Float'];
  secondaryMin?: Maybe<Scalars['Float']>;
  secondaryStep?: Maybe<Scalars['Step']>;
  secondaryUnits?: Maybe<Scalars['String']>;
  step: Scalars['Step'];
  units: Scalars['String'];
  virtualCoverage?: Maybe<Scalars['Float']>;
  virtualStep?: Maybe<Scalars['Float']>;
  virtualUnits?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _jobsMeta: _QueryMeta;
  availabilityBlockOffs: AvailabilityTimeBlockOffList;
  cart: Cart;
  cartPreparatoryConfig: CartPreparatoryConfig;
  channel: Channel;
  channelMessages: Array<ChannelMessageList>;
  channels: ChannelList;
  cities: Array<City>;
  city: City;
  clientConfig: PartnerClientConfigList;
  clientTip?: Maybe<PartnerClientTipInstance>;
  config: Config;
  contractor?: Maybe<Contractor>;
  contractorSkids?: Maybe<ContractorSkidList>;
  contractors: ContractorList;
  countries: Array<Country>;
  countryStates: CountryStateList;
  dashboard: Dashboard;
  deliveryMethods: DeliveryMethodList;
  deliveryTransaction: DeliveryTransaction;
  deliveryTransactionPreparatoryConfig: DeliveryTransactionPreparatoryConfig;
  deliveryTransactions: DeliveryTransactionList;
  driver: Driver;
  driverBlockOff: DriverBlockOff;
  driverOrders: OrderTruckList;
  driverTask: DriverTask;
  driverTasks: DriverTaskList;
  drivers: DriverList;
  exportContractors: ExportResult;
  exportDeliveryTransactions: ExportResult;
  exportDriverTasks: ExportResult;
  exportOrders: ExportResult;
  exportPayouts: ExportResult;
  exportTransactions: ExportResult;
  exportWorkingDays: ExportResult;
  favoriteProductTypes: FavoriteProductTypes;
  features: FeatureList;
  fee: Fee;
  fees: FeeList;
  financeAccounts: PartnerFinanceAccountList;
  finances: PartnerFinanceList;
  financesExport: CsvExport;
  financesStats: PartnerAccountStatsInstance;
  formulas: FormulaList;
  gallery: GalleryList;
  globalMap: GlobalMapList;
  inventories: InventoryList;
  inventoryRecipes: InventoryRecipeList;
  inventoryTransactions: InventoryTransactionList;
  invite: Invite;
  jobDetails?: Maybe<CareerJob>;
  jobStatus: JobStatusList;
  jobs: CareerJobList;
  me: MeInfo;
  option: Option;
  options: OptionList;
  order: Order;
  orderMessages: Array<OrderMessageList>;
  orderPreparatoryConfig: OrderPreparatoryConfig;
  orderTruck: OrderTruck;
  orderTrucks: OrderTruckList;
  orders: OrderListExtended;
  ordersChanges: OrderChanges;
  partner?: Maybe<Partner>;
  partnerContractors?: Maybe<PartnerContractorList>;
  partnerDrivers?: Maybe<PartnerDriverList>;
  partnerPayouts: PartnerPayoutList;
  partnerStatus?: Maybe<PartnerStatus>;
  partners?: Maybe<PartnerList>;
  paymentLink: PaymentLink;
  paymentLinks: PaymentLinkList;
  payoutsExport: CsvExport;
  plant: Plant;
  plantProducts: PlantProductList;
  plants: PlantList;
  productCategories: ProductCategoryList;
  productCategory: ProductCategory;
  productDecorate: ProductDecorate;
  productDecoratePrices: ProductDecoratePriceList;
  productDecorates: ProductDecorateList;
  productDependencies: ProductDependencyInstance;
  productIngredients: ProductIngredientList;
  productType: ProductType;
  productTypePrices: ProductTypePriceList;
  productTypes: ProductTypeList;
  project: Project;
  projects: ProjectList;
  questionary?: Maybe<Questionary>;
  roles: RoleList;
  skidTransactions?: Maybe<SkidTransactionList>;
  skids?: Maybe<SkidList>;
  storefront: Storefront;
  supplier?: Maybe<Supplier>;
  suppliers?: Maybe<SupplierList>;
  taxableSettings: TaxableSettingsList;
  taxes: PartnerTaxList;
  transactions: TransactionList;
  truck: Truck;
  trucks: TruckList;
  widget?: Maybe<WidgetInstance>;
  widgets: WidgetList;
};


export type QueryAvailabilityBlockOffsArgs = {
  city?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<Array<IdInput>>;
  product?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryCartArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCartPreparatoryConfigArgs = {
  cart?: InputMaybe<IdInput>;
};


export type QueryChannelArgs = {
  id: Scalars['ID'];
};


export type QueryChannelMessagesArgs = {
  channels: Array<IdInput>;
  from?: InputMaybe<Scalars['String']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryChannelsArgs = {
  actual?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['Boolean']>;
  contractors?: InputMaybe<Array<IdInput>>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  drivers?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  orders?: InputMaybe<Array<IdInput>>;
  partners?: InputMaybe<Array<IdInput>>;
  projects?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCitiesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  point?: InputMaybe<LocationInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryCityArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryClientTipArgs = {
  name: Scalars['String'];
};


export type QueryContractorArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryContractorSkidsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  contractor?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skid?: InputMaybe<IdInput>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryContractorsArgs = {
  ignoreScope?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<PartnerContractorStatusEnum>>;
};


export type QueryCountriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryCountryStatesArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveryMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveryTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryTransactionPreparatoryConfigArgs = {
  deliveryTransaction?: InputMaybe<IdInput>;
  driverTask?: InputMaybe<IdInput>;
};


export type QueryDeliveryTransactionsArgs = {
  driver?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  truck?: InputMaybe<Array<IdInput>>;
};


export type QueryDriverArgs = {
  id: Scalars['ID'];
};


export type QueryDriverBlockOffArgs = {
  id: Scalars['ID'];
};


export type QueryDriverOrdersArgs = {
  driver?: InputMaybe<IdInput>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  statuses?: InputMaybe<Array<DriverTruckStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  workingDay?: InputMaybe<IdInput>;
};


export type QueryDriverTaskArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverTasksArgs = {
  bolStatus?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<IdInput>>;
  cities?: InputMaybe<Array<IdInput>>;
  contractors?: InputMaybe<Array<IdInput>>;
  countryStates?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  driverRoles?: InputMaybe<Array<Scalars['String']>>;
  driverTrips?: InputMaybe<Array<IdInput>>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
  exported?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeTrips?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orders?: InputMaybe<Array<IdInput>>;
  plants?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  status?: InputMaybe<Array<DeliveryStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<Array<IdInput>>;
  truckRoles?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<DriverTaskTypeEnum>>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  withDriver?: InputMaybe<Scalars['Boolean']>;
  withTruck?: InputMaybe<Scalars['Boolean']>;
  workingDay?: InputMaybe<IdInput>;
};


export type QueryDriversArgs = {
  city?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  orderTruck?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<DriverTypeEnum>>;
};


export type QueryExportContractorsArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  contractors: Array<IdInput>;
};


export type QueryExportDeliveryTransactionsArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  deliveryTransactions: Array<IdInput>;
  exportAction: Scalars['String'];
};


export type QueryExportDriverTasksArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  driverTasks: Array<IdInput>;
  exportAction: Scalars['String'];
};


export type QueryExportOrdersArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  exportAction: Scalars['String'];
  orders: Array<IdInput>;
};


export type QueryExportPayoutsArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  exportAction: Scalars['String'];
  payouts: Array<IdInput>;
};


export type QueryExportTransactionsArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  exportAction: Scalars['String'];
  transactions: Array<IdInput>;
};


export type QueryExportWorkingDaysArgs = {
  async?: InputMaybe<Scalars['Boolean']>;
  dayFrom: Scalars['String'];
  dayTo: Scalars['String'];
  exportAction: Scalars['String'];
};


export type QueryFavoriteProductTypesArgs = {
  contractor?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryFeeArgs = {
  fee: IdInput;
};


export type QueryFeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<FeeTypeEnum>>;
};


export type QueryFinanceAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryFinancesArgs = {
  autoCollect?: InputMaybe<FinanceOfflineCollectTypesEnum>;
  contractor?: InputMaybe<IdInput>;
  creditStatuses?: InputMaybe<Array<CreditStatusEnum>>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  exported?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  getPaid?: InputMaybe<FinanceOfflineCollectTypesEnum>;
  invoiced?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offline?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  partner?: InputMaybe<IdInput>;
  paymentStatus?: InputMaybe<Array<OrderPaymentStatusEnum>>;
  plants?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FinanceStatusEnum>;
  statuses?: InputMaybe<Array<FinanceStatusEnum>>;
};


export type QueryFinancesExportArgs = {
  finances: Array<IdInput>;
};


export type QueryFinancesStatsArgs = {
  from?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<IdInput>;
  period?: InputMaybe<FinancePeriodEnum>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryFormulasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Array<FormulaReasonEnum>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryGalleryArgs = {
  orders?: InputMaybe<Array<IdInput>>;
};


export type QueryGlobalMapArgs = {
  city?: InputMaybe<Array<IdInput>>;
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<Array<IdInput>>;
  precision: Scalars['Float'];
  product?: InputMaybe<Array<IdInput>>;
  project?: InputMaybe<Array<IdInput>>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  skipPremiumPartners?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Array<OrderSourceEnum>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  supplier?: InputMaybe<Array<IdInput>>;
  to?: InputMaybe<Scalars['String']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryInventoryRecipesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productTypes?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryInventoryTransactionsArgs = {
  inventories?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  real?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
};


export type QueryJobDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryJobStatusArgs = {
  jobs: Array<Scalars['String']>;
};


export type QueryJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryMeArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryOptionArgs = {
  id: Scalars['ID'];
  supplier?: InputMaybe<IdInput>;
};


export type QueryOptionsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  root?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<IdInput>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryOrderMessagesArgs = {
  from?: InputMaybe<Scalars['String']>;
  orders: Array<IdInput>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrderPreparatoryConfigArgs = {
  contractor?: InputMaybe<IdInput>;
  input?: InputMaybe<OrderPreparatoryConfigInput>;
  order?: InputMaybe<IdInput>;
  partner?: InputMaybe<IdInput>;
};


export type QueryOrderTruckArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderTrucksArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  drivers?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orders?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  statuses?: InputMaybe<Array<DriverTruckStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  trucks?: InputMaybe<Array<IdInput>>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  withDriver?: InputMaybe<Scalars['Boolean']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
  withTruck?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrdersArgs = {
  city?: InputMaybe<Array<IdInput>>;
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  flags?: InputMaybe<Scalars['JSON']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  paymentStatus?: InputMaybe<Array<OrderPaymentStatusEnum>>;
  payoutStatus?: InputMaybe<FinanceStatusEnum>;
  pickupScheduled?: InputMaybe<Scalars['Boolean']>;
  plant?: InputMaybe<Array<IdInput>>;
  product?: InputMaybe<Array<IdInput>>;
  project?: InputMaybe<Array<IdInput>>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  skipPremiumPartners?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  source?: InputMaybe<Array<OrderSourceEnum>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  supplier?: InputMaybe<Array<IdInput>>;
  to?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<Array<IdInput>>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrdersChangesArgs = {
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Array<IdInput>>;
  lastCreatedAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orders?: InputMaybe<Array<IdInput>>;
  plant?: InputMaybe<Array<IdInput>>;
  product?: InputMaybe<Array<IdInput>>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  supplier?: InputMaybe<Array<IdInput>>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPartnerArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPartnerContractorsArgs = {
  accountStatus?: InputMaybe<Array<PartnerContractorAccountStatusEnum>>;
  contractors?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  markAsRead?: InputMaybe<Scalars['Boolean']>;
  onlyNotRead?: InputMaybe<Scalars['Boolean']>;
  partners?: InputMaybe<Array<IdInput>>;
  priceStatus?: InputMaybe<Array<PartnerContractorPriceStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Array<PartnerContractorSourceEnum>>;
  status?: InputMaybe<Array<PartnerContractorStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryPartnerDriversArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  countryStates?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Array<PartnerDriverSourceEnum>>;
  status?: InputMaybe<Array<PartnerDriverStatusEnum>>;
  type?: InputMaybe<Array<DriverTypeEnum>>;
};


export type QueryPartnerPayoutsArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<PayoutStatusEnum>>;
};


export type QueryPartnersArgs = {
  category?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  paidOnly?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<RegionInput>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  visibleOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPaymentLinkArgs = {
  id?: InputMaybe<Scalars['ID']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentLinksArgs = {
  contractor?: InputMaybe<IdInput>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  paymentTypes?: InputMaybe<Array<GroupedPaymentTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortDirectionEnum>;
  statuses?: InputMaybe<Array<PaymentLinkStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryPayoutsExportArgs = {
  payouts: Array<IdInput>;
};


export type QueryPlantArgs = {
  id: Scalars['ID'];
};


export type QueryPlantProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  plant: IdInput;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryPlantsArgs = {
  category?: InputMaybe<Array<IdInput>>;
  city?: InputMaybe<Array<IdInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<Array<IdInput>>;
};


export type QueryProductCategoriesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  region?: InputMaybe<RegionInput>;
  root?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<IdInput>;
};


export type QueryProductCategoryArgs = {
  id: Scalars['ID'];
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type QueryProductDecorateArgs = {
  id: Scalars['ID'];
  supplier?: InputMaybe<IdInput>;
};


export type QueryProductDecoratePricesArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  productDecorates?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  suppliers?: InputMaybe<Array<IdInput>>;
};


export type QueryProductDecoratesArgs = {
  category?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  root?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<IdInput>;
};


export type QueryProductDependenciesArgs = {
  category: IdInput;
};


export type QueryProductIngredientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryProductTypeArgs = {
  id: Scalars['ID'];
  partner?: InputMaybe<IdInput>;
  supplier?: InputMaybe<IdInput>;
};


export type QueryProductTypePricesArgs = {
  cities?: InputMaybe<Array<IdInput>>;
  groups?: InputMaybe<Array<PriceGroupEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  plants?: InputMaybe<Array<IdInput>>;
  productTypes?: InputMaybe<Array<IdInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  suppliers?: InputMaybe<Array<IdInput>>;
};


export type QueryProductTypesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<IdInput>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<IdInput>;
  partner?: InputMaybe<IdInput>;
  plant?: InputMaybe<IdInput>;
  product?: InputMaybe<IdInput>;
  root?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<IdInput>;
  withCombinations?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectsArgs = {
  contractor?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<Array<IdInput>>;
  quoteStatus?: InputMaybe<Array<ProjectQuoteEnum>>;
  scheduledTime?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<ProjectTypeEnum>>;
};


export type QueryQuestionaryArgs = {
  contractor?: InputMaybe<IdInput>;
  order?: InputMaybe<IdInput>;
  orderTruck?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  reason: QuestionaryReasonEnum;
};


export type QueryRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
};


export type QuerySkidTransactionsArgs = {
  contractor?: InputMaybe<IdInput>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skid?: InputMaybe<IdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<SkidTransactionStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QuerySkidsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryStorefrontArgs = {
  address?: InputMaybe<AddressInput>;
  location?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
};


export type QuerySupplierArgs = {
  id: Scalars['ID'];
};


export type QuerySuppliersArgs = {
  city?: InputMaybe<IdInput>;
  ignoreScope?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryTaxableSettingsArgs = {
  contractor?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  project?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTaxesArgs = {
  countryState?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsArgs = {
  contractor?: InputMaybe<IdInput>;
  exported?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<IdInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortDirectionEnum>;
  sources?: InputMaybe<Array<TransactionSourceEnum>>;
  statuses?: InputMaybe<Array<TransactionStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryTruckArgs = {
  id: Scalars['ID'];
};


export type QueryTrucksArgs = {
  city?: InputMaybe<IdInput>;
  countryState?: InputMaybe<IdInput>;
  driver?: InputMaybe<IdInput>;
  limit?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<IdInput>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryWidgetArgs = {
  id: Scalars['ID'];
};


export type QueryWidgetsArgs = {
  designs?: InputMaybe<Array<WidgetDesignEnum>>;
  limit?: InputMaybe<Scalars['Int']>;
  modes?: InputMaybe<Array<WidgetModeEnum>>;
  partners?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<WidgetTypeEnum>>;
};

export type Questionary = {
  __typename?: 'Questionary';
  id: Scalars['ID'];
  lastStep?: Maybe<Scalars['String']>;
  reason: QuestionaryReasonEnum;
  status?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

/** Autogenerated return type of QuestionaryAnswerSave */
export type QuestionaryAnswerSavePayload = {
  __typename?: 'QuestionaryAnswerSavePayload';
  contractor?: Maybe<Contractor>;
  order?: Maybe<Order>;
  orderTruck?: Maybe<OrderTruck>;
  project?: Maybe<Project>;
  success: Scalars['Boolean'];
};

export enum QuestionaryReasonEnum {
  ContractorDetails = 'contractor_details',
  DeliveryControl = 'delivery_control',
  DeliveryDetails = 'delivery_details',
  NewOrder = 'new_order',
  OrderDetails = 'order_details',
  PartnerOnboarding = 'partner_onboarding',
  ProjectDetails = 'project_details',
  Reconciliation = 'reconciliation',
  Signup = 'signup',
  TaskDocument = 'task_document'
}

export type RegionInput = {
  deltaLatitude?: InputMaybe<Scalars['Float']>;
  deltaLongitude?: InputMaybe<Scalars['Float']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  radius?: InputMaybe<Scalars['Float']>;
};

export enum RejectReasonEnum {
  DeliveryTime = 'delivery_time'
}

export type Resource = {
  __typename?: 'Resource';
  /** [DEPRECATED] */
  fileUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimeType?: Maybe<Scalars['String']>;
  /** [DEPRECATED] */
  source?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Input object for files, images e.t.c */
export type ResourceInput = {
  /** base64 file content */
  base64?: InputMaybe<Scalars['String']>;
  /** IO of a new file */
  file?: InputMaybe<Scalars['Upload']>;
  /** remove existing resource */
  remove?: InputMaybe<Scalars['Boolean']>;
  /** url of a new file */
  source?: InputMaybe<Scalars['String']>;
};

export type ResourceTransformInput = {
  rotation?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of ResourceTransform */
export type ResourceTransformPayload = {
  __typename?: 'ResourceTransformPayload';
  document: Resource;
  success: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  partner?: Maybe<Partner>;
  updatedAt: Scalars['String'];
};

export type RoleList = {
  __typename?: 'RoleList';
  count: Scalars['Int'];
  values: Array<Role>;
};

export type Route = {
  __typename?: 'Route';
  distance: Scalars['Float'];
  distanceUnit?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  routes: Array<Scalars['JSON']>;
};

export type ServiceRequestInfoInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  productsManage?: InputMaybe<Scalars['String']>;
  productsSell?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  typeOfIndustry?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ServiceRequestInfo */
export type ServiceRequestInfoPayload = {
  __typename?: 'ServiceRequestInfoPayload';
  success: Scalars['Boolean'];
};

export type Skid = {
  __typename?: 'Skid';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  partner: Partner;
  updatedAt: Scalars['String'];
};

export type SkidContractorListInstance = {
  __typename?: 'SkidContractorListInstance';
  contractor?: Maybe<Contractor>;
  quantity?: Maybe<Scalars['Int']>;
  skid?: Maybe<Skid>;
};

export type SkidList = {
  __typename?: 'SkidList';
  count: Scalars['Int'];
  values: Array<Skid>;
};

export type SkidTransaction = {
  __typename?: 'SkidTransaction';
  availableActions: Array<Scalars['String']>;
  contractor: Contractor;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  order?: Maybe<Order>;
  quantity: Scalars['Int'];
  reason: Scalars['String'];
  skid: Skid;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** Autogenerated return type of SkidTransactionDelete */
export type SkidTransactionDeletePayload = {
  __typename?: 'SkidTransactionDeletePayload';
  success: Scalars['Boolean'];
};

export type SkidTransactionList = {
  __typename?: 'SkidTransactionList';
  count: Scalars['Int'];
  values: Array<SkidTransaction>;
};

export enum SkidTransactionReasonEnum {
  Correction = 'correction',
  Receive = 'receive',
  Return = 'return',
  WriteOff = 'write_off'
}

export enum SkidTransactionStatusEnum {
  InProgress = 'in_progress',
  Success = 'success'
}

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceInfo = {
  __typename?: 'SourceInfo';
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

export type Storefront = {
  __typename?: 'Storefront';
  locations: PlantList;
  productTypes: StorefrontProductTypeList;
};


export type StorefrontLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<RegionInput>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type StorefrontProductTypesArgs = {
  categories?: InputMaybe<Array<IdInput>>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Scalars['JSON']>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mainPage?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  skipCurrentLocation?: InputMaybe<Scalars['Boolean']>;
};

export type StorefrontProductTypeList = {
  __typename?: 'StorefrontProductTypeList';
  availableFilters?: Maybe<Scalars['Json']>;
  count: Scalars['Count'];
  countByGroup: Array<PlantCountByGroup>;
  values: Array<OrderPreparatoryConfigProductTypePrice>;
};

/** The subscription root for the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription';
  allChannelsChanged?: Maybe<ChannelList>;
  channelCreated?: Maybe<Channel>;
  /** A channel message was created */
  channelMessageCreated?: Maybe<ChannelMessage>;
  /** A channel message was deleted */
  channelMessageDeleted?: Maybe<ChannelMessage>;
  /** A channel message was updated */
  channelMessageUpdated?: Maybe<ChannelMessage>;
  channelsChanged?: Maybe<Channel>;
  driverTaskCreated?: Maybe<DriverTask>;
  driverTaskDeleted?: Maybe<DriverTaskDeletedPayload>;
  driverTaskUpdated?: Maybe<DriverTask>;
  orderCreated?: Maybe<Order>;
  orderUpdated?: Maybe<Order>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionAllChannelsChangedArgs = {
  actual?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['Boolean']>;
  contractors?: InputMaybe<Array<IdInput>>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  drivers?: InputMaybe<Array<IdInput>>;
  orders?: InputMaybe<Array<IdInput>>;
  partners?: InputMaybe<Array<IdInput>>;
  projects?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionChannelCreatedArgs = {
  actual?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['Boolean']>;
  contractors?: InputMaybe<Array<IdInput>>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  drivers?: InputMaybe<Array<IdInput>>;
  orders?: InputMaybe<Array<IdInput>>;
  partners?: InputMaybe<Array<IdInput>>;
  projects?: InputMaybe<Array<IdInput>>;
  search?: InputMaybe<Scalars['String']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionChannelMessageCreatedArgs = {
  channel: IdInput;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionChannelMessageDeletedArgs = {
  channel: IdInput;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionChannelMessageUpdatedArgs = {
  channel: IdInput;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionChannelsChangedArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  contractors?: InputMaybe<Array<IdInput>>;
  driverTasks?: InputMaybe<Array<IdInput>>;
  drivers?: InputMaybe<Array<IdInput>>;
  orders?: InputMaybe<Array<IdInput>>;
  partners?: InputMaybe<Array<IdInput>>;
  projects?: InputMaybe<Array<IdInput>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionDriverTaskCreatedArgs = {
  categories?: InputMaybe<Array<IdInput>>;
  cities?: InputMaybe<Array<IdInput>>;
  contractors?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
  from?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Array<IdInput>>;
  plants?: InputMaybe<Array<IdInput>>;
  status?: InputMaybe<Array<DeliveryStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<Array<IdInput>>;
  types?: InputMaybe<Array<DriverTaskTypeEnum>>;
  withDriver?: InputMaybe<Scalars['Boolean']>;
  withTruck?: InputMaybe<Scalars['Boolean']>;
  workingDay?: InputMaybe<IdInput>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionDriverTaskDeletedArgs = {
  categories?: InputMaybe<Array<IdInput>>;
  cities?: InputMaybe<Array<IdInput>>;
  contractors?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
  from?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  orders?: InputMaybe<Array<IdInput>>;
  plants?: InputMaybe<Array<IdInput>>;
  status?: InputMaybe<Array<DeliveryStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<Array<IdInput>>;
  types?: InputMaybe<Array<DriverTaskTypeEnum>>;
  withDriver?: InputMaybe<Scalars['Boolean']>;
  withTruck?: InputMaybe<Scalars['Boolean']>;
  workingDay?: InputMaybe<IdInput>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionDriverTaskUpdatedArgs = {
  categories?: InputMaybe<Array<IdInput>>;
  cities?: InputMaybe<Array<IdInput>>;
  contractors?: InputMaybe<Array<IdInput>>;
  driver?: InputMaybe<Array<IdInput>>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
  from?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  orders?: InputMaybe<Array<IdInput>>;
  plants?: InputMaybe<Array<IdInput>>;
  status?: InputMaybe<Array<DeliveryStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  truck?: InputMaybe<Array<IdInput>>;
  types?: InputMaybe<Array<DriverTaskTypeEnum>>;
  withDriver?: InputMaybe<Scalars['Boolean']>;
  withTruck?: InputMaybe<Scalars['Boolean']>;
  workingDay?: InputMaybe<IdInput>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionOrderCreatedArgs = {
  city?: InputMaybe<Array<IdInput>>;
  contractor?: InputMaybe<IdInput>;
  driver?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Array<OrderPaymentStatusEnum>>;
  payoutStatus?: InputMaybe<FinanceStatusEnum>;
  plant?: InputMaybe<Array<IdInput>>;
  product?: InputMaybe<Array<IdInput>>;
  project?: InputMaybe<Array<IdInput>>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skipPremiumPartners?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  source?: InputMaybe<Array<OrderSourceEnum>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  supplier?: InputMaybe<Array<IdInput>>;
  to?: InputMaybe<Scalars['String']>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
};


/** The subscription root for the GraphQL schema */
export type SubscriptionOrderUpdatedArgs = {
  city?: InputMaybe<Array<IdInput>>;
  contractor?: InputMaybe<IdInput>;
  driver?: InputMaybe<Array<IdInput>>;
  from?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Array<OrderPaymentStatusEnum>>;
  payoutStatus?: InputMaybe<FinanceStatusEnum>;
  plant?: InputMaybe<Array<IdInput>>;
  product?: InputMaybe<Array<IdInput>>;
  project?: InputMaybe<Array<IdInput>>;
  region?: InputMaybe<RegionInput>;
  search?: InputMaybe<Scalars['String']>;
  skipPremiumPartners?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<SortDirectionEnum>;
  source?: InputMaybe<Array<OrderSourceEnum>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  supplier?: InputMaybe<Array<IdInput>>;
  to?: InputMaybe<Scalars['String']>;
  updatedAtFrom?: InputMaybe<Scalars['String']>;
  withTest?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionInstance = {
  __typename?: 'SubscriptionInstance';
  expiresAt?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SuperAdmin = {
  __typename?: 'SuperAdmin';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type Supplier = {
  __typename?: 'Supplier';
  categories: ProductCategoryList;
  id: Scalars['ID'];
  members: SupplierMemberList;
  name: Scalars['String'];
  partners: Array<Partner>;
  plants: PlantList;
  productTypes: ProductTypeList;
  serviceName: Scalars['String'];
};


export type SupplierMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SupplierPlantsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type SupplierCreateInput = {
  name: Scalars['String'];
};

/** Autogenerated return type of SupplierCreate */
export type SupplierCreatePayload = {
  __typename?: 'SupplierCreatePayload';
  success: Scalars['Boolean'];
  supplier?: Maybe<Supplier>;
};

export type SupplierList = {
  __typename?: 'SupplierList';
  count: Scalars['Int'];
  values: Array<Supplier>;
};

export type SupplierMember = {
  __typename?: 'SupplierMember';
  active: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identities: Array<Identity>;
  identity?: Maybe<Identity>;
  name: Scalars['String'];
  role: Scalars['String'];
  supplier: Supplier;
};

export type SupplierMemberCreateInput = {
  member: MemberInput;
  supplier: IdInput;
};

/** Autogenerated return type of SupplierMemberCreate */
export type SupplierMemberCreatePayload = {
  __typename?: 'SupplierMemberCreatePayload';
  member: SupplierMember;
  success: Scalars['Boolean'];
};

export type SupplierMemberList = {
  __typename?: 'SupplierMemberList';
  count: Scalars['Int'];
  values: Array<SupplierMember>;
};

/** Autogenerated return type of SupplierMemberRemove */
export type SupplierMemberRemovePayload = {
  __typename?: 'SupplierMemberRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of SupplierMemberResetPassword */
export type SupplierMemberResetPasswordPayload = {
  __typename?: 'SupplierMemberResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of SupplierMemberUpdate */
export type SupplierMemberUpdatePayload = {
  __typename?: 'SupplierMemberUpdatePayload';
  member: SupplierMember;
  success: Scalars['Boolean'];
};

export type SupplierUpdateInput = {
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productCategories?: InputMaybe<PartnerProductCategoriesInput>;
  productTypes?: InputMaybe<PartnerProductTypesInput>;
};

/** Autogenerated return type of SupplierUpdate */
export type SupplierUpdatePayload = {
  __typename?: 'SupplierUpdatePayload';
  success: Scalars['Boolean'];
  supplier?: Maybe<Supplier>;
};

export type TaxableSettings = {
  __typename?: 'TaxableSettings';
  contractor?: Maybe<Contractor>;
  fee: Fee;
  id: Scalars['ID'];
  project?: Maybe<Project>;
  zeroOut: Scalars['Boolean'];
};

export type TaxableSettingsList = {
  __typename?: 'TaxableSettingsList';
  count: Scalars['Int'];
  taxes: PartnerTaxList;
  values: Array<TaxableSettings>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float'];
  availableActions: Array<Scalars['String']>;
  availableForExport: Scalars['Boolean'];
  captureBeforeAt?: Maybe<Scalars['String']>;
  contractor?: Maybe<Contractor>;
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dispute?: Maybe<Scalars['JSON']>;
  exported?: Maybe<Scalars['Boolean']>;
  history: Array<TransactionHistoryItem>;
  id: Scalars['ID'];
  offlineType?: Maybe<TransactionOfflineTypeEnum>;
  paymentMethod?: Maybe<PaymentMethod>;
  payout?: Maybe<PartnerPayoutInstance>;
  payoutAmount?: Maybe<Scalars['Float']>;
  payoutFee?: Maybe<Scalars['Float']>;
  prettyId: Scalars['String'];
  processingAmount?: Maybe<Scalars['Float']>;
  processingFee?: Maybe<Fee>;
  provider: Scalars['String'];
  reason: TransactionReason;
  referenceNumber?: Maybe<Scalars['String']>;
  riskLevel?: Maybe<Scalars['String']>;
  riskScore?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  statusChangedAt?: Maybe<Scalars['String']>;
  stripeSource?: Maybe<Scalars['JSON']>;
  stripeStatus?: Maybe<Scalars['String']>;
  stripeUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TransactionHistoryItem = {
  __typename?: 'TransactionHistoryItem';
  amount?: Maybe<Scalars['Float']>;
  amountCaptured?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
  captured?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  refunded?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TransactionList = {
  __typename?: 'TransactionList';
  count: Scalars['Int'];
  values: Array<Transaction>;
};

export enum TransactionOfflineTypeEnum {
  Cash = 'cash',
  Cheque = 'cheque',
  Other = 'other',
  Wire = 'wire'
}

export type TransactionReason = {
  __typename?: 'TransactionReason';
  order?: Maybe<Order>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentLink?: Maybe<PaymentLink>;
  type: Scalars['String'];
};

/** Autogenerated return type of TransactionSetExported */
export type TransactionSetExportedPayload = {
  __typename?: 'TransactionSetExportedPayload';
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
  transactions?: Maybe<Array<Transaction>>;
};

export enum TransactionSourceEnum {
  Account = 'account',
  Billd = 'billd',
  CreditMemo = 'credit_memo',
  Eway = 'eway',
  Manual = 'manual',
  Offline = 'offline',
  Stripe = 'stripe',
  StripeB2bCa = 'stripe_b2b_ca',
  StripeB2bUs = 'stripe_b2b_us'
}

export enum TransactionStatusEnum {
  Canceled = 'canceled',
  Disputed = 'disputed',
  Error = 'error',
  InTransit = 'in_transit',
  RequiresCapture = 'requires_capture',
  Success = 'success'
}

export type Truck = {
  __typename?: 'Truck';
  blockOff?: Maybe<Scalars['Boolean']>;
  deviceId?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
  id: Scalars['ID'];
  location?: Maybe<Location>;
  locationUpdatedAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Note>;
  notes?: Maybe<NoteList>;
  plants: Array<Plant>;
  productCategories?: Maybe<Array<ProductCategory>>;
  role?: Maybe<Scalars['String']>;
  timeSinceLocationUpdated?: Maybe<Scalars['Int']>;
  trackingSystem: Scalars['String'];
  trackingSystemId?: Maybe<Scalars['String']>;
  truckBlockOffs?: Maybe<Array<TruckBlockOff>>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};


export type TruckBlockOffArgs = {
  date: Scalars['String'];
};


export type TruckNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckAccept */
export type TruckAcceptPayload = {
  __typename?: 'TruckAcceptPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckArrive */
export type TruckArrivePayload = {
  __typename?: 'TruckArrivePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

export type TruckBlockOff = {
  __typename?: 'TruckBlockOff';
  active: Scalars['Boolean'];
  category?: Maybe<TruckBlockOffEnum>;
  from: Scalars['Int'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['Int']>;
  truck: Truck;
};

/** Autogenerated return type of TruckBlockOffCreate */
export type TruckBlockOffCreatePayload = {
  __typename?: 'TruckBlockOffCreatePayload';
  success: Scalars['Boolean'];
  truckBlockOff?: Maybe<TruckBlockOff>;
};

/** Autogenerated return type of TruckBlockOffDelete */
export type TruckBlockOffDeletePayload = {
  __typename?: 'TruckBlockOffDeletePayload';
  success: Scalars['Boolean'];
};

export enum TruckBlockOffEnum {
  Broken = 'broken'
}

/** Autogenerated return type of TruckBlockOffUpdate */
export type TruckBlockOffUpdatePayload = {
  __typename?: 'TruckBlockOffUpdatePayload';
  success: Scalars['Boolean'];
  truckBlockOff: TruckBlockOff;
};

/** Autogenerated return type of TruckCancel */
export type TruckCancelPayload = {
  __typename?: 'TruckCancelPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckComplete */
export type TruckCompletePayload = {
  __typename?: 'TruckCompletePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

export type TruckCreateInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  name: Scalars['String'];
  plant?: InputMaybe<IdInput>;
  productCategories?: InputMaybe<Array<IdInput>>;
  role?: InputMaybe<Scalars['String']>;
  trackingSystem?: InputMaybe<Scalars['String']>;
  trackingSystemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TruckCreate */
export type TruckCreatePayload = {
  __typename?: 'TruckCreatePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<Truck>;
};

export type TruckList = {
  __typename?: 'TruckList';
  count: Scalars['Int'];
  values: Array<Truck>;
};

/** Autogenerated return type of TruckNoteUpdate */
export type TruckNoteUpdatePayload = {
  __typename?: 'TruckNoteUpdatePayload';
  note?: Maybe<Note>;
  success: Scalars['Boolean'];
};

export type TruckRemoveInput = {
  truck: IdInput;
};

/** Autogenerated return type of TruckRemove */
export type TruckRemovePayload = {
  __typename?: 'TruckRemovePayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TruckReturn */
export type TruckReturnPayload = {
  __typename?: 'TruckReturnPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

/** Autogenerated return type of TruckRevert */
export type TruckRevertPayload = {
  __typename?: 'TruckRevertPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

/** Autogenerated return type of TruckStart */
export type TruckStartPayload = {
  __typename?: 'TruckStartPayload';
  success: Scalars['Boolean'];
  truck?: Maybe<OrderTruck>;
};

export type TruckUpdateInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<IdInput>;
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<IdInput>;
  productCategories?: InputMaybe<Array<IdInput>>;
  removeDriver?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  trackingSystem?: InputMaybe<Scalars['String']>;
  trackingSystemId?: InputMaybe<Scalars['String']>;
  truck: IdInput;
  type?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TruckUpdate */
export type TruckUpdatePayload = {
  __typename?: 'TruckUpdatePayload';
  success: Scalars['Boolean'];
  truck?: Maybe<Truck>;
};

export type TrucksConfig = {
  __typename?: 'TrucksConfig';
  balanceTruck?: Maybe<Scalars['Float']>;
  count: TrucksConfigCountType;
  deliveryMethod: DeliveryMethod;
  order: TrucksConfigOrderType;
  quantity: TrucksConfigQuantityType;
  secondaryQuantity?: Maybe<TrucksConfigSecondaryQuantityType>;
};

export type TrucksConfigCountType = {
  __typename?: 'TrucksConfigCountType';
  max: Scalars['Int'];
};

export type TrucksConfigOrderType = {
  __typename?: 'TrucksConfigOrderType';
  minAmount?: Maybe<Scalars['Float']>;
  minQuantity?: Maybe<Scalars['Float']>;
};

export type TrucksConfigQuantityType = {
  __typename?: 'TrucksConfigQuantityType';
  max: Scalars['Float'];
  min: Scalars['Float'];
  step: Scalars['Step'];
};

export type TrucksConfigSecondaryQuantityType = {
  __typename?: 'TrucksConfigSecondaryQuantityType';
  max: Scalars['Float'];
  min: Scalars['Float'];
  step: Scalars['Step'];
};

export type Unit = {
  __typename?: 'Unit';
  code: Scalars['String'];
  name: Scalars['String'];
  plural: Array<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  driver?: Maybe<Driver>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UserClientStoreSet */
export type UserClientStoreSetPayload = {
  __typename?: 'UserClientStoreSetPayload';
  data: Scalars['JSON'];
  success: Scalars['Boolean'];
};

export type WidgetCreateInput = {
  align?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  design?: InputMaybe<WidgetDesignEnum>;
  image?: InputMaybe<Scalars['Boolean']>;
  imageBackground?: InputMaybe<Scalars['Boolean']>;
  imageSize?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['Upload']>;
  mode?: InputMaybe<WidgetModeEnum>;
  partner?: InputMaybe<IdInput>;
  shift?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  titleColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WidgetTypeEnum>;
  usePartnerLogo?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of WidgetCreate */
export type WidgetCreatePayload = {
  __typename?: 'WidgetCreatePayload';
  success: Scalars['Boolean'];
  widget: WidgetInstance;
};

/** Autogenerated return type of WidgetDelete */
export type WidgetDeletePayload = {
  __typename?: 'WidgetDeletePayload';
  success: Scalars['Boolean'];
};

export enum WidgetDesignEnum {
  Connect = 'connect',
  Regular = 'regular',
  Saving = 'saving',
  Shop = 'shop',
  ShopFullscreen = 'shop_fullscreen'
}

export type WidgetInstance = {
  __typename?: 'WidgetInstance';
  align?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  design: Scalars['String'];
  embedCode: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['Boolean']>;
  imageBackground?: Maybe<Scalars['Boolean']>;
  imageSize?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  mode: Scalars['String'];
  partner: Partner;
  shift?: Maybe<Scalars['Int']>;
  statistics: WidgetStatistics;
  title?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  usePartnerLogo?: Maybe<Scalars['Boolean']>;
};

export type WidgetList = {
  __typename?: 'WidgetList';
  count: Scalars['Int'];
  values: Array<WidgetInstance>;
};

export enum WidgetModeEnum {
  Main = 'main',
  Signup = 'signup',
  Suppliers = 'suppliers'
}

export type WidgetStatistics = {
  __typename?: 'WidgetStatistics';
  clicks: Scalars['Int'];
  earned: Scalars['Float'];
  loads: Scalars['Int'];
  orders: Scalars['Int'];
  signups: Scalars['Int'];
};

export enum WidgetTypeEnum {
  Inline = 'inline',
  Popup = 'popup',
  Regular = 'regular'
}

export type WidgetUpdateInput = {
  align?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  design?: InputMaybe<WidgetDesignEnum>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Boolean']>;
  imageBackground?: InputMaybe<Scalars['Boolean']>;
  imageSize?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['Upload']>;
  mode?: InputMaybe<WidgetModeEnum>;
  partner?: InputMaybe<IdInput>;
  shift?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  titleColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WidgetTypeEnum>;
  usePartnerLogo?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of WidgetUpdate */
export type WidgetUpdatePayload = {
  __typename?: 'WidgetUpdatePayload';
  success: Scalars['Boolean'];
  widget: WidgetInstance;
};

/** Autogenerated return type of WorkingDayUpdate */
export type WorkingDayUpdatePayload = {
  __typename?: 'WorkingDayUpdatePayload';
  success: Scalars['Boolean'];
  workingDay: DriverWorkingDay;
};

export type _QueryMeta = {
  __typename?: '_QueryMeta';
  count: Scalars['Int'];
};
